var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a3, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a3, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a3, prop, b2[prop]);
    }
  return a3;
};
var __spreadProps = (a3, b2) => __defProps(a3, __getOwnPropDescs(b2));

// src/buildWidgetProps.ts
var parseWidgetAttributes = (widget, widgetAttributes, configWidgetAttributes, getPropValue2) => {
  const attributes = widgetAttributes.all.reduce((acc, prop) => {
    const propName = widgetAttributes.mapped[prop];
    const configPropValue = configWidgetAttributes == null ? void 0 : configWidgetAttributes[prop];
    const propValue = getPropValue2(widget, prop, configPropValue);
    return __spreadProps(__spreadValues({}, acc), { [propName]: propValue });
  }, {});
  return attributes;
};
function buildWidgetProps(widget, widgetAttributes, configWidgetAttributes, getPropValue2) {
  const parsedAttributes = parseWidgetAttributes(widget, widgetAttributes, configWidgetAttributes, getPropValue2);
  let shadow = widget && widget.shadowRoot;
  try {
    if (widget.shadowRoot === null) {
      shadow = widget && widget.attachShadow({ mode: "open" });
    }
  } catch (error) {
    console.error(error);
  }
  return {
    shadow,
    element: widget,
    config: parsedAttributes
  };
}

// src/link-creation/constants/link-creation.constants.ts
var PLACEHOLDER_ID = {
  team: "{teamId}",
  player: "{playerId}",
  venue: "{venueId}",
  coach: "{coachId}",
  referee: "{refereeId}",
  standingsTournament: "{standingsId}",
  match: "{matchId}",
  standingsStage: "{standingsId}",
  tournament: "{tournamentId}",
  competition: "{competitionId}",
  standings: "{competitionId}",
  arena: "{arenaId}",
  season: "{seasonId}",
  stage: "{stageId}",
  game: "{gameId}",
  slug: "{slug}"
};
var ENTITY_TYPES = {
  team: "team",
  player: "player",
  venue: "venue",
  coach: "coach",
  referee: "referee",
  standingsTournament: "standings_tournament",
  match: "match",
  tournament: "tournament",
  standingsStage: "standings_stage",
  competition: "competition",
  standings: "standings",
  arena: "arena",
  season: "season",
  stage: "stage",
  game: "game"
};
var EVENT_URL_SORT_CRITERIA = {
  alphabetically: "alphabetically",
  homeAway: "home-away",
  awayHome: "away-home",
  homeOnly: "home-only",
  awayOnly: "away-only",
  eventOnly: "event-only"
};
var EVENT_URL_SORT_DIRECTION = {
  asc: "asc",
  desc: "desc"
};
var listOfAvailableEntities = [
  ENTITY_TYPES.team,
  ENTITY_TYPES.player,
  ENTITY_TYPES.venue,
  ENTITY_TYPES.coach,
  ENTITY_TYPES.referee,
  ENTITY_TYPES.standingsTournament,
  ENTITY_TYPES.match,
  ENTITY_TYPES.tournament,
  ENTITY_TYPES.standingsStage,
  ENTITY_TYPES.arena,
  ENTITY_TYPES.standings,
  ENTITY_TYPES.competition,
  ENTITY_TYPES.season,
  ENTITY_TYPES.stage,
  ENTITY_TYPES.game
];
var SLUG_ENTITY;
(function(SLUG_ENTITY2) {
  SLUG_ENTITY2["SLUG"] = "slug";
})(SLUG_ENTITY || (SLUG_ENTITY = {}));

// src/link-creation/service/link-options.default.ts
var LinkOptionsDefault = class {
  constructor() {
    this.applyDefaultValues = (linkOptions) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      const linkOptionsCopy = Object.assign({}, linkOptions);
      linkOptionsCopy.player = this.applyDefaultValue(linkOptionsCopy.player, (_a = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _a.player);
      linkOptionsCopy.team = this.applyDefaultValue(linkOptionsCopy.team, (_b = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _b.team);
      linkOptionsCopy.coach = this.applyDefaultValue(linkOptionsCopy.coach, (_c = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _c.coach);
      linkOptionsCopy.venue = this.applyDefaultValue(linkOptionsCopy.venue, (_d = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _d.venue);
      linkOptionsCopy.referee = this.applyDefaultValue(linkOptionsCopy.referee, (_e = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _e.referee);
      linkOptionsCopy.tournament = this.applyDefaultValue(linkOptionsCopy.tournament, (_f = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _f.tournament);
      linkOptionsCopy.standingsStage = this.applyDefaultValue(linkOptionsCopy.standings_stage, (_g = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _g.standings_stage);
      linkOptionsCopy.standingsTournament = this.applyDefaultValue(linkOptionsCopy.standingsTournament, (_h = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _h.standingsTournament);
      linkOptionsCopy.match = this.applyEventDefaultValue(linkOptionsCopy.match, (_i = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _i.match);
      linkOptionsCopy.game = this.applyEventDefaultValue(linkOptionsCopy.game, (_j = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _j.game);
      linkOptionsCopy.competition = this.applyDefaultValue(linkOptionsCopy.competition, (_k = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _k.competition);
      linkOptionsCopy.standings = this.applyDefaultValue(linkOptionsCopy.standings, (_l = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _l.standings);
      linkOptionsCopy.arena = this.applyDefaultValue(linkOptionsCopy.arena, (_m = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _m.arena);
      linkOptionsCopy.season = this.applyDefaultValue(linkOptionsCopy.season, (_n = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _n.season);
      linkOptionsCopy.stage = this.applyDefaultValue(linkOptionsCopy.stage, (_o = linkOptionsCopy == null ? void 0 : linkOptionsCopy.slug) == null ? void 0 : _o.stage);
      linkOptionsCopy.configuration = this.applyConfigurationDefaultValue(linkOptionsCopy.configuration);
      return linkOptionsCopy;
    };
    this.applyDefaultValue = (link, slug) => {
      const linkDefault = { url: null, urlSlug: null };
      const linkCopy = Object.assign({}, link);
      if (slug && slug.length > 0 && slug !== null)
        return __spreadProps(__spreadValues({}, linkCopy), { urlSlug: slug });
      if (linkCopy && linkCopy.url && linkCopy.url.length > 0)
        return __spreadProps(__spreadValues({}, linkCopy), { urlSlug: null });
      return linkDefault;
    };
    this.applyEventDefaultValue = (event, slug) => {
      const eventDefault = { url: null, sort: { criteria: null, direction: null } };
      const eventCopy = Object.assign({}, event);
      if (eventCopy) {
        eventCopy.url = this.applyDefaultValue(eventCopy, slug).url;
        eventCopy.urlSlug = this.applyDefaultValue(eventCopy, slug).urlSlug;
        if (eventCopy.sort) {
          eventCopy.sort.criteria = eventCopy.sort.criteria ? eventCopy.sort.criteria : null;
          if (eventCopy.sort.criteria === EVENT_URL_SORT_CRITERIA.alphabetically) {
            eventCopy.sort.direction = eventCopy.sort.direction ? eventCopy.sort.direction : "asc";
          } else {
            eventCopy.sort.direction = null;
          }
        } else {
          eventCopy.sort = { criteria: null, direction: null };
        }
        return eventCopy;
      }
      return eventDefault;
    };
    this.applyConfigurationDefaultValue = (configuration) => {
      const configurationDefault = { newWindow: true };
      const configurationCopy = Object.assign({}, configuration);
      if (configuration && (configuration == null ? void 0 : configuration.newWindow) && (configuration == null ? void 0 : configuration.newWindow) !== null)
        return configurationCopy;
      return configurationDefault;
    };
  }
};

// src/link-creation/service/link-creation.service.ts
var LinkCreationService = class {
  constructor(linkOptions) {
    this.linkOptions = {};
    this.linkOptionsVersion = "";
    this.createEntityUrl = (entityId, entityType, type, slug) => {
      const linkOption = this.linkOptions[entityType];
      let url = null;
      let urlSlug = null;
      if (linkOption) {
        url = linkOption.url;
        urlSlug = linkOption.urlSlug;
      } else {
        return null;
      }
      if ((url === null || url === void 0) && (urlSlug === null || urlSlug === void 0) || entityType === ENTITY_TYPES.team && type === "placeholder") {
        return null;
      }
      if (listOfAvailableEntities.includes(entityType)) {
        if (slug && slug !== null && slug.length > 0 && urlSlug && urlSlug !== null)
          return urlSlug.replace(PLACEHOLDER_ID[SLUG_ENTITY.SLUG], slug);
        return url.replace(PLACEHOLDER_ID[entityType], entityId);
      }
      console.warn(`This function "createEntityUrl" is available only for the following entities: ${listOfAvailableEntities.join(", ")}`);
      return null;
    };
    this.createMatchUrl = (matchId, homeTeam, awayTeam, slug) => {
      var _a, _b;
      if (((_a = this.linkOptions.match) == null ? void 0 : _a.url) || ((_b = this.linkOptions.match) == null ? void 0 : _b.urlSlug)) {
        return this.applyProperlyTeamForEventUrl(matchId, homeTeam, awayTeam, this.linkOptions.match.sort, this.linkOptions.match.url, PLACEHOLDER_ID.match, slug, this.linkOptions.match.urlSlug);
      }
      return null;
    };
    this.createGameUrl = (gameId, homeTeam, awayTeam, slug) => {
      var _a;
      if ((_a = this.linkOptions.game) == null ? void 0 : _a.url) {
        return this.applyProperlyTeamForEventUrl(gameId, homeTeam, awayTeam, this.linkOptions.game.sort, this.linkOptions.game.url, PLACEHOLDER_ID.game, slug, this.linkOptions.game.urlSlug);
      }
      return null;
    };
    this.applyProperlyTeamForEventUrl = (eventId, homeTeam, awayTeam, sort, url, placeholder, slug, urlSlug) => {
      let eventUrl = url;
      if (urlSlug && urlSlug !== null) {
        if (!slug) {
          return null;
        }
        eventUrl = urlSlug;
        eventUrl = eventUrl.replace(PLACEHOLDER_ID.slug, `${slug}`);
        return eventUrl;
      }
      switch (sort.criteria) {
        case EVENT_URL_SORT_CRITERIA.alphabetically: {
          const teams = this.applyAlphabeticSortDirection(homeTeam, awayTeam, sort);
          return this.eventUrl(eventId, teams[0], teams[1], eventUrl, placeholder);
        }
        case EVENT_URL_SORT_CRITERIA.awayHome: {
          return this.eventUrl(eventId, awayTeam, homeTeam, eventUrl, placeholder);
        }
        case EVENT_URL_SORT_CRITERIA.homeAway: {
          return this.eventUrl(eventId, homeTeam, awayTeam, eventUrl, placeholder);
        }
        case EVENT_URL_SORT_CRITERIA.awayOnly: {
          return this.eventUrlSingleTeam(eventId, awayTeam, eventUrl, placeholder);
        }
        case EVENT_URL_SORT_CRITERIA.homeOnly: {
          return this.eventUrlSingleTeam(eventId, homeTeam, eventUrl, placeholder);
        }
        case EVENT_URL_SORT_CRITERIA.eventOnly: {
          return this.eventOnlyUrl(eventId, eventUrl, placeholder);
        }
        default: {
          return null;
        }
      }
    };
    this.eventUrl = (eventId, firstTeam, secondTeam, url, placeholderId) => {
      url = url.replace(placeholderId, `${eventId}`);
      url = url.replace(PLACEHOLDER_ID.team, `${firstTeam.legacyId || firstTeam.id}`);
      url = url.replace(PLACEHOLDER_ID.team, `${secondTeam.legacyId || secondTeam.id}`);
      return url;
    };
    this.eventUrlSingleTeam = (eventId, team, url, placeholderId) => {
      url = url.replace(placeholderId, `${eventId}`);
      url = url.replace(PLACEHOLDER_ID.team, `${team.id}`);
      return url;
    };
    this.eventOnlyUrl = (eventId, url, event) => {
      url = url.replace(event, `${eventId}`);
      return url;
    };
    this.applyAlphabeticSortDirection = (homeTeam, awayTeam, sort) => {
      let teams = [homeTeam, awayTeam];
      if (sort.direction === EVENT_URL_SORT_DIRECTION.asc || sort.direction === EVENT_URL_SORT_DIRECTION.desc) {
        teams = teams.sort((team1, team2) => {
          if (team1.name < team2.name)
            return -1;
          if (team1.name > team2.name)
            return 1;
          return 0;
        });
        return sort.direction === EVENT_URL_SORT_DIRECTION.asc ? teams : teams.reverse();
      }
      return teams;
    };
    const defaultOptionsService = new LinkOptionsDefault();
    this.linkOptions = defaultOptionsService.applyDefaultValues(linkOptions);
  }
};

// ../constants/sportType.ts
var Sports;
(function(Sports2) {
  Sports2["FOOTBALL"] = "football";
  Sports2["BASKETBALL"] = "basketball";
  Sports2["TENNIS"] = "tennis";
  Sports2["MULTISPORT"] = "multisport";
  Sports2["ICE_HOCKEY"] = "ice-hockey";
})(Sports || (Sports = {}));
var FootballStandingsElements;
(function(FootballStandingsElements2) {
  FootballStandingsElements2["MATCHES_PLAYED"] = "matches_played";
  FootballStandingsElements2["MATCHES_WON"] = "matches_won";
  FootballStandingsElements2["MATCH_LOSSES"] = "match_losses";
  FootballStandingsElements2["MATCH_DRAW"] = "match_draw";
  FootballStandingsElements2["GOAL_DIFFERENCE"] = "goal_difference";
  FootballStandingsElements2["POINTS"] = "points";
  FootballStandingsElements2["TEAM_FORM"] = "team_form";
})(FootballStandingsElements || (FootballStandingsElements = {}));
var TableVariants;
(function(TableVariants2) {
  TableVariants2["STATS"] = "stats_table";
  TableVariants2["STANDINGS"] = "standings";
  TableVariants2["DEFAULT"] = "default";
})(TableVariants || (TableVariants = {}));

// ../constants/widgetAttributes.ts
var WidgetAttributes;
(function(WidgetAttributes2) {
  WidgetAttributes2["WIDGET_SPORT"] = "data-widget-sport";
  WidgetAttributes2["WIDGET_TYPE"] = "data-widget-type";
  WidgetAttributes2["WIDGET_ID"] = "data-widget-id";
  WidgetAttributes2["DATE"] = "data-date";
  WidgetAttributes2["NAME_TYPE"] = "data-team-name-type";
  WidgetAttributes2["REFRESH_TIME"] = "data-refresh-time";
  WidgetAttributes2["ENTITY_LINKS"] = "data-entity-links";
  WidgetAttributes2["THEME"] = "data-theme";
  WidgetAttributes2["POPULAR_LIST"] = "data-popular-list";
  WidgetAttributes2["LABELS"] = "data-labels";
  WidgetAttributes2["DROPDOWN_DISPLAY"] = "data-dropdown-display";
  WidgetAttributes2["HEADER_DEFAULT_OPTION"] = "data-header-default-option";
  WidgetAttributes2["HEADER_DISPLAY"] = "data-header-display";
  WidgetAttributes2["ODDS_BETTING_ID"] = "data-odds-betting-id";
  WidgetAttributes2["ODDS_DISPLAY"] = "data-odds-display";
  WidgetAttributes2["ODDS_MARKET"] = "data-odds-market";
  WidgetAttributes2["ODDS_PRE_EVENT_ONLY"] = "data-odds-pre-event-only";
  WidgetAttributes2["ODDS_MARKET_VALUE_TYPE"] = "data-odds-market-value-type";
  WidgetAttributes2["OPTIONS_DISPLAY"] = "data-options-display";
  WidgetAttributes2["ODDS_TAB_BETTING_ID"] = "data-odds-tab-betting-id";
  WidgetAttributes2["AGE_RESTRICTION_DISPLAY"] = "data-age-restriction-display";
  WidgetAttributes2["MATCH"] = "data-match-id";
  WidgetAttributes2["SHORT_STATUS_TYPE"] = "data-short-status-type";
  WidgetAttributes2["COMPETITION"] = "data-competition";
  WidgetAttributes2["STAGE"] = "data-stage";
  WidgetAttributes2["SEASON"] = "data-season";
  WidgetAttributes2["PLAYER"] = "data-player";
  WidgetAttributes2["TEAM"] = "data-team";
  WidgetAttributes2["TABS"] = "data-tabs";
  WidgetAttributes2["DISPLAY_TABS"] = "data-display-tabs";
  WidgetAttributes2["DEFAULT_TAB"] = "data-default-tab";
  WidgetAttributes2["ROUND"] = "data-round";
  WidgetAttributes2["ROUNDS"] = "data-rounds";
  WidgetAttributes2["ROUNDS_FILTER"] = "data-rounds-filter";
  WidgetAttributes2["MATCH_TYPE"] = "data-match-type";
  WidgetAttributes2["SORT_DIRECTION"] = "data-sort-direction";
  WidgetAttributes2["SORT_DIRECTION_RESULTS"] = "data-sort-direction-results";
  WidgetAttributes2["SORT_DIRECTION_FIXTURES"] = "data-sort-direction-fixtures";
  WidgetAttributes2["FANS_UNITED_API_KEY"] = "fans-united-api-key";
  WidgetAttributes2["FANS_UNITED_CLIENT_ID"] = "fans-united-client-id";
  WidgetAttributes2["FANS_UNITED_EXPANDED"] = "fans-united-expanded";
  WidgetAttributes2["FANS_UNITED_TOKEN"] = "fans-united-token";
  WidgetAttributes2["FANS_UNITED_ID_SCHEMA"] = "fans-united-id-schema";
  WidgetAttributes2["FANS_UNITED_ENABLED"] = "fans-united-enabled";
  WidgetAttributes2["FANS_UNITED_ENVIRONMENT"] = "fans-united-environment";
  WidgetAttributes2["FANS_UNITED_HIDE_BEFORE_GAME_START"] = "fans-united-hide-before-game-start";
  WidgetAttributes2["FANS_UNITED_SHOW_FROM"] = "fans-united-show-from";
  WidgetAttributes2["GROUPS"] = "data-groups";
  WidgetAttributes2["DISPLAY_STATISTICS"] = "data-display-statistics";
  WidgetAttributes2["LIMIT"] = "data-limit";
  WidgetAttributes2["DATA_TEAM_IDS"] = "data-team-ids";
  WidgetAttributes2["DATA_LIMIT"] = "data-limit";
  WidgetAttributes2["DATA_START_POSITION"] = "data-start-position";
  WidgetAttributes2["DATA_HIGHLIGHT_ENTITIES"] = "data-highlight-entities";
  WidgetAttributes2["SPORT_ENTITY_ONE"] = "data-sport-entity-one";
  WidgetAttributes2["SPORT_ENTITY_TWO"] = "data-sport-entity-two";
  WidgetAttributes2["ELEMENTS"] = "data-elements";
  WidgetAttributes2["ELEMENTS_MOBILE"] = "data-elements-mobile";
  WidgetAttributes2["ELEMENTS_DESKTOP"] = "data-elements-desktop";
  WidgetAttributes2["TEAM_TYPE"] = "data-team-type";
  WidgetAttributes2["DATA_OFFSET"] = "data-offset";
  WidgetAttributes2["DATA_STANDING_TYPE_SUBCATEGORY"] = "data-standing-type-subcategory";
  WidgetAttributes2["TOURNAMENT"] = "data-tournament";
  WidgetAttributes2["HOME_TEAM_COLOR"] = "data-home-team-color";
  WidgetAttributes2["AWAY_TEAM_COLOR"] = "data-away-team-color";
  WidgetAttributes2["ALLOW_INLINE_ODDS"] = "data-allow-inline-odds";
  WidgetAttributes2["ADDITIONAL_INFO"] = "data-additional-info";
  WidgetAttributes2["IMAGE_DISPLAY"] = "data-image-display";
  WidgetAttributes2["AMOUNT"] = "data-amount";
  WidgetAttributes2["WRAPPER_LINK"] = "data-wrapper-link";
  WidgetAttributes2["GAME_TYPE"] = "data-game-type";
  WidgetAttributes2["GENDER"] = "data-gender";
  WidgetAttributes2["FIXED"] = "data-fixed";
  WidgetAttributes2["DATA_DATE_FROM"] = "data-date-from";
  WidgetAttributes2["DATA_DATE_TO"] = "data-date-to";
  WidgetAttributes2["BETTING_BRAND_COLORS"] = "data-betting-brand-colors";
  WidgetAttributes2["BETTING_LOGO_CLICK_ACTION"] = "data-betting-logo-click-action";
  WidgetAttributes2["BETTING_LOGO_OVERLAP"] = "data-betting-logo-overlap";
  WidgetAttributes2["BETTING_LOGO_DISPLAY"] = "data-betting-logo-display";
  WidgetAttributes2["DATA_ODDS_CLICKABLE"] = "data-odds-clickable";
  WidgetAttributes2["DATA_SHOW_COMPETITION_NAMES"] = "data-show-competition-names";
  WidgetAttributes2["NAME_FORMAT"] = "data-name-format";
  WidgetAttributes2["COMPETITIONS"] = "data-competitions";
  WidgetAttributes2["SPORT"] = "data-sport";
  WidgetAttributes2["DATA_MATCH_DISPLAY"] = "data-match-display";
  WidgetAttributes2["DATA_STATISTICS_DISPLAY"] = "data-statistics-display";
  WidgetAttributes2["CURRENCY_POSITION"] = "data-currency-symbol-position";
  WidgetAttributes2["SINGLE_EVENT_MAIN_EVENTS_DISPLAY"] = "data-single-event-main-events-display";
  WidgetAttributes2["MATCH_CENTER_EVENT_MAIN_EVENTS_DISPLAY"] = "data-match-center-main-events-display";
  WidgetAttributes2["DATE_FORMAT"] = "data-date-format";
  WidgetAttributes2["DATA_DISPLAY_SOCIAL_ICONS"] = "data-display-social-icons";
  WidgetAttributes2["DATA_DISPLAY_TEAM_IMAGE"] = "data-display-team-image";
  WidgetAttributes2["DATA_COUNTRY_ID"] = "data-country-id";
})(WidgetAttributes || (WidgetAttributes = {}));
var widgetAttributes_default = WidgetAttributes;

// src/validateRequiredWidgetAttributes.ts
function validateRequiredWidgetAttributes_default(widget, widgetAttributes) {
  const invalidAttributes = widgetAttributes.required.map((attribute) => {
    const attributeValue = widget.getAttribute(attribute);
    if (!attributeValue) {
      console.warn(`The ${attribute} property is required`);
      return attribute;
    }
    if (attribute === widgetAttributes_default.WIDGET_SPORT) {
      const allSports = [Sports.FOOTBALL, Sports.BASKETBALL, Sports.TENNIS, Sports.MULTISPORT, Sports.ICE_HOCKEY];
      if (!allSports.includes(attributeValue)) {
        console.warn(`The value of the ${attribute} property is incorrect. Allowed values are: ${allSports.join(", ")}`);
        return attribute;
      }
    } else if (attribute === widgetAttributes_default.WIDGET_TYPE) {
      const allTypes = ["tournament", "team", "player", "event", "h2h", "multisport"];
      if (!allTypes.includes(attributeValue)) {
        console.warn(`The value of the ${attribute} property is incorrect. Allowed values are: ${allTypes.join(", ")}`);
        return attribute;
      }
    }
  });
  return invalidAttributes.filter(Boolean);
}

// ../types/common.ts
var WidgetTypes;
(function(WidgetTypes2) {
  WidgetTypes2["TOURNAMENT"] = "tournament";
  WidgetTypes2["TEAM"] = "team";
  WidgetTypes2["PLAYER"] = "player";
  WidgetTypes2["EVENT"] = "event";
  WidgetTypes2["H2H"] = "h2h";
  WidgetTypes2["MULTISPORT"] = "multisport";
})(WidgetTypes || (WidgetTypes = {}));
var THEME_VARIANTS;
(function(THEME_VARIANTS2) {
  THEME_VARIANTS2["LIGHT"] = "light";
  THEME_VARIANTS2["DARK"] = "dark";
  THEME_VARIANTS2["CLIENT"] = "client";
})(THEME_VARIANTS || (THEME_VARIANTS = {}));
var LineupStatuses;
(function(LineupStatuses2) {
  LineupStatuses2["NOT_AVAILABLE"] = "NOT_AVAILABLE";
  LineupStatuses2["UNCONFIRMED"] = "UNCONFIRMED";
  LineupStatuses2["CONFIRMED"] = "CONFIRMED";
})(LineupStatuses || (LineupStatuses = {}));
var IMostDecoratedDataLabelsKeys;
(function(IMostDecoratedDataLabelsKeys2) {
  IMostDecoratedDataLabelsKeys2["FIRST_YELLOW_CARDS"] = "first_yellow_cards";
  IMostDecoratedDataLabelsKeys2["RED_CARDS"] = "red_cards";
  IMostDecoratedDataLabelsKeys2["TOTAL_CARDS"] = "total_cards";
  IMostDecoratedDataLabelsKeys2["YELLOW_CARDS"] = "yellow_cards";
})(IMostDecoratedDataLabelsKeys || (IMostDecoratedDataLabelsKeys = {}));
var ITopScorersDataLabelsKeys;
(function(ITopScorersDataLabelsKeys2) {
  ITopScorersDataLabelsKeys2["ASSISTS"] = "assists";
  ITopScorersDataLabelsKeys2["GOALS"] = "goals";
  ITopScorersDataLabelsKeys2["MINUTES"] = "minutes";
  ITopScorersDataLabelsKeys2["PENALTIES"] = "penalties";
  ITopScorersDataLabelsKeys2["PLAYED"] = "played";
  ITopScorersDataLabelsKeys2["RED_CARDS"] = "red_cards";
  ITopScorersDataLabelsKeys2["SCORED_FIRST"] = "scored_first";
  ITopScorersDataLabelsKeys2["YELLOW_CARDS"] = "yellow_cards";
  ITopScorersDataLabelsKeys2["MISSED_PENALTIES"] = "missed_penalties";
})(ITopScorersDataLabelsKeys || (ITopScorersDataLabelsKeys = {}));
var Movement;
(function(Movement2) {
  Movement2["UP"] = "UP";
  Movement2["DOWN"] = "DOWN";
  Movement2["NONE"] = "NONE";
})(Movement || (Movement = {}));
var OddsMarketTypes;
(function(OddsMarketTypes2) {
  OddsMarketTypes2["ONETWO"] = "12";
  OddsMarketTypes2["ONEXTWO"] = "1x2";
  OddsMarketTypes2["OVER_UNDER"] = "OVER_UNDER";
  OddsMarketTypes2["DOUBLE_CHANCE"] = "DOUBLE_CHANCE";
  OddsMarketTypes2["BOTH_TO_SCORE"] = "BOTH_TO_SCORE";
  OddsMarketTypes2["DRAW_NO_BET"] = "DRAW_NO_BET";
  OddsMarketTypes2["FIRST_TEAM_TO_SCORE"] = "FIRST_TEAM_TO_SCORE";
  OddsMarketTypes2["GAME_HANDICAP"] = "GAME_HANDICAP";
  OddsMarketTypes2["FIRST_HALF"] = "FIRST_HALF";
  OddsMarketTypes2["SECOND_HALF"] = "SECOND_HALF";
  OddsMarketTypes2["FULL_TIME"] = "FULL_TIME";
  OddsMarketTypes2["FIRST_HALF_GOALS"] = "FIRST_HALF_GOALS";
  OddsMarketTypes2["CORRECT_SCORE"] = "CORRECT_SCORE";
  OddsMarketTypes2["FIRST_PLAYER_TO_SCORE"] = "FIRST_PLAYER_TO_SCORE";
  OddsMarketTypes2["PLAYER_TO_SCORE_DURING_GAME"] = "PLAYER_TO_SCORE_DURING_GAME";
  OddsMarketTypes2["PLAYER_TO_RECEIVE_CARD"] = "PLAYER_TO_RECEIVE_CARD";
  OddsMarketTypes2["FIRST_HALF_AND_FINAL_RESULT"] = "FIRST_HALF_AND_FINAL_RESULT";
})(OddsMarketTypes || (OddsMarketTypes = {}));
var OddFormat;
(function(OddFormat2) {
  OddFormat2["FRACTIONAL"] = "FRACTIONAL";
  OddFormat2["DECIMAL"] = "DECIMAL";
  OddFormat2["MONEYLINE"] = "MONEYLINE";
})(OddFormat || (OddFormat = {}));
var OddsTypes;
(function(OddsTypes2) {
  OddsTypes2["PRE_EVENT"] = "PRE_EVENT";
  OddsTypes2["ALL"] = "ALL";
})(OddsTypes || (OddsTypes = {}));
var HeaderLabels;
(function(HeaderLabels2) {
  HeaderLabels2["OVERTIME"] = "overtime_short";
  HeaderLabels2["POINTS"] = "points_short";
  HeaderLabels2["SCORE"] = "score_short";
})(HeaderLabels || (HeaderLabels = {}));
var SocialLabels;
(function(SocialLabels2) {
  SocialLabels2["FACEBOOK"] = "facebook";
  SocialLabels2["TWITTER"] = "twitter";
  SocialLabels2["YOUTUBE"] = "youtube";
  SocialLabels2["WIKIPEDIA"] = "wikipedia";
  SocialLabels2["WEB"] = "web";
  SocialLabels2["INSTAGRAM"] = "instagram";
})(SocialLabels || (SocialLabels = {}));
var ParticipantType;
(function(ParticipantType2) {
  ParticipantType2["HOME"] = "HOME";
  ParticipantType2["AWAY"] = "AWAY";
})(ParticipantType || (ParticipantType = {}));
var TeamFormOutcomeTypes;
(function(TeamFormOutcomeTypes2) {
  TeamFormOutcomeTypes2["WIN"] = "win";
  TeamFormOutcomeTypes2["LOSS"] = "loss";
  TeamFormOutcomeTypes2["WIN_OVERTIME"] = "win_overtime";
  TeamFormOutcomeTypes2["LOSS_OVERTIME"] = "loss_overtime";
  TeamFormOutcomeTypes2["DRAW"] = "draw";
  TeamFormOutcomeTypes2["WIN_AFTER_PENALTY"] = "win_after_penalty";
  TeamFormOutcomeTypes2["LOSS_AFTER_PENALTY"] = "loss_after_penalty";
})(TeamFormOutcomeTypes || (TeamFormOutcomeTypes = {}));

// ../types/football.ts
var NameFormat;
(function(NameFormat2) {
  NameFormat2["LAST_NAME"] = "last_name";
  NameFormat2["INITIALS"] = "initials";
})(NameFormat || (NameFormat = {}));
var ScopeTypes;
(function(ScopeTypes2) {
  ScopeTypes2["FIRST_HALF"] = "FIRST_HALF";
  ScopeTypes2["SECOND_HALF"] = "SECOND_HALF";
  ScopeTypes2["ORDINARY_TIME"] = "ORDINARY_TIME";
  ScopeTypes2["FULL_TIME"] = "FULL_TIME";
  ScopeTypes2["ALL"] = "ALL";
})(ScopeTypes || (ScopeTypes = {}));
var LineupsStatus;
(function(LineupsStatus2) {
  LineupsStatus2["CONFIRMED"] = "CONFIRMED";
  LineupsStatus2["UNCONFIRMED"] = "UNCONFIRMED";
  LineupsStatus2["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(LineupsStatus || (LineupsStatus = {}));
var EventTypeCode;
(function(EventTypeCode2) {
  EventTypeCode2["YELLOW_CARD_RED"] = "YELLOW_RED_CARD";
  EventTypeCode2["PENALTY_SHOOTOUT_MISSED"] = "PENALTY_SHOOTOUT_MISSED";
  EventTypeCode2["PENALTY_SHOOTOUT_SCORED"] = "PENALTY_SHOOTOUT_SCORED";
  EventTypeCode2["SUBSTITUTION"] = "SUBSTITUTION";
  EventTypeCode2["GOAL"] = "GOAL";
  EventTypeCode2["RED_CARD"] = "RED_CARD";
  EventTypeCode2["PENALTY_MISS"] = "PENALTY_MISS";
  EventTypeCode2["YELLOW_CARD"] = "YELLOW_CARD";
  EventTypeCode2["ASSIST"] = "ASSIST";
  EventTypeCode2["PENALTY_GOAL"] = "PENALTY_GOAL";
  EventTypeCode2["OWN_GOAL"] = "OWN_GOAL";
  EventTypeCode2["DISALLOWED_GOAL"] = "DISALLOWED_GOAL";
  EventTypeCode2["DISALLOWED_MISSED_PENALTY"] = "DISALLOWED_MISSED_PENALTY";
  EventTypeCode2["DISALLOWED_PENALTY"] = "DISALLOWED_PENALTY";
  EventTypeCode2["DISALLOWED_OWN_GOAL"] = "DISALLOWED_OWN_GOAL";
  EventTypeCode2["KICKOFF"] = "KICKOFF";
  EventTypeCode2["HALFTIME"] = "HALFTIME";
  EventTypeCode2["START_SECOND_HALF"] = "START_SECOND_HALF";
  EventTypeCode2["FINISHED_FIRST_HALF"] = "FINISHED_FIRST_HALF";
  EventTypeCode2["FINISHED_AFTER_EXTRA_TIME"] = "FINISHED_AFTER_EXTRA_TIME";
  EventTypeCode2["FINISHED_AFTER_PENALTIES"] = "FINISHED_AFTER_PENALTIES";
  EventTypeCode2["OVERTIME_FIRST_HALF"] = "OVERTIME_FIRST_HALF";
  EventTypeCode2["OVERTIME_FIRST_HALF_END"] = "OVERTIME_FIRST_HALF_END";
  EventTypeCode2["OVERTIME_SECOND_HALF"] = "OVERTIME_SECOND_HALF";
  EventTypeCode2["INJURY_TIME"] = "INJURY_TIME";
  EventTypeCode2["FINISHED"] = "FINISHED";
})(EventTypeCode || (EventTypeCode = {}));

// ../types/multisportApi.ts
var SportTypes;
(function(SportTypes2) {
  SportTypes2["ALL"] = "all";
  SportTypes2["FOOTBALL"] = "football";
  SportTypes2["BASKETBALL"] = "basketball";
  SportTypes2["TENNIS"] = "tennis";
  SportTypes2["CYCLING"] = "cycling";
  SportTypes2["HANDBALL"] = "handball";
  SportTypes2["ICE_HOCKEY"] = "ice_hockey";
  SportTypes2["MOTORSPORTS"] = "motorsports";
  SportTypes2["RUGBY_LEAGUE"] = "rugby_league";
  SportTypes2["CRICKET"] = "cricket";
  SportTypes2["ROLLER_HOCKEY"] = "roller_hockey";
})(SportTypes || (SportTypes = {}));
var StatusType;
(function(StatusType2) {
  StatusType2["FINISHED"] = "FINISHED";
  StatusType2["NOT_STARTED"] = "NOT_STARTED";
  StatusType2["LIVE"] = "LIVE";
  StatusType2["INTERRUPTED"] = "INTERRUPTED";
  StatusType2["CANCELED"] = "CANCELED";
  StatusType2["UNKNOWN"] = "UNKNOWN";
})(StatusType || (StatusType = {}));
var TennisCode;
(function(TennisCode2) {
  TennisCode2["GAME_SCORE"] = "gamescore";
  TennisCode2["SET_1"] = "set1";
  TennisCode2["SET_2"] = "set2";
  TennisCode2["SET_3"] = "set3";
  TennisCode2["SET_4"] = "set4";
  TennisCode2["SET_5"] = "set5";
  TennisCode2["SET_6"] = "set6";
})(TennisCode || (TennisCode = {}));
var WinnerType;
(function(WinnerType2) {
  WinnerType2["YES"] = "YES";
  WinnerType2["NO"] = "NO";
  WinnerType2["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(WinnerType || (WinnerType = {}));

// src/isOfTypeMarket.ts
function isOfTypeMarket(keyInput) {
  return [
    OddsMarketTypes.ONETWO,
    OddsMarketTypes.ONEXTWO,
    OddsMarketTypes.OVER_UNDER,
    OddsMarketTypes.DOUBLE_CHANCE,
    OddsMarketTypes.BOTH_TO_SCORE,
    OddsMarketTypes.DRAW_NO_BET,
    OddsMarketTypes.FIRST_TEAM_TO_SCORE,
    OddsMarketTypes.GAME_HANDICAP,
    OddsMarketTypes.FIRST_HALF,
    OddsMarketTypes.SECOND_HALF,
    OddsMarketTypes.FULL_TIME,
    OddsMarketTypes.FIRST_HALF_GOALS,
    OddsMarketTypes.CORRECT_SCORE,
    OddsMarketTypes.FIRST_PLAYER_TO_SCORE,
    OddsMarketTypes.PLAYER_TO_SCORE_DURING_GAME,
    OddsMarketTypes.PLAYER_TO_RECEIVE_CARD,
    OddsMarketTypes.FIRST_HALF_AND_FINAL_RESULT,
    "bothScore",
    "doubleChance",
    "overUnder",
    "over",
    "under"
  ].includes(keyInput);
}

// src/isOfTypeMarketValueType.ts
function isOfTypeMarketValueType(keyInput) {
  return [OddFormat.DECIMAL, OddFormat.FRACTIONAL, OddFormat.MONEYLINE].includes(keyInput.toUpperCase());
}

// ../../node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

// ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}

// ../../node_modules/date-fns/esm/toDate/index.js
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof3(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof3(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

// ../../node_modules/date-fns/esm/addMilliseconds/index.js
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

// ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

// ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

// ../../node_modules/date-fns/esm/startOfDay/index.js
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/isSameDay/index.js
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

// ../../node_modules/date-fns/esm/isDate/index.js
function _typeof2(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof2 = function _typeof3(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof2 = function _typeof3(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof2(obj);
}
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof2(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

// ../../node_modules/date-fns/esm/isValid/index.js
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

// ../../node_modules/date-fns/esm/subMilliseconds/index.js
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

// ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

// ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js
var MILLISECONDS_IN_WEEK2 = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK2) + 1;
}

// ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}

// ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var formatters = {
  y: function y(date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters_default = formatters;

// ../../node_modules/date-fns/esm/_lib/format/formatters/index.js
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters2 = {
  G: function G(date, token, localize12) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize12.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize12.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize12.era(era, {
          width: "wide"
        });
    }
  },
  y: function y2(date, token, localize12) {
    if (token === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize12.ordinalNumber(year, {
        unit: "year"
      });
    }
    return lightFormatters_default.y(date, token);
  },
  Y: function Y(date, token, localize12, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize12.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function Q(date, token, localize12) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize12.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize12.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize12.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize12.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function q(date, token, localize12) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize12.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize12.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize12.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize12.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function M2(date, token, localize12) {
    var month = date.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters_default.M(date, token);
      case "Mo":
        return localize12.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize12.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize12.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize12.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function L(date, token, localize12) {
    var month = date.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize12.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize12.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize12.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize12.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function w(date, token, localize12, options) {
    var week2 = getUTCWeek(date, options);
    if (token === "wo") {
      return localize12.ordinalNumber(week2, {
        unit: "week"
      });
    }
    return addLeadingZeros(week2, token.length);
  },
  I: function I(date, token, localize12) {
    var isoWeek = getUTCISOWeek(date);
    if (token === "Io") {
      return localize12.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function d2(date, token, localize12) {
    if (token === "do") {
      return localize12.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return lightFormatters_default.d(date, token);
  },
  D: function D(date, token, localize12) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === "Do") {
      return localize12.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function E(date, token, localize12) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function e(date, token, localize12, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize12.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function c(date, token, localize12, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize12.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function i(date, token, localize12) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize12.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize12.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize12.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize12.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize12.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function a2(date, token, localize12) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function b(date, token, localize12) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function B(date, token, localize12) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize12.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function h2(date, token, localize12) {
    if (token === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize12.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return lightFormatters_default.h(date, token);
  },
  H: function H2(date, token, localize12) {
    if (token === "Ho") {
      return localize12.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return lightFormatters_default.H(date, token);
  },
  K: function K(date, token, localize12) {
    var hours = date.getUTCHours() % 12;
    if (token === "Ko") {
      return localize12.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function k(date, token, localize12) {
    var hours = date.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize12.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function m2(date, token, localize12) {
    if (token === "mo") {
      return localize12.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return lightFormatters_default.m(date, token);
  },
  s: function s2(date, token, localize12) {
    if (token === "so") {
      return localize12.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return lightFormatters_default.s(date, token);
  },
  S: function S2(date, token) {
    return lightFormatters_default.S(date, token);
  },
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters_default = formatters2;

// ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong12) {
  switch (pattern) {
    case "P":
      return formatLong12.date({
        width: "short"
      });
    case "PP":
      return formatLong12.date({
        width: "medium"
      });
    case "PPP":
      return formatLong12.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong12.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong12) {
  switch (pattern) {
    case "p":
      return formatLong12.time({
        width: "short"
      });
    case "pp":
      return formatLong12.time({
        width: "medium"
      });
    case "ppp":
      return formatLong12.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong12.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong12) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong12);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong12.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong12.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong12.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong12.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong12)).replace("{{time}}", timeLongFormatter(timePattern, formatLong12));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters_default = longFormatters;

// ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
var formatDistance_default = formatDistance;

// ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatLong_default = formatLong;

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative_default = formatRelative;

// ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var localize_default = localize;

// ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}

// ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}

// ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var match_default = match;

// ../../node_modules/date-fns/esm/locale/en-US/index.js
var locale = {
  code: "en-US",
  formatDistance: formatDistance_default,
  formatLong: formatLong_default,
  formatRelative: formatRelative_default,
  localize: localize_default,
  match: match_default,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var en_US_default = locale;

// ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale_default = en_US_default;

// ../../node_modules/date-fns/esm/format/index.js
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale12 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale12.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale12.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale12,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters_default[firstCharacter];
      return longFormatter(substring, locale12.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters_default[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale12.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

// ../../node_modules/date-fns/esm/isFuture/index.js
function isFuture(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getTime() > Date.now();
}

// ../../node_modules/date-fns/esm/isToday/index.js
function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}

// ../constants/date.ts
var defaultLocaleLang = "en";
var defaultTimezone = "Europe/Sofia";

// ../../node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatDistance/index.js
var formatDistanceLocale2 = {
  lessThanXSeconds: {
    one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
  },
  xSeconds: {
    one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
    other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
  },
  halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
  lessThanXMinutes: {
    one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
    other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
  },
  xMinutes: {
    one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
    other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
  },
  aboutXHours: {
    one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
  },
  xHours: {
    one: "1 \u0447\u0430\u0441",
    other: "{{count}} \u0447\u0430\u0441\u0430"
  },
  xDays: {
    one: "1 \u0434\u0435\u043D",
    other: "{{count}} \u0434\u043D\u0438"
  },
  aboutXWeeks: {
    one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
  },
  xWeeks: {
    one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
    other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
  },
  aboutXMonths: {
    one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
  },
  xMonths: {
    one: "1 \u043C\u0435\u0441\u0435\u0446",
    other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
  },
  aboutXYears: {
    one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  },
  xYears: {
    one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  },
  overXYears: {
    one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  },
  almostXYears: {
    one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
    other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
  }
};
var formatDistance3 = function formatDistance4(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale2[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\u0441\u043B\u0435\u0434 " + result;
    } else {
      return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
  }
  return result;
};
var formatDistance_default2 = formatDistance3;

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatLong/index.js
var dateFormats2 = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
};
var timeFormats2 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
};
var dateTimeFormats2 = {
  any: "{{date}} {{time}}"
};
var formatLong2 = {
  date: buildFormatLongFn({
    formats: dateFormats2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats2,
    defaultWidth: "any"
  })
};
var formatLong_default2 = formatLong2;

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatRelative/index.js
var weekdays = ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"];
function lastWeek(day) {
  var weekday = weekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
  }
}
function thisWeek(day) {
  var weekday = weekdays[day];
  if (day === 2) {
    return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
  } else {
    return "'\u0432 " + weekday + " \u0432' p";
  }
}
function nextWeek(day) {
  var weekday = weekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
  }
}
var lastWeekFormatToken = function lastWeekFormatToken2(dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek(day);
  } else {
    return lastWeek(day);
  }
};
var nextWeekFormatToken = function nextWeekFormatToken2(dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek(day);
  } else {
    return nextWeek(day);
  }
};
var formatRelativeLocale2 = {
  lastWeek: lastWeekFormatToken,
  yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
  today: "'\u0434\u043D\u0435\u0441 \u0432' p",
  tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
  nextWeek: nextWeekFormatToken,
  other: "P"
};
var formatRelative3 = function formatRelative4(token, date, baseDate, options) {
  var format2 = formatRelativeLocale2[token];
  if (typeof format2 === "function") {
    return format2(date, baseDate, options);
  }
  return format2;
};
var formatRelative_default2 = formatRelative3;

// ../../node_modules/date-fns/esm/locale/bg/_lib/localize/index.js
var eraValues2 = {
  narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
  abbreviated: ["\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.", "\u043D. \u0435."],
  wide: ["\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"]
};
var quarterValues2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."],
  wide: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"]
};
var monthValues2 = {
  abbreviated: ["\u044F\u043D\u0443", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0435", "\u0434\u0435\u043A"],
  wide: ["\u044F\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
};
var dayValues2 = {
  narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
  short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
  abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u044F", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u044A\u0431"],
  wide: ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"]
};
var dayPeriodValues2 = {
  wide: {
    am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
    pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
    midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
    noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
    morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
    afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
    evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
    night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
  }
};
function isFeminine(unit) {
  return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function isNeuter(unit) {
  return unit === "quarter";
}
function numberWithSuffix(number, unit, masculine, feminine, neuter) {
  var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
  return number + "-" + suffix;
}
var ordinalNumber3 = function ordinalNumber4(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) {
    return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
  } else if (number % 1e3 === 0) {
    return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
  } else if (number % 100 === 0) {
    return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
  }
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
      case 2:
        return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
      case 7:
      case 8:
        return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
  }
  return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var localize2 = {
  ordinalNumber: ordinalNumber3,
  era: buildLocalizeFn({
    values: eraValues2,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues2,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback2(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues2,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues2,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues2,
    defaultWidth: "wide"
  })
};
var localize_default2 = localize2;

// ../../node_modules/date-fns/esm/locale/bg/_lib/match/index.js
var matchOrdinalNumberPattern2 = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern2 = /\d+/i;
var matchEraPatterns2 = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns2 = {
  any: [/^п/i, /^н/i]
};
var matchQuarterPatterns2 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchDayPatterns2 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns2 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
};
var matchMonthPatterns2 = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns2 = {
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
};
var matchDayPeriodPatterns2 = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns2 = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
};
var match2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern2,
    parsePattern: parseOrdinalNumberPattern2,
    valueCallback: function valueCallback3(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns2,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns2,
    defaultParseWidth: "any",
    valueCallback: function valueCallback4(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns2,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns2,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns2,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns2,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns2,
    defaultParseWidth: "any"
  })
};
var match_default2 = match2;

// ../../node_modules/date-fns/esm/locale/bg/index.js
var locale2 = {
  code: "bg",
  formatDistance: formatDistance_default2,
  formatLong: formatLong_default2,
  formatRelative: formatRelative_default2,
  localize: localize_default2,
  match: match_default2,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var bg_default = locale2;

// ../../node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistanceLocale3 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
};
var formatDistance5 = function formatDistance6(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale3[token].withPreposition : formatDistanceLocale3[token].standalone;
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return "vor " + result;
    }
  }
  return result;
};
var formatDistance_default3 = formatDistance5;

// ../../node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js
var dateFormats3 = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
};
var timeFormats3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats3 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong3 = {
  date: buildFormatLongFn({
    formats: dateFormats3,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats3,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats3,
    defaultWidth: "full"
  })
};
var formatLong_default3 = formatLong3;

// ../../node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelativeLocale3 = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
};
var formatRelative5 = function formatRelative6(token, _date, _baseDate, _options) {
  return formatRelativeLocale3[token];
};
var formatRelative_default3 = formatRelative5;

// ../../node_modules/date-fns/esm/locale/de/_lib/localize/index.js
var eraValues3 = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
};
var quarterValues3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
};
var monthValues3 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
};
var formattingMonthValues = {
  narrow: monthValues3.narrow,
  abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: monthValues3.wide
};
var dayValues3 = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
};
var dayPeriodValues3 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
};
var formattingDayPeriodValues2 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
};
var ordinalNumber5 = function ordinalNumber6(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize3 = {
  ordinalNumber: ordinalNumber5,
  era: buildLocalizeFn({
    values: eraValues3,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues3,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback3(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues3,
    formattingValues: formattingMonthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues3,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues2,
    defaultFormattingWidth: "wide"
  })
};
var localize_default3 = localize3;

// ../../node_modules/date-fns/esm/locale/de/_lib/match/index.js
var matchOrdinalNumberPattern3 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern3 = /\d+/i;
var matchEraPatterns3 = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns3 = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns3 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns3 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns3 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns3 = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns3 = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns3 = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns3 = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
};
var match3 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern3,
    parsePattern: parseOrdinalNumberPattern3,
    valueCallback: function valueCallback5(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns3,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns3,
    defaultParseWidth: "any",
    valueCallback: function valueCallback6(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns3,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns3,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns3,
    defaultParseWidth: "any"
  })
};
var match_default3 = match3;

// ../../node_modules/date-fns/esm/locale/de/index.js
var locale3 = {
  code: "de",
  formatDistance: formatDistance_default3,
  formatLong: formatLong_default3,
  formatRelative: formatRelative_default3,
  localize: localize_default3,
  match: match_default3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var de_default = locale3;

// ../../node_modules/date-fns/esm/locale/el/_lib/formatDistance/index.js
var formatDistanceLocale4 = {
  lessThanXSeconds: {
    one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
  },
  xSeconds: {
    one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
  },
  halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
  lessThanXMinutes: {
    one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
    other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
  },
  xMinutes: {
    one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
    other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
  },
  aboutXHours: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
  },
  xHours: {
    one: "1 \u03CE\u03C1\u03B1",
    other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
  },
  xDays: {
    one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
    other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
  },
  aboutXWeeks: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
  },
  xWeeks: {
    one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
    other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
  },
  aboutXMonths: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
  },
  xMonths: {
    one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
    other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
  },
  aboutXYears: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  xYears: {
    one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  overXYears: {
    one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  almostXYears: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  }
};
var formatDistance7 = function formatDistance8(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale4[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\u03C3\u03B5 " + result;
    } else {
      return result + " \u03C0\u03C1\u03B9\u03BD";
    }
  }
  return result;
};
var formatDistance_default4 = formatDistance7;

// ../../node_modules/date-fns/esm/locale/el/_lib/formatLong/index.js
var dateFormats4 = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
};
var timeFormats4 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats4 = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong4 = {
  date: buildFormatLongFn({
    formats: dateFormats4,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats4,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats4,
    defaultWidth: "full"
  })
};
var formatLong_default4 = formatLong4;

// ../../node_modules/date-fns/esm/locale/el/_lib/formatRelative/index.js
var formatRelativeLocale4 = {
  lastWeek: function lastWeek2(date) {
    switch (date.getUTCDay()) {
      case 6:
        return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
      default:
        return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
    }
  },
  yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
  today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
  tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
  nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
  other: "P"
};
var formatRelative7 = function formatRelative8(token, date) {
  var format2 = formatRelativeLocale4[token];
  if (typeof format2 === "function")
    return format2(date);
  return format2;
};
var formatRelative_default4 = formatRelative7;

// ../../node_modules/date-fns/esm/locale/el/_lib/localize/index.js
var eraValues4 = {
  narrow: ["\u03C0\u03A7", "\u03BC\u03A7"],
  abbreviated: ["\u03C0.\u03A7.", "\u03BC.\u03A7."],
  wide: ["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD", "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
};
var quarterValues4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["\u03A41", "\u03A42", "\u03A43", "\u03A44"],
  wide: ["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
};
var monthValues4 = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03AC\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03AC\u03B9", "\u0399\u03BF\u03CD\u03BD", "\u0399\u03BF\u03CD\u03BB", "\u0391\u03CD\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03AD", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2", "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2", "\u039C\u03AC\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2", "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2", "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]
};
var formattingMonthValues2 = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03B1\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03B1\u0390", "\u0399\u03BF\u03C5\u03BD", "\u0399\u03BF\u03C5\u03BB", "\u0391\u03C5\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03B5", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5", "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5", "\u039C\u03B1\u0390\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5", "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5", "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]
};
var dayValues4 = {
  narrow: ["\u039A", "\u0394", "T", "\u03A4", "\u03A0", "\u03A0", "\u03A3"],
  short: ["\u039A\u03C5", "\u0394\u03B5", "\u03A4\u03C1", "\u03A4\u03B5", "\u03A0\u03AD", "\u03A0\u03B1", "\u03A3\u03AC"],
  abbreviated: ["\u039A\u03C5\u03C1", "\u0394\u03B5\u03C5", "\u03A4\u03C1\u03AF", "\u03A4\u03B5\u03C4", "\u03A0\u03AD\u03BC", "\u03A0\u03B1\u03C1", "\u03A3\u03AC\u03B2"],
  wide: ["\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE", "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1", "\u03A4\u03C1\u03AF\u03C4\u03B7", "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7", "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7", "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE", "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]
};
var dayPeriodValues4 = {
  narrow: {
    am: "\u03C0\u03BC",
    pm: "\u03BC\u03BC",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  abbreviated: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  wide: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  }
};
var ordinalNumber7 = function ordinalNumber8(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  var suffix;
  if (unit === "year" || unit === "month") {
    suffix = "\u03BF\u03C2";
  } else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") {
    suffix = "\u03B7";
  } else {
    suffix = "\u03BF";
  }
  return number + suffix;
};
var localize4 = {
  ordinalNumber: ordinalNumber7,
  era: buildLocalizeFn({
    values: eraValues4,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues4,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback4(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues4,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues2,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues4,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues4,
    defaultWidth: "wide"
  })
};
var localize_default4 = localize4;

// ../../node_modules/date-fns/esm/locale/el/_lib/match/index.js
var matchOrdinalNumberPattern4 = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern4 = /\d+/i;
var matchEraPatterns4 = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns4 = {
  any: [/^π/i, /^(μ|κ)/i]
};
var matchQuarterPatterns4 = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns4 = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns4 = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
};
var matchDayPatterns4 = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns4 = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
};
var matchDayPeriodPatterns4 = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns4 = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
};
var match4 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern4,
    parsePattern: parseOrdinalNumberPattern4,
    valueCallback: function valueCallback7(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns4,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns4,
    defaultParseWidth: "any",
    valueCallback: function valueCallback8(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns4,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns4,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns4,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns4,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns4,
    defaultParseWidth: "any"
  })
};
var match_default4 = match4;

// ../../node_modules/date-fns/esm/locale/el/index.js
var locale4 = {
  code: "el",
  formatDistance: formatDistance_default4,
  formatLong: formatLong_default4,
  formatRelative: formatRelative_default4,
  localize: localize_default4,
  match: match_default4,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var el_default = locale4;

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatDistance/index.js
var translations = {
  about: "k\xF6r\xFClbel\xFCl",
  over: "t\xF6bb mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
};
var withoutSuffixes = {
  xseconds: " m\xE1sodperc",
  halfaminute: "f\xE9l perc",
  xminutes: " perc",
  xhours: " \xF3ra",
  xdays: " nap",
  xweeks: " h\xE9t",
  xmonths: " h\xF3nap",
  xyears: " \xE9v"
};
var withSuffixes = {
  xseconds: {
    "-1": " m\xE1sodperccel ezel\u0151tt",
    "1": " m\xE1sodperc m\xFAlva",
    "0": " m\xE1sodperce"
  },
  halfaminute: {
    "-1": "f\xE9l perccel ezel\u0151tt",
    "1": "f\xE9l perc m\xFAlva",
    "0": "f\xE9l perce"
  },
  xminutes: {
    "-1": " perccel ezel\u0151tt",
    "1": " perc m\xFAlva",
    "0": " perce"
  },
  xhours: {
    "-1": " \xF3r\xE1val ezel\u0151tt",
    "1": " \xF3ra m\xFAlva",
    "0": " \xF3r\xE1ja"
  },
  xdays: {
    "-1": " nappal ezel\u0151tt",
    "1": " nap m\xFAlva",
    "0": " napja"
  },
  xweeks: {
    "-1": " h\xE9ttel ezel\u0151tt",
    "1": " h\xE9t m\xFAlva",
    "0": " hete"
  },
  xmonths: {
    "-1": " h\xF3nappal ezel\u0151tt",
    "1": " h\xF3nap m\xFAlva",
    "0": " h\xF3napja"
  },
  xyears: {
    "-1": " \xE9vvel ezel\u0151tt",
    "1": " \xE9v m\xFAlva",
    "0": " \xE9ve"
  }
};
var formatDistance9 = function formatDistance10(token, count, options) {
  var adverb = token.match(/about|over|almost|lessthan/i);
  var unit = adverb ? token.replace(adverb[0], "") : token;
  var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
  var key = unit.toLowerCase();
  var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
  var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
  var result = key === "halfaminute" ? translated : count + translated;
  if (adverb) {
    var adv = adverb[0].toLowerCase();
    result = translations[adv] + " " + result;
  }
  return result;
};
var formatDistance_default5 = formatDistance9;

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatLong/index.js
var dateFormats5 = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
};
var timeFormats5 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
var dateTimeFormats5 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong5 = {
  date: buildFormatLongFn({
    formats: dateFormats5,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats5,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats5,
    defaultWidth: "full"
  })
};
var formatLong_default5 = formatLong5;

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatRelative/index.js
var accusativeWeekdays = ["vas\xE1rnap", "h\xE9tf\u0151n", "kedden", "szerd\xE1n", "cs\xFCt\xF6rt\xF6k\xF6n", "p\xE9nteken", "szombaton"];
function week(isFuture2) {
  return function(date) {
    var weekday = accusativeWeekdays[date.getUTCDay()];
    var prefix = isFuture2 ? "" : "'m\xFAlt' ";
    return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
  };
}
var formatRelativeLocale5 = {
  lastWeek: week(false),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: week(true),
  other: "P"
};
var formatRelative9 = function formatRelative10(token, date) {
  var format2 = formatRelativeLocale5[token];
  if (typeof format2 === "function") {
    return format2(date);
  }
  return format2;
};
var formatRelative_default5 = formatRelative9;

// ../../node_modules/date-fns/esm/locale/hu/_lib/localize/index.js
var eraValues5 = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus el\u0151tt", "id\u0151sz\xE1m\xEDt\xE1sunk szerint"]
};
var quarterValues5 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.\xE9v", "2. n.\xE9v", "3. n.\xE9v", "4. n.\xE9v"],
  wide: ["1. negyed\xE9v", "2. negyed\xE9v", "3. negyed\xE9v", "4. negyed\xE9v"]
};
var formattingQuarterValues = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.\xE9v", "II. n.\xE9v", "III. n.\xE9v", "IV. n.\xE9v"],
  wide: ["I. negyed\xE9v", "II. negyed\xE9v", "III. negyed\xE9v", "IV. negyed\xE9v"]
};
var monthValues5 = {
  narrow: ["J", "F", "M", "\xC1", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: ["jan.", "febr.", "m\xE1rc.", "\xE1pr.", "m\xE1j.", "j\xFAn.", "j\xFAl.", "aug.", "szept.", "okt.", "nov.", "dec."],
  wide: ["janu\xE1r", "febru\xE1r", "m\xE1rcius", "\xE1prilis", "m\xE1jus", "j\xFAnius", "j\xFAlius", "augusztus", "szeptember", "okt\xF3ber", "november", "december"]
};
var dayValues5 = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: ["vas\xE1rnap", "h\xE9tf\u0151", "kedd", "szerda", "cs\xFCt\xF6rt\xF6k", "p\xE9ntek", "szombat"]
};
var dayPeriodValues5 = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "\xE9jjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "\xE9jjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "\xE9jf\xE9l",
    noon: "d\xE9l",
    morning: "reggel",
    afternoon: "d\xE9lut\xE1n",
    evening: "este",
    night: "\xE9jjel"
  }
};
var ordinalNumber9 = function ordinalNumber10(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize5 = {
  ordinalNumber: ordinalNumber9,
  era: buildLocalizeFn({
    values: eraValues5,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues5,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback5(quarter) {
      return quarter - 1;
    },
    formattingValues: formattingQuarterValues,
    defaultFormattingWidth: "wide"
  }),
  month: buildLocalizeFn({
    values: monthValues5,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues5,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues5,
    defaultWidth: "wide"
  })
};
var localize_default5 = localize5;

// ../../node_modules/date-fns/esm/locale/hu/_lib/match/index.js
var matchOrdinalNumberPattern5 = /^(\d+)\.?/i;
var parseOrdinalNumberPattern5 = /\d+/i;
var matchEraPatterns5 = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns5 = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
};
var matchQuarterPatterns5 = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns5 = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
};
var matchMonthPatterns5 = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns5 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns5 = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns5 = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
};
var matchDayPeriodPatterns5 = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns5 = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
};
var match5 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern5,
    parsePattern: parseOrdinalNumberPattern5,
    valueCallback: function valueCallback9(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns5,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns5,
    defaultParseWidth: "any",
    valueCallback: function valueCallback10(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns5,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns5,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns5,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns5,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns5,
    defaultParseWidth: "any"
  })
};
var match_default5 = match5;

// ../../node_modules/date-fns/esm/locale/hu/index.js
var locale5 = {
  code: "hu",
  formatDistance: formatDistance_default5,
  formatLong: formatLong_default5,
  formatRelative: formatRelative_default5,
  localize: localize_default5,
  match: match_default5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var hu_default = locale5;

// ../../node_modules/date-fns/esm/locale/it/_lib/formatDistance/index.js
var formatDistanceLocale5 = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "pi\xF9 di un anno",
    other: "pi\xF9 di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
};
var formatDistance11 = function formatDistance12(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale5[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "tra " + result;
    } else {
      return result + " fa";
    }
  }
  return result;
};
var formatDistance_default6 = formatDistance11;

// ../../node_modules/date-fns/esm/locale/it/_lib/formatLong/index.js
var dateFormats6 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats6 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats6 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong6 = {
  date: buildFormatLongFn({
    formats: dateFormats6,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats6,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats6,
    defaultWidth: "full"
  })
};
var formatLong_default6 = formatLong6;

// ../../node_modules/date-fns/esm/locale/it/_lib/formatRelative/index.js
var weekdays2 = ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"];
function _lastWeek(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + weekdays2[day] + " scorso alle' p";
  }
}
function thisWeek2(day) {
  return "'" + weekdays2[day] + " alle' p";
}
function _nextWeek(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + weekdays2[day] + " prossimo alle' p";
  }
}
var formatRelativeLocale6 = {
  lastWeek: function lastWeek3(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek2(day);
    } else {
      return _lastWeek(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function nextWeek2(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek2(day);
    } else {
      return _nextWeek(day);
    }
  },
  other: "P"
};
var formatRelative11 = function formatRelative12(token, date, baseDate, options) {
  var format2 = formatRelativeLocale6[token];
  if (typeof format2 === "function") {
    return format2(date, baseDate, options);
  }
  return format2;
};
var formatRelative_default6 = formatRelative11;

// ../../node_modules/date-fns/esm/locale/it/_lib/localize/index.js
var eraValues6 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
};
var quarterValues6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues6 = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
};
var dayValues6 = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
};
var dayPeriodValues6 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
};
var formattingDayPeriodValues3 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
};
var ordinalNumber11 = function ordinalNumber12(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return String(number);
};
var localize6 = {
  ordinalNumber: ordinalNumber11,
  era: buildLocalizeFn({
    values: eraValues6,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues6,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback6(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues6,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues6,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues6,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues3,
    defaultFormattingWidth: "wide"
  })
};
var localize_default6 = localize6;

// ../../node_modules/date-fns/esm/locale/it/_lib/match/index.js
var matchOrdinalNumberPattern6 = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern6 = /\d+/i;
var matchEraPatterns6 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns6 = {
  any: [/^a/i, /^(d|e)/i]
};
var matchQuarterPatterns6 = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns6 = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns6 = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns6 = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns6 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns6 = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
var match6 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern6,
    parsePattern: parseOrdinalNumberPattern6,
    valueCallback: function valueCallback11(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns6,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns6,
    defaultParseWidth: "any",
    valueCallback: function valueCallback12(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns6,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns6,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns6,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns6,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns6,
    defaultParseWidth: "any"
  })
};
var match_default6 = match6;

// ../../node_modules/date-fns/esm/locale/it/index.js
var locale6 = {
  code: "it",
  formatDistance: formatDistance_default6,
  formatLong: formatLong_default6,
  formatRelative: formatRelative_default6,
  localize: localize_default6,
  match: match_default6,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var it_default = locale6;

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatDistance/index.js
var formatDistanceLocale6 = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 m\xEAs",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 m\xEAs",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
};
var formatDistance13 = function formatDistance14(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale6[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "daqui a " + result;
    } else {
      return "h\xE1 " + result;
    }
  }
  return result;
};
var formatDistance_default7 = formatDistance13;

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatLong/index.js
var dateFormats7 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
};
var timeFormats7 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats7 = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong7 = {
  date: buildFormatLongFn({
    formats: dateFormats7,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats7,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats7,
    defaultWidth: "full"
  })
};
var formatLong_default7 = formatLong7;

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatRelative/index.js
var formatRelativeLocale7 = {
  lastWeek: function lastWeek4(date) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
    return "'" + last + "' eeee '\xE0s' p";
  },
  yesterday: "'ontem \xE0s' p",
  today: "'hoje \xE0s' p",
  tomorrow: "'amanh\xE3 \xE0s' p",
  nextWeek: "eeee '\xE0s' p",
  other: "P"
};
var formatRelative13 = function formatRelative14(token, date, _baseDate, _options) {
  var format2 = formatRelativeLocale7[token];
  if (typeof format2 === "function") {
    return format2(date);
  }
  return format2;
};
var formatRelative_default7 = formatRelative13;

// ../../node_modules/date-fns/esm/locale/pt/_lib/localize/index.js
var eraValues7 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
};
var quarterValues7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues7 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
};
var dayValues7 = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
};
var dayPeriodValues7 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
};
var formattingDayPeriodValues4 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
};
var ordinalNumber13 = function ordinalNumber14(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + "\xBA";
};
var localize7 = {
  ordinalNumber: ordinalNumber13,
  era: buildLocalizeFn({
    values: eraValues7,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues7,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback7(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues7,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues7,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues7,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues4,
    defaultFormattingWidth: "wide"
  })
};
var localize_default7 = localize7;

// ../../node_modules/date-fns/esm/locale/pt/_lib/match/index.js
var matchOrdinalNumberPattern7 = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern7 = /\d+/i;
var matchEraPatterns7 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns7 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var matchQuarterPatterns7 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns7 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns7 = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns7 = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var matchDayPeriodPatterns7 = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns7 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var match7 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern7,
    parsePattern: parseOrdinalNumberPattern7,
    valueCallback: function valueCallback13(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns7,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns7,
    defaultParseWidth: "any",
    valueCallback: function valueCallback14(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns7,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns7,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns7,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns7,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns7,
    defaultParseWidth: "any"
  })
};
var match_default7 = match7;

// ../../node_modules/date-fns/esm/locale/pt/index.js
var locale7 = {
  code: "pt",
  formatDistance: formatDistance_default7,
  formatLong: formatLong_default7,
  formatRelative: formatRelative_default7,
  localize: localize_default7,
  match: match_default7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var pt_default = locale7;

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatDistance/index.js
var formatDistanceLocale7 = {
  lessThanXSeconds: {
    one: "mai pu\u021Bin de o secund\u0103",
    other: "mai pu\u021Bin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secund\u0103",
    other: "{{count}} secunde"
  },
  halfAMinute: "jum\u0103tate de minut",
  lessThanXMinutes: {
    one: "mai pu\u021Bin de un minut",
    other: "mai pu\u021Bin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 or\u0103",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 or\u0103",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o s\u0103pt\u0103m\xE2n\u0103",
    other: "circa {{count}} s\u0103pt\u0103m\xE2ni"
  },
  xWeeks: {
    one: "1 s\u0103pt\u0103m\xE2n\u0103",
    other: "{{count}} s\u0103pt\u0103m\xE2ni"
  },
  aboutXMonths: {
    one: "circa 1 lun\u0103",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lun\u0103",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
};
var formatDistance15 = function formatDistance16(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale7[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\xEEn " + result;
    } else {
      return result + " \xEEn urm\u0103";
    }
  }
  return result;
};
var formatDistance_default8 = formatDistance15;

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatLong/index.js
var dateFormats8 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
};
var timeFormats8 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats8 = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong8 = {
  date: buildFormatLongFn({
    formats: dateFormats8,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats8,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats8,
    defaultWidth: "full"
  })
};
var formatLong_default8 = formatLong8;

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatRelative/index.js
var formatRelativeLocale8 = {
  lastWeek: "eeee 'trecut\u0103 la' p",
  yesterday: "'ieri la' p",
  today: "'ast\u0103zi la' p",
  tomorrow: "'m\xE2ine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
};
var formatRelative15 = function formatRelative16(token, _date, _baseDate, _options) {
  return formatRelativeLocale8[token];
};
var formatRelative_default8 = formatRelative15;

// ../../node_modules/date-fns/esm/locale/ro/_lib/localize/index.js
var eraValues8 = {
  narrow: ["\xCE", "D"],
  abbreviated: ["\xCE.d.C.", "D.C."],
  wide: ["\xCEnainte de Cristos", "Dup\u0103 Cristos"]
};
var quarterValues8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
};
var monthValues8 = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
  wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
};
var dayValues8 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "s\xE2"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "s\xE2m"],
  wide: ["duminic\u0103", "luni", "mar\u021Bi", "miercuri", "joi", "vineri", "s\xE2mb\u0103t\u0103"]
};
var dayPeriodValues8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  }
};
var formattingDayPeriodValues5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nop\u021Bii",
    noon: "amiaz\u0103",
    morning: "diminea\u021B\u0103",
    afternoon: "dup\u0103-amiaz\u0103",
    evening: "sear\u0103",
    night: "noapte"
  }
};
var ordinalNumber15 = function ordinalNumber16(dirtyNumber, _options) {
  return String(dirtyNumber);
};
var localize8 = {
  ordinalNumber: ordinalNumber15,
  era: buildLocalizeFn({
    values: eraValues8,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues8,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback8(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues8,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues8,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues8,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues5,
    defaultFormattingWidth: "wide"
  })
};
var localize_default8 = localize8;

// ../../node_modules/date-fns/esm/locale/ro/_lib/match/index.js
var matchOrdinalNumberPattern8 = /^(\d+)?/i;
var parseOrdinalNumberPattern8 = /\d+/i;
var matchEraPatterns8 = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns8 = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
};
var matchQuarterPatterns8 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns8 = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns8 = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns8 = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns8 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns8 = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
};
var match8 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern8,
    parsePattern: parseOrdinalNumberPattern8,
    valueCallback: function valueCallback15(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns8,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns8,
    defaultParseWidth: "any",
    valueCallback: function valueCallback16(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns8,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns8,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns8,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns8,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns8,
    defaultParseWidth: "any"
  })
};
var match_default8 = match8;

// ../../node_modules/date-fns/esm/locale/ro/index.js
var locale8 = {
  code: "ro",
  formatDistance: formatDistance_default8,
  formatLong: formatLong_default8,
  formatRelative: formatRelative_default8,
  localize: localize_default8,
  match: match_default8,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var ro_default = locale8;

// ../../node_modules/date-fns/esm/locale/sk/_lib/formatDistance/index.js
function declensionGroup(scheme, count) {
  if (count === 1 && scheme.one) {
    return scheme.one;
  }
  if (count >= 2 && count <= 4 && scheme.twoFour) {
    return scheme.twoFour;
  }
  return scheme.other;
}
function declension(scheme, count, time) {
  var group = declensionGroup(scheme, count);
  var finalText = group[time];
  return finalText.replace("{{count}}", String(count));
}
function extractPreposition(token) {
  var result = ["lessThan", "about", "over", "almost"].filter(function(preposition) {
    return !!token.match(new RegExp("^" + preposition));
  });
  return result[0];
}
function prefixPreposition(preposition) {
  var translation = "";
  if (preposition === "almost") {
    translation = "takmer";
  }
  if (preposition === "about") {
    translation = "pribli\u017Ene";
  }
  return translation.length > 0 ? translation + " " : "";
}
function suffixPreposition(preposition) {
  var translation = "";
  if (preposition === "lessThan") {
    translation = "menej ne\u017E";
  }
  if (preposition === "over") {
    translation = "viac ne\u017E";
  }
  return translation.length > 0 ? translation + " " : "";
}
function lowercaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}
var formatDistanceLocale8 = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sek\xFAnd",
      past: "{{count}} sekundami",
      future: "{{count}} sek\xFAnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol min\xFAty",
      past: "pol min\xFAtou",
      future: "pol min\xFAty"
    }
  },
  xMinutes: {
    one: {
      present: "min\xFAta",
      past: "min\xFAtou",
      future: "min\xFAtu"
    },
    twoFour: {
      present: "{{count}} min\xFAty",
      past: "{{count}} min\xFAtami",
      future: "{{count}} min\xFAty"
    },
    other: {
      present: "{{count}} min\xFAt",
      past: "{{count}} min\xFAtami",
      future: "{{count}} min\xFAt"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hod\xEDn",
      past: "{{count}} hodinami",
      future: "{{count}} hod\xEDn"
    }
  },
  xDays: {
    one: {
      present: "de\u0148",
      past: "d\u0148om",
      future: "de\u0148"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} d\u0148ami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dn\xED",
      past: "{{count}} d\u0148ami",
      future: "{{count}} dn\xED"
    }
  },
  xWeeks: {
    one: {
      present: "t\xFD\u017Ede\u0148",
      past: "t\xFD\u017Ed\u0148om",
      future: "t\xFD\u017Ede\u0148"
    },
    twoFour: {
      present: "{{count}} t\xFD\u017Edne",
      past: "{{count}} t\xFD\u017Ed\u0148ami",
      future: "{{count}} t\xFD\u017Edne"
    },
    other: {
      present: "{{count}} t\xFD\u017Ed\u0148ov",
      past: "{{count}} t\xFD\u017Ed\u0148ami",
      future: "{{count}} t\xFD\u017Ed\u0148ov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
};
var formatDistance17 = function formatDistance18(token, count, options) {
  var preposition = extractPreposition(token) || "";
  var key = lowercaseFirstLetter(token.substring(preposition.length));
  var scheme = formatDistanceLocale8[key];
  if (!(options !== null && options !== void 0 && options.addSuffix)) {
    return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, "present");
  }
  if (options.comparison && options.comparison > 0) {
    return prefixPreposition(preposition) + "o " + suffixPreposition(preposition) + declension(scheme, count, "future");
  } else {
    return prefixPreposition(preposition) + "pred " + suffixPreposition(preposition) + declension(scheme, count, "past");
  }
};
var formatDistance_default9 = formatDistance17;

// ../../node_modules/date-fns/esm/locale/sk/_lib/formatLong/index.js
var dateFormats9 = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
};
var timeFormats9 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
};
var dateTimeFormats9 = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong9 = {
  date: buildFormatLongFn({
    formats: dateFormats9,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats9,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats9,
    defaultWidth: "full"
  })
};
var formatLong_default9 = formatLong9;

// ../../node_modules/date-fns/esm/locale/sk/_lib/formatRelative/index.js
var accusativeWeekdays2 = ["nede\u013Eu", "pondelok", "utorok", "stredu", "\u0161tvrtok", "piatok", "sobotu"];
function _lastWeek2(day) {
  var weekday = accusativeWeekdays2[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'minul\xFA " + weekday + " o' p";
    default:
      return "'minul\xFD' eeee 'o' p";
  }
}
function thisWeek3(day) {
  var weekday = accusativeWeekdays2[day];
  if (day === 4) {
    return "'vo' eeee 'o' p";
  } else {
    return "'v " + weekday + " o' p";
  }
}
function _nextWeek2(day) {
  var weekday = accusativeWeekdays2[day];
  switch (day) {
    case 0:
    case 4:
    case 6:
      return "'bud\xFAcu " + weekday + " o' p";
    default:
      return "'bud\xFAci' eeee 'o' p";
  }
}
var formatRelativeLocale9 = {
  lastWeek: function lastWeek5(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek3(day);
    } else {
      return _lastWeek2(day);
    }
  },
  yesterday: "'v\u010Dera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: function nextWeek3(date, baseDate, options) {
    var day = date.getUTCDay();
    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek3(day);
    } else {
      return _nextWeek2(day);
    }
  },
  other: "P"
};
var formatRelative17 = function formatRelative18(token, date, baseDate, options) {
  var format2 = formatRelativeLocale9[token];
  if (typeof format2 === "function") {
    return format2(date, baseDate, options);
  }
  return format2;
};
var formatRelative_default9 = formatRelative17;

// ../../node_modules/date-fns/esm/locale/sk/_lib/localize/index.js
var eraValues9 = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
};
var quarterValues9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. \u0161tvr\u0165rok", "2. \u0161tvr\u0165rok", "3. \u0161tvr\u0165rok", "4. \u0161tvr\u0165rok"]
};
var monthValues9 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["janu\xE1r", "febru\xE1r", "marec", "apr\xEDl", "m\xE1j", "j\xFAn", "j\xFAl", "august", "september", "okt\xF3ber", "november", "december"]
};
var formattingMonthValues3 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["janu\xE1ra", "febru\xE1ra", "marca", "apr\xEDla", "m\xE1ja", "j\xFAna", "j\xFAla", "augusta", "septembra", "okt\xF3bra", "novembra", "decembra"]
};
var dayValues9 = {
  narrow: ["n", "p", "u", "s", "\u0161", "p", "s"],
  short: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
  wide: ["nede\u013Ea", "pondelok", "utorok", "streda", "\u0161tvrtok", "piatok", "sobota"]
};
var dayPeriodValues9 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "r\xE1no",
    afternoon: "pop.",
    evening: "ve\u010D.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "r\xE1no",
    afternoon: "popol.",
    evening: "ve\u010Der",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "r\xE1no",
    afternoon: "popoludnie",
    evening: "ve\u010Der",
    night: "noc"
  }
};
var formattingDayPeriodValues6 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "r\xE1no",
    afternoon: "pop.",
    evening: "ve\u010D.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "r\xE1no",
    afternoon: "popol.",
    evening: "ve\u010Der",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "r\xE1no",
    afternoon: "popoludn\xED",
    evening: "ve\u010Der",
    night: "v noci"
  }
};
var ordinalNumber17 = function ordinalNumber18(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize9 = {
  ordinalNumber: ordinalNumber17,
  era: buildLocalizeFn({
    values: eraValues9,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues9,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback9(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues9,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues3,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues9,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues9,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues6,
    defaultFormattingWidth: "wide"
  })
};
var localize_default9 = localize9;

// ../../node_modules/date-fns/esm/locale/sk/_lib/match/index.js
var matchOrdinalNumberPattern9 = /^(\d+)\.?/i;
var parseOrdinalNumberPattern9 = /\d+/i;
var matchEraPatterns9 = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var parseEraPatterns9 = {
  any: [/^pr/i, /^(po|n)/i]
};
var matchQuarterPatterns9 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var parseQuarterPatterns9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns9 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var parseMonthPatterns9 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns9 = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var parseDayPatterns9 = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
};
var matchDayPeriodPatterns9 = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var parseDayPeriodPatterns9 = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
};
var match9 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern9,
    parsePattern: parseOrdinalNumberPattern9,
    valueCallback: function valueCallback17(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns9,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns9,
    defaultParseWidth: "any",
    valueCallback: function valueCallback18(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns9,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns9,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns9,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns9,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns9,
    defaultParseWidth: "any"
  })
};
var match_default9 = match9;

// ../../node_modules/date-fns/esm/locale/sk/index.js
var locale9 = {
  code: "sk",
  formatDistance: formatDistance_default9,
  formatLong: formatLong_default9,
  formatRelative: formatRelative_default9,
  localize: localize_default9,
  match: match_default9,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var sk_default = locale9;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatDistance/index.js
var formatDistanceLocale9 = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
};
var formatDistance19 = function formatDistance20(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale9[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (count % 10 > 1 && count % 10 < 5 && String(count).substr(-2, 1) !== "1") {
    result = tokenValue.dual.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "za " + result;
    } else {
      return "pre " + result;
    }
  }
  return result;
};
var formatDistance_default10 = formatDistance19;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatLong/index.js
var dateFormats10 = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
};
var timeFormats10 = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats10 = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong10 = {
  date: buildFormatLongFn({
    formats: dateFormats10,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats10,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats10,
    defaultWidth: "full"
  })
};
var formatLong_default10 = formatLong10;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatRelative/index.js
var formatRelativeLocale10 = {
  lastWeek: function lastWeek6(date) {
    switch (date.getUTCDay()) {
      case 0:
        return "'pro\u0161le nedelje u' p";
      case 3:
        return "'pro\u0161le srede u' p";
      case 6:
        return "'pro\u0161le subote u' p";
      default:
        return "'pro\u0161li' EEEE 'u' p";
    }
  },
  yesterday: "'ju\u010De u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function nextWeek4(date) {
    switch (date.getUTCDay()) {
      case 0:
        return "'slede\u0107e nedelje u' p";
      case 3:
        return "'slede\u0107u sredu u' p";
      case 6:
        return "'slede\u0107u subotu u' p";
      default:
        return "'slede\u0107i' EEEE 'u' p";
    }
  },
  other: "P"
};
var formatRelative19 = function formatRelative20(token, date, _baseDate, _options) {
  var format2 = formatRelativeLocale10[token];
  if (typeof format2 === "function") {
    return format2(date);
  }
  return format2;
};
var formatRelative_default10 = formatRelative19;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/localize/index.js
var eraValues10 = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
};
var quarterValues10 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
};
var monthValues10 = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
};
var formattingMonthValues4 = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
};
var dayValues10 = {
  narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
  wide: ["nedelja", "ponedeljak", "utorak", "sreda", "\u010Detvrtak", "petak", "subota"]
};
var formattingDayPeriodValues7 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uve\u010De",
    night: "no\u0107u"
  }
};
var dayPeriodValues10 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uve\u010De",
    night: "no\u0107u"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "pono\u0107",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uve\u010De",
    night: "no\u0107u"
  }
};
var ordinalNumber19 = function ordinalNumber20(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize10 = {
  ordinalNumber: ordinalNumber19,
  era: buildLocalizeFn({
    values: eraValues10,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues10,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback10(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues10,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues4,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues10,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues10,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues7,
    defaultFormattingWidth: "wide"
  })
};
var localize_default10 = localize10;

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/match/index.js
var matchOrdinalNumberPattern10 = /^(\d+)\./i;
var parseOrdinalNumberPattern10 = /\d+/i;
var matchEraPatterns10 = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns10 = {
  any: [/^pr/i, /^(po|nova)/i]
};
var matchQuarterPatterns10 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns10 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns10 = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns10 = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns10 = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns10 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns10 = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns10 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
};
var match10 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern10,
    parsePattern: parseOrdinalNumberPattern10,
    valueCallback: function valueCallback19(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns10,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns10,
    defaultParseWidth: "any",
    valueCallback: function valueCallback20(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns10,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns10,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns10,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns10,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns10,
    defaultParseWidth: "any"
  })
};
var match_default10 = match10;

// ../../node_modules/date-fns/esm/locale/sr-Latn/index.js
var locale10 = {
  code: "sr-Latn",
  formatDistance: formatDistance_default10,
  formatLong: formatLong_default10,
  formatRelative: formatRelative_default10,
  localize: localize_default10,
  match: match_default10,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var sr_Latn_default = locale10;

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatDistance/index.js
var formatDistanceLocale10 = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yar\u0131m dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yakla\u015F\u0131k 1 saat",
    other: "yakla\u015F\u0131k {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 g\xFCn",
    other: "{{count}} g\xFCn"
  },
  aboutXWeeks: {
    one: "yakla\u015F\u0131k 1 hafta",
    other: "yakla\u015F\u0131k {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yakla\u015F\u0131k 1 ay",
    other: "yakla\u015F\u0131k {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yakla\u015F\u0131k 1 y\u0131l",
    other: "yakla\u015F\u0131k {{count}} y\u0131l"
  },
  xYears: {
    one: "1 y\u0131l",
    other: "{{count}} y\u0131l"
  },
  overXYears: {
    one: "1 y\u0131ldan fazla",
    other: "{{count}} y\u0131ldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 y\u0131l",
    other: "neredeyse {{count}} y\u0131l"
  }
};
var formatDistance21 = function formatDistance22(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale10[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " sonra";
    } else {
      return result + " \xF6nce";
    }
  }
  return result;
};
var formatDistance_default11 = formatDistance21;

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatLong/index.js
var dateFormats11 = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
};
var timeFormats11 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats11 = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong11 = {
  date: buildFormatLongFn({
    formats: dateFormats11,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats11,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats11,
    defaultWidth: "full"
  })
};
var formatLong_default11 = formatLong11;

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatRelative/index.js
var formatRelativeLocale11 = {
  lastWeek: "'ge\xE7en hafta' eeee 'saat' p",
  yesterday: "'d\xFCn saat' p",
  today: "'bug\xFCn saat' p",
  tomorrow: "'yar\u0131n saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
};
var formatRelative21 = function formatRelative22(token, _date, _baseDate, _options) {
  return formatRelativeLocale11[token];
};
var formatRelative_default11 = formatRelative21;

// ../../node_modules/date-fns/esm/locale/tr/_lib/localize/index.js
var eraValues11 = {
  narrow: ["M\xD6", "MS"],
  abbreviated: ["M\xD6", "MS"],
  wide: ["Milattan \xD6nce", "Milattan Sonra"]
};
var quarterValues11 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1\xC7", "2\xC7", "3\xC7", "4\xC7"],
  wide: ["\u0130lk \xE7eyrek", "\u0130kinci \xC7eyrek", "\xDC\xE7\xFCnc\xFC \xE7eyrek", "Son \xE7eyrek"]
};
var monthValues11 = {
  narrow: ["O", "\u015E", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: ["Oca", "\u015Eub", "Mar", "Nis", "May", "Haz", "Tem", "A\u011Fu", "Eyl", "Eki", "Kas", "Ara"],
  wide: ["Ocak", "\u015Eubat", "Mart", "Nisan", "May\u0131s", "Haziran", "Temmuz", "A\u011Fustos", "Eyl\xFCl", "Ekim", "Kas\u0131m", "Aral\u0131k"]
};
var dayValues11 = {
  narrow: ["P", "P", "S", "\xC7", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "\xC7a", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "\xC7ar", "Per", "Cum", "Cts"],
  wide: ["Pazar", "Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi"]
};
var dayPeriodValues11 = {
  narrow: {
    am: "\xF6\xF6",
    pm: "\xF6s",
    midnight: "gy",
    noon: "\xF6",
    morning: "sa",
    afternoon: "\xF6s",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "\xD6\xD6",
    pm: "\xD6S",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Fle",
    morning: "sabah",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Fam",
    night: "gece"
  },
  wide: {
    am: "\xD6.\xD6.",
    pm: "\xD6.S.",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Fle",
    morning: "sabah",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Fam",
    night: "gece"
  }
};
var formattingDayPeriodValues8 = {
  narrow: {
    am: "\xF6\xF6",
    pm: "\xF6s",
    midnight: "gy",
    noon: "\xF6",
    morning: "sa",
    afternoon: "\xF6s",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "\xD6\xD6",
    pm: "\xD6S",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Flen",
    morning: "sabahleyin",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Famleyin",
    night: "geceleyin"
  },
  wide: {
    am: "\xF6.\xF6.",
    pm: "\xF6.s.",
    midnight: "gece yar\u0131s\u0131",
    noon: "\xF6\u011Flen",
    morning: "sabahleyin",
    afternoon: "\xF6\u011Fleden sonra",
    evening: "ak\u015Famleyin",
    night: "geceleyin"
  }
};
var ordinalNumber21 = function ordinalNumber22(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + ".";
};
var localize11 = {
  ordinalNumber: ordinalNumber21,
  era: buildLocalizeFn({
    values: eraValues11,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues11,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback11(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues11,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues11,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues11,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues8,
    defaultFormattingWidth: "wide"
  })
};
var localize_default11 = localize11;

// ../../node_modules/date-fns/esm/locale/tr/_lib/match/index.js
var matchOrdinalNumberPattern11 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern11 = /\d+/i;
var matchEraPatterns11 = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns11 = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
};
var matchQuarterPatterns11 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns11 = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
};
var matchMonthPatterns11 = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns11 = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
};
var matchDayPatterns11 = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns11 = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
};
var matchDayPeriodPatterns11 = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns11 = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
};
var match11 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern11,
    parsePattern: parseOrdinalNumberPattern11,
    valueCallback: function valueCallback21(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns11,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns11,
    defaultParseWidth: "any",
    valueCallback: function valueCallback22(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns11,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns11,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns11,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns11,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns11,
    defaultParseWidth: "any"
  })
};
var match_default11 = match11;

// ../../node_modules/date-fns/esm/locale/tr/index.js
var locale11 = {
  code: "tr",
  formatDistance: formatDistance_default11,
  formatLong: formatLong_default11,
  formatRelative: formatRelative_default11,
  localize: localize_default11,
  match: match_default11,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var tr_default = locale11;

// src/date.ts
var getDateFnsLocale = (lang) => {
  switch (lang) {
    case "bg":
      return bg_default;
    case "el":
      return el_default;
    case "ro":
      return ro_default;
    case "tr":
      return tr_default;
    case "de":
      return de_default;
    case "pt":
      return pt_default;
    case "it":
      return it_default;
    case "sr":
      return sr_Latn_default;
    case "hu":
      return hu_default;
    case "sk":
      return sk_default;
    default:
      return en_US_default;
  }
};
var convertTZ = (date, tzString) => {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
};
var getDate = (date, sdkDateOptions) => {
  var _a;
  const localeLang = (_a = sdkDateOptions == null ? void 0 : sdkDateOptions.dataConfigLang) != null ? _a : defaultLocaleLang;
  const kickoffTime = convertDateToTz(date, sdkDateOptions);
  const isKickOffFuture = isFuture(kickoffTime);
  const shouldShowDate = isKickOffFuture && !isToday(kickoffTime);
  return [shouldShowDate, format(kickoffTime, "dd MMM", { locale: getDateFnsLocale(localeLang) }).toUpperCase()];
};
var getMatchDate = (date, sdkDateOptions, formatType) => {
  var _a;
  const localeLang = (_a = sdkDateOptions == null ? void 0 : sdkDateOptions.dataConfigLang) != null ? _a : defaultLocaleLang;
  const kickoffTime = convertDateToTz(date, sdkDateOptions);
  return format(kickoffTime, formatType != null ? formatType : "dd MMMM yyyy", { locale: getDateFnsLocale(localeLang) });
};
var getMatchDateExtended = (date, sdkDateOptions, formatType = "dd/MM/yyyy - HH:mm") => {
  var _a, _b, _c, _d, _e;
  const { dataConfigLang, dataConfigTimezone } = sdkDateOptions;
  const dateObject = typeof date === "string" ? new Date(date) : date;
  const dateFormatter = new Intl.DateTimeFormat(dataConfigLang, {
    timeZone: dataConfigTimezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
  const timeZoneFormatter = new Intl.DateTimeFormat(dataConfigLang, {
    timeZone: dataConfigTimezone,
    timeZoneName: "short"
  });
  const formattedParts = dateFormatter.formatToParts(dateObject);
  const dateParts = {
    day: ((_a = formattedParts.find((part) => part.type === "day")) == null ? void 0 : _a.value) || "01",
    month: ((_b = formattedParts.find((part) => part.type === "month")) == null ? void 0 : _b.value) || "01",
    year: ((_c = formattedParts.find((part) => part.type === "year")) == null ? void 0 : _c.value) || "1970",
    hour: ((_d = formattedParts.find((part) => part.type === "hour")) == null ? void 0 : _d.value) || "00",
    minute: ((_e = formattedParts.find((part) => part.type === "minute")) == null ? void 0 : _e.value) || "00"
  };
  return formatType.replace("dd", dateParts.day).replace("MM", dateParts.month).replace("yyyy", dateParts.year).replace("HH", dateParts.hour).replace("mm", dateParts.minute);
};
var formatGameTime = (dateTime, sdkDateOptions) => {
  var _a;
  const defaultReturnValue = "-";
  if (typeof dateTime === "string") {
    const dateHoursToTimezone = dateTime && convertTZ(new Date(dateTime), (_a = sdkDateOptions == null ? void 0 : sdkDateOptions.dataConfigTimezone) != null ? _a : defaultTimezone);
    return dateHoursToTimezone ? format(dateHoursToTimezone, "H:mm") : defaultReturnValue;
  }
  return defaultReturnValue;
};
var extractOnlyDateSDKOptions = (generalSDKOptions) => {
  var _a, _b;
  return {
    dataConfigTimezone: (_a = generalSDKOptions == null ? void 0 : generalSDKOptions.dataConfigTimezone) != null ? _a : defaultTimezone,
    dataConfigLang: (_b = generalSDKOptions == null ? void 0 : generalSDKOptions.dataConfigLang) != null ? _b : defaultLocaleLang
  };
};
var convertDateToTz = (date, sdkDateOptions) => {
  var _a;
  const timeZone = (_a = sdkDateOptions == null ? void 0 : sdkDateOptions.dataConfigTimezone) != null ? _a : defaultTimezone;
  return convertTZ(date, timeZone);
};

// ../constants/statusTypes.ts
var LIVE = "LIVE";
var FINISHED = "FINISHED";
var NOT_STARTED = "NOT_STARTED";
var INTERRUPTED = "INTERRUPTED";
var CANCELLED = "CANCELLED";
var NOT_LIVE = "NOT_LIVE";
var UNKNOWN = "UNKNOWN";
var ABANDONED = "ABANDONED";
var POSTPONED = "POSTPONED";
var FINISHED_AFTER_PENALTIES = "finished_ap";
var FINISHED_AFTER_EXTRA_TIME = "finished_aet";

// src/getGameResult.ts
var getGameResult = (statusType, result, showEmptyValue) => {
  const missingResult = showEmptyValue ? "" : "-";
  if ((statusType == null ? void 0 : statusType.toUpperCase()) === NOT_STARTED || (statusType == null ? void 0 : statusType.toUpperCase()) === CANCELLED)
    return missingResult;
  return result != null ? result : missingResult;
};

// ../constants/nameTypes.ts
var SHORT_NAME = "short_name";
var SHORT_NAME_ALT = "shortName";
var THREE_LETTER_CODE = "three_letter_code";

// ../constants/notAvailable.ts
var NOT_AVAILABLE = "N/A";

// src/getTeamName.ts
var getTeamName = (team, dataTeamNameType) => {
  if (dataTeamNameType && dataTeamNameType === SHORT_NAME && (team == null ? void 0 : team.shortName)) {
    return team == null ? void 0 : team.shortName;
  }
  if (dataTeamNameType && dataTeamNameType === THREE_LETTER_CODE && (team == null ? void 0 : team.threeLetterCode)) {
    return team == null ? void 0 : team.threeLetterCode;
  }
  if (team == null ? void 0 : team.name) {
    return team == null ? void 0 : team.name;
  }
  return NOT_AVAILABLE;
};

// ../constants/statusCodes.ts
var POSTPONED2 = "postponed";
var AWAITING_INFO = "awaiting_info";
var HALF_TIME = "halftime";
var PAUSE = "pause";
var PENALTY = "penalty";
var WAITING_FOR_EXTRA_TIME = "waiting_for_extra_time";
var WAITING_FOR_PENALTY = "waiting_for_penalty";

// src/getGameStatus.ts
var getGameRegularTime = (minute) => {
  const injuryTime = (minute == null ? void 0 : minute.injuryTime) && (minute == null ? void 0 : minute.injuryTime) > 0 ? `+${minute == null ? void 0 : minute.injuryTime}` : "";
  return (minute == null ? void 0 : minute.regularTime) ? `${minute == null ? void 0 : minute.regularTime}${injuryTime}'` : "-";
};
var getGameStatus = (game, dataShortStatusType, sdkDateOptions) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const shouldUseShortName = Boolean(dataShortStatusType) && (dataShortStatusType === SHORT_NAME || dataShortStatusType === SHORT_NAME_ALT);
  const statusName = shouldUseShortName ? (_a = game == null ? void 0 : game.status) == null ? void 0 : _a.shortName : (_b = game.status) == null ? void 0 : _b.name;
  if (((_d = (_c = game == null ? void 0 : game.status) == null ? void 0 : _c.type) == null ? void 0 : _d.toUpperCase()) === NOT_STARTED || ((_e = game == null ? void 0 : game.status) == null ? void 0 : _e.code) === POSTPONED2) {
    return formatGameTime(game == null ? void 0 : game.kickoffTime, sdkDateOptions);
  }
  if (((_f = game == null ? void 0 : game.status) == null ? void 0 : _f.type.toUpperCase()) === LIVE) {
    if ((game == null ? void 0 : game.status) && [AWAITING_INFO, HALF_TIME, PAUSE, PENALTY, WAITING_FOR_EXTRA_TIME, WAITING_FOR_PENALTY].includes((_g = game == null ? void 0 : game.status) == null ? void 0 : _g.code)) {
      return statusName;
    }
    return getGameRegularTime(game == null ? void 0 : game.minute);
  }
  if (game.status && [INTERRUPTED, FINISHED, CANCELLED, UNKNOWN, ABANDONED].includes((_i = (_h = game == null ? void 0 : game.status) == null ? void 0 : _h.type) == null ? void 0 : _i.toUpperCase())) {
    return statusName;
  }
  return "-";
};

// src/isMobileDevice.ts
function isMobileDevice() {
  return window.matchMedia("only screen and (max-width: 1023px)").matches;
}
var isMobileUserAgent = () => {
  return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// src/isSmartphone.ts
function isSmartphone() {
  return window.matchMedia("only screen and (max-width: 768px)").matches;
}

// src/scrollToHorizontally.ts
var scrollToHorizontally = (el) => {
  if (!el)
    return;
  const elementLeftEdge = el.offsetLeft;
  const elementRightEdge = elementLeftEdge + el.offsetWidth;
  const parentNode = el.parentNode;
  const parentContainer = parentNode.parentNode;
  const viewableLeftEdge = parentContainer.scrollLeft;
  const viewableRightEdge = viewableLeftEdge + parentContainer.clientWidth;
  if (elementLeftEdge < viewableLeftEdge) {
    parentContainer.scrollLeft = elementLeftEdge - 10;
  } else if (elementRightEdge > viewableRightEdge) {
    parentContainer.scrollLeft = elementRightEdge - parentContainer.clientWidth + 10;
  }
};
var scrollToHorizontally_default = scrollToHorizontally;

// src/removeUndefinedPropertiesFromObject.ts
var removeUndefinedPropertiesFromObject = (obj) => Object.keys(obj).reduce((newObj, current) => {
  if (typeof obj[current] !== "undefined") {
    return __spreadProps(__spreadValues({}, newObj), {
      [current]: obj[current]
    });
  }
  return newObj;
}, {});

// src/formatRuleType.ts
var formatRuleType = (ruleType) => (ruleType == null ? void 0 : ruleType.replace("_", "").toLowerCase()) || "none";
var formatRuleType_default = formatRuleType;

// src/getTiebreakScore.ts
var getTiebreakScore = (score) => {
  return score != null ? score : "";
};

// src/getMatchStatus.ts
var getMatchStatus = (match12, dataShortStatusType, sdkDateOptions) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const shouldUseShortName = Boolean(dataShortStatusType) && (dataShortStatusType === SHORT_NAME || dataShortStatusType === SHORT_NAME_ALT);
  const statusName = shouldUseShortName ? (_a = match12 == null ? void 0 : match12.status) == null ? void 0 : _a.shortName : (_b = match12.status) == null ? void 0 : _b.name;
  if (((_d = (_c = match12 == null ? void 0 : match12.status) == null ? void 0 : _c.type) == null ? void 0 : _d.toUpperCase()) === NOT_STARTED)
    return formatGameTime(match12 == null ? void 0 : match12.scheduledStartTime, sdkDateOptions);
  if (((_e = match12 == null ? void 0 : match12.status) == null ? void 0 : _e.type.toUpperCase()) === LIVE)
    return statusName != null ? statusName : (_f = match12.status) == null ? void 0 : _f.name;
  if (match12.status && [INTERRUPTED, FINISHED, CANCELLED].includes((_h = (_g = match12 == null ? void 0 : match12.status) == null ? void 0 : _g.type) == null ? void 0 : _h.toUpperCase()))
    return statusName;
  return "-";
};

// src/getScoreByCoverageType.ts
var Result;
(function(Result3) {
  Result3["RESULT_ONLY"] = "RO";
})(Result || (Result = {}));
var getScoreByCoverageType = (matchStatus, coverageType) => {
  if (matchStatus === FINISHED.toLowerCase())
    return "";
  if (coverageType === NOT_LIVE || coverageType === UNKNOWN)
    return Result.RESULT_ONLY;
  return "";
};

// src/fansUnitedTokenProvider.ts
var FansUnitedTokenProvider = class {
  constructor({ getAuthToken, signOut }) {
    this.getIdToken = getAuthToken;
    this.logout = signOut;
  }
};

// src/getUniqueListBy.ts
var getUniqueListBy = (key, arr) => {
  if (!arr)
    return [];
  return arr.filter((value, index, self) => index === self.findIndex((item) => item[key] === value[key]));
};
var getUniqueListBy_default = getUniqueListBy;

// src/getLabelValue.ts
var getLabelValue = (value, defaultValue) => {
  if (value === void 0 || value === null || value === "") {
    return defaultValue;
  }
  return value.toString();
};
var getLabelValue_default = getLabelValue;

// ../constants/defaultWidgetOptions.ts
var defaultWidgetOptions_default = {
  "data-theme": "light",
  "data-refresh-time": "never",
  "data-date": "HH:mm",
  "data-sort-direction-fixtures": "asc",
  "data-sort-direction-results": "desc"
};

// ../constants/refreshTimes.ts
var refreshTimes = {
  super_fast: 15e3,
  fast: 3e4,
  medium: 6e4,
  slow: 18e4,
  super_slow: 6e5,
  never: null
};
var refreshTimes_default = refreshTimes;

// src/getPropValue.ts
var getDatePropValue = (value, dayjs) => {
  if (typeof value === "object") {
    return value;
  }
  const dateDefault = {
    dateFormat: "DD.MM.YYYY",
    date: dayjs.utc().format("DD.MM.YYYY")
  };
  if (!value) {
    return dateDefault;
  }
  const parsedDateAttr = JSON.parse(value);
  const areDateAndFormatMatching = dayjs(parsedDateAttr.date, parsedDateAttr.dateFormat).isValid();
  if (!areDateAndFormatMatching) {
    return dateDefault;
  }
  return {
    date: parsedDateAttr && parsedDateAttr.date ? parsedDateAttr.date : dateDefault.date,
    dateFormat: parsedDateAttr && parsedDateAttr.dateFormat ? parsedDateAttr.dateFormat : dateDefault.dateFormat
  };
};
var getDataDateValue = (value, dayjs) => {
  if (typeof value === "object") {
    return value;
  }
  const dateDefault = {
    date: "",
    dateFormat: ""
  };
  if (!value) {
    return dateDefault;
  }
  const parsedDateAttr = JSON.parse(value);
  const areDateAndFormatMatching = dayjs(parsedDateAttr.date, parsedDateAttr.dateFormat).isValid();
  if (!areDateAndFormatMatching) {
    return dateDefault;
  }
  return {
    date: parsedDateAttr && parsedDateAttr.date ? parsedDateAttr.date : dateDefault.date,
    dateFormat: parsedDateAttr && parsedDateAttr.dateFormat ? parsedDateAttr.dateFormat : dateDefault.dateFormat
  };
};
var getOddsMarketPropValue = (value, defaultValue, guardFunction) => {
  if (!value) {
    return void 0;
  }
  if (!guardFunction(value)) {
    return defaultValue;
  }
  return value;
};
var getBooleanPropValue = (value, defaultValue = false) => {
  return value && (typeof value === "boolean" || ["true", "false"].includes(value)) ? JSON.parse(value) : defaultValue;
};
var getOddsPropValue = (value) => {
  return value !== void 0 && JSON.parse(value) === false ? false : true;
};
var parseArrayWithValues = (value) => {
  if ((value == null ? void 0 : value.charAt(0)) === "[") {
    let parsedValue;
    try {
      parsedValue = JSON.parse(value.replace(/'/g, '"'));
    } catch (e2) {
      parsedValue = value;
    }
    return parsedValue;
  }
  return value;
};
var getPropValue = (sport, dayjs, widget, name, configPropValue) => {
  var _a, _b;
  const value = (_a = widget.getAttribute(name)) != null ? _a : configPropValue;
  const defaultMarket = sport === Sports.FOOTBALL ? OddsMarketTypes.ONEXTWO : OddsMarketTypes.ONETWO;
  const defaultMarketValueType = OddFormat.DECIMAL;
  switch (name) {
    case widgetAttributes_default.DATE:
      return getDatePropValue(value, dayjs);
    case widgetAttributes_default.DATA_DATE_FROM:
    case widgetAttributes_default.DATA_DATE_TO:
      return getDataDateValue(value, dayjs);
    case widgetAttributes_default.ODDS_MARKET:
      return getOddsMarketPropValue(value, defaultMarket, isOfTypeMarket);
    case widgetAttributes_default.ODDS_MARKET_VALUE_TYPE:
      return getOddsMarketPropValue(value, defaultMarketValueType, isOfTypeMarketValueType);
    case widgetAttributes_default.REFRESH_TIME:
      return value && refreshTimes_default[value] ? value : defaultWidgetOptions_default["data-refresh-time"];
    case widgetAttributes_default.THEME:
      return value || defaultWidgetOptions_default["data-theme"];
    case widgetAttributes_default.SHORT_STATUS_TYPE:
      return value || SHORT_NAME_ALT;
    case widgetAttributes_default.LABELS:
    case widgetAttributes_default.TABS:
    case widgetAttributes_default.ELEMENTS:
    case widgetAttributes_default.ELEMENTS_DESKTOP:
    case widgetAttributes_default.ELEMENTS_MOBILE:
    case widgetAttributes_default.DISPLAY_STATISTICS:
    case widgetAttributes_default.ENTITY_LINKS:
    case widgetAttributes_default.DATA_HIGHLIGHT_ENTITIES:
    case widgetAttributes_default.SPORT_ENTITY_ONE:
    case widgetAttributes_default.SPORT_ENTITY_TWO:
      if (value && typeof value !== "object") {
        let parsedValue;
        try {
          parsedValue = JSON.parse(value);
        } catch (e2) {
          parsedValue = JSON.parse(value.replace(/'/g, '"'));
        }
        return parsedValue;
      }
      return value;
    case widgetAttributes_default.GROUPS:
      if (typeof value === "object") {
        return value;
      }
      return value ? JSON.parse(value).map((num) => Number(num)) : [];
    case widgetAttributes_default.DROPDOWN_DISPLAY:
    case widgetAttributes_default.HEADER_DISPLAY:
    case widgetAttributes_default.FANS_UNITED_EXPANDED:
    case widgetAttributes_default.FANS_UNITED_ENABLED:
    case widgetAttributes_default.DISPLAY_TABS:
    case widgetAttributes_default.WRAPPER_LINK:
    case widgetAttributes_default.BETTING_BRAND_COLORS:
    case widgetAttributes_default.DATA_ODDS_CLICKABLE:
    case widgetAttributes_default.BETTING_LOGO_OVERLAP:
    case widgetAttributes_default.BETTING_LOGO_DISPLAY:
    case widgetAttributes_default.SINGLE_EVENT_MAIN_EVENTS_DISPLAY:
    case widgetAttributes_default.ADDITIONAL_INFO:
      return getBooleanPropValue(value, false);
    case widgetAttributes_default.MATCH_CENTER_EVENT_MAIN_EVENTS_DISPLAY:
      return getBooleanPropValue(value, true);
    case widgetAttributes_default.ALLOW_INLINE_ODDS:
    case widgetAttributes_default.FIXED:
    case widgetAttributes_default.IMAGE_DISPLAY:
    case widgetAttributes_default.BETTING_LOGO_CLICK_ACTION:
    case widgetAttributes_default.DATA_SHOW_COMPETITION_NAMES:
    case widgetAttributes_default.DATA_MATCH_DISPLAY:
    case widgetAttributes_default.DATA_STATISTICS_DISPLAY:
    case widgetAttributes_default.DATA_DISPLAY_SOCIAL_ICONS:
    case widgetAttributes_default.DATA_DISPLAY_TEAM_IMAGE:
      return getBooleanPropValue(value, true);
    case widgetAttributes_default.FANS_UNITED_HIDE_BEFORE_GAME_START:
      return (_b = Number(value)) != null ? _b : 15;
    case widgetAttributes_default.ODDS_PRE_EVENT_ONLY:
    case widgetAttributes_default.ODDS_DISPLAY:
      return getOddsPropValue(value);
    case widgetAttributes_default.ROUNDS_FILTER:
    case widgetAttributes_default.COMPETITIONS:
      return parseArrayWithValues(value);
    case widgetAttributes_default.ROUNDS:
    case widgetAttributes_default.DATA_TEAM_IDS:
      if (value && typeof value === "string") {
        let parsedValue;
        try {
          parsedValue = JSON.parse(value);
        } catch (e2) {
          if (value.charAt(0) === "[") {
            try {
              parsedValue = JSON.parse(value.replace(/'/g, '"'));
            } catch (e3) {
              parsedValue = value;
            }
          }
        }
        if (Array.isArray(parsedValue)) {
          parsedValue = parsedValue.map((value2) => typeof value2 === "object" ? value2 : value2.toString());
        }
        return parsedValue;
      }
      return value;
    case widgetAttributes_default.SORT_DIRECTION_FIXTURES:
      return value ? value : sport === Sports.FOOTBALL ? defaultWidgetOptions_default["data-sort-direction-fixtures"] : defaultWidgetOptions_default["data-sort-direction-fixtures"].toUpperCase();
    case widgetAttributes_default.SORT_DIRECTION_RESULTS:
      return value ? value : sport === Sports.FOOTBALL ? defaultWidgetOptions_default["data-sort-direction-results"] : defaultWidgetOptions_default["data-sort-direction-results"].toUpperCase();
    case widgetAttributes_default.OPTIONS_DISPLAY:
      return value === "auto" ? value : getBooleanPropValue(value, true);
    case widgetAttributes_default.CURRENCY_POSITION:
      return value ? value : "prefix";
    default:
      return value;
  }
};
var getPropValue_default = getPropValue;

// src/caseConverters.ts
var toCamelCase = (value) => value.split("-").map((part, i2) => i2 > 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part).join("");
var toSentenceCase = (value) => value.split("_").map((part, i2) => i2 === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part).join(" ");
var snakeToCamelCase = (value, checkBeforeConvert = false) => {
  if (checkBeforeConvert && !value.includes("_")) {
    return value;
  }
  return value.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
};
var camelToSnakeCase = (value) => value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
var toSnakeCase = (value) => value.toLowerCase().replace(/ /g, "_");
var isStringLowerCase = (str) => str === str.toLowerCase();

// src/getWidgetAttributes.ts
var getWidgetAttributes = (name, required, optional, sport) => {
  const all = [...required, ...optional];
  const mapped = {};
  const keyName = sport ? sport + "-" + name : name;
  all.forEach((attr) => {
    mapped[attr] = toCamelCase(attr);
  });
  const attributes = {
    required,
    optional,
    all,
    mapped
  };
  return {
    [keyName]: attributes
  };
};
var getWidgetAttributes_default = getWidgetAttributes;

// ../constants/entityTypes.ts
var COMPETITION_ENTITY = "competition";
var BETTING_M_VALUE_ENTITY = "betting_m_value";
var BETTING_LOGO_ENTITY = "betting_logo";
var TEAM_ENTITY = "team";
var PLAYER_ENTITY = "player";
var EVENT_ENTITY = "event";

// ../constants/subscribeTypes.ts
var COMPETITION_SUBSCRIBE_TYPE = "competition";
var BETTING_MARKET_VALUE_SUBSCRIBE_TYPE = "bettingMarketValue";
var BETTING_LOGO_SUBSCRIBE_TYPE = "bettingLogo";
var TEAM_SUBSCRIBE_TYPE = "team";
var PLAYER_SUBSCRIBE_TYPE = "player";
var EVENT_SUBSCRIBE_TYPE = "event";
var USER_INTERACTION_SUBSCRIBE_TYPE = "onUserInteraction";

// src/clickHandlers.ts
var defaultHandleCompetitionClick = (handleClick, competition) => {
  handleClick({
    id: competition.id,
    name: competition.name,
    entity_type: COMPETITION_ENTITY
  }, COMPETITION_SUBSCRIBE_TYPE);
};
var defaultHandleOddProviderClick = (handleClick, oddProvider) => {
  handleClick({
    id: oddProvider == null ? void 0 : oddProvider.id,
    name: oddProvider == null ? void 0 : oddProvider.name,
    link: oddProvider == null ? void 0 : oddProvider.url,
    entity_type: BETTING_LOGO_ENTITY
  }, BETTING_LOGO_SUBSCRIBE_TYPE);
};
var defaultHandleTeamClick = (handleClick, { id, name }) => {
  handleClick({
    id,
    name,
    entity_type: TEAM_ENTITY
  }, TEAM_SUBSCRIBE_TYPE);
};
var defaultHandleEventClick = (handleClick, event) => {
  handleClick({
    id: event,
    entity_type: EVENT_ENTITY
  }, EVENT_SUBSCRIBE_TYPE);
};
var defaultHandleTournamentClick = (handleClick, id, name) => {
  handleClick({
    id,
    name,
    entity_type: COMPETITION_ENTITY
  }, COMPETITION_SUBSCRIBE_TYPE);
};
var defaultHandleParticipantClick = (handleClick, { id, name, entityType }) => {
  handleClick({
    id,
    name,
    entity_type: entityType === TEAM_ENTITY ? TEAM_ENTITY : PLAYER_ENTITY
  }, entityType === TEAM_ENTITY ? TEAM_SUBSCRIBE_TYPE : PLAYER_SUBSCRIBE_TYPE);
};
var defaultHandlePlayerClick = (handleClick, id, name) => {
  handleClick({
    id,
    name,
    entity_type: PLAYER_ENTITY
  }, PLAYER_SUBSCRIBE_TYPE);
};
var defaultHandleUserInteractionClick = (handleClick, name, entityType) => {
  handleClick({
    name,
    entity_type: entityType
  }, USER_INTERACTION_SUBSCRIBE_TYPE);
};
var defaultHandleBettingMarketValueClick = (handleClick, bookmaker, market, link) => {
  handleClick({
    name: bookmaker.name,
    id: bookmaker.id,
    entity_type: BETTING_M_VALUE_ENTITY,
    market,
    link
  }, BETTING_MARKET_VALUE_SUBSCRIBE_TYPE);
};
var defaultHandleBettingMarketValueClickNew = (handleClick, bookmaker, market, link) => {
  handleClick({
    name: bookmaker.name,
    id: bookmaker.id,
    entity_type: BETTING_M_VALUE_ENTITY,
    market,
    link
  }, BETTING_MARKET_VALUE_SUBSCRIBE_TYPE);
};

// ../constants/tennis.ts
var ParticipantTypes;
(function(ParticipantTypes2) {
  ParticipantTypes2["TEAM_DOUBLE"] = "TEAM_DOUBLE";
  ParticipantTypes2["PLAYER"] = "PLAYER";
})(ParticipantTypes || (ParticipantTypes = {}));
var Winner;
(function(Winner2) {
  Winner2["YES"] = "YES";
  Winner2["NO"] = "NO";
})(Winner || (Winner = {}));
var MatchTypes;
(function(MatchTypes2) {
  MatchTypes2["DOUBLE"] = "DOUBLE";
  MatchTypes2["SINGLE"] = "SINGLE";
})(MatchTypes || (MatchTypes = {}));
var RankingScopeTypes;
(function(RankingScopeTypes2) {
  RankingScopeTypes2["CURRENT"] = "CURRENT";
})(RankingScopeTypes || (RankingScopeTypes = {}));
var RankingColumnTypes;
(function(RankingColumnTypes2) {
  RankingColumnTypes2["NAME"] = "NAME";
  RankingColumnTypes2["POINTS"] = "POINTS";
  RankingColumnTypes2["NATIONALITY"] = "NATIONALITY";
})(RankingColumnTypes || (RankingColumnTypes = {}));
var PlayoffDoubleTypes;
(function(PlayoffDoubleTypes2) {
  PlayoffDoubleTypes2["MALE_DOUBLES"] = "MALE_DOUBLES";
  PlayoffDoubleTypes2["FEMALE_DOUBLES"] = "FEMALE_DOUBLES";
  PlayoffDoubleTypes2["MIXED_DOUBLES"] = "MIXED_DOUBLES";
})(PlayoffDoubleTypes || (PlayoffDoubleTypes = {}));
var CurrentServer;
(function(CurrentServer2) {
  CurrentServer2["YES"] = "YES";
  CurrentServer2["NO"] = "NO";
})(CurrentServer || (CurrentServer = {}));

// src/isKnouckoutGameDoubles.ts
var isKnouckoutGameDoubles = (type) => {
  switch (type) {
    case PlayoffDoubleTypes.MALE_DOUBLES: {
      return true;
    }
    case PlayoffDoubleTypes.FEMALE_DOUBLES: {
      return true;
    }
    case PlayoffDoubleTypes.MIXED_DOUBLES: {
      return true;
    }
    default: {
      return false;
    }
  }
};

// src/getTeamWinnerForm.ts
var TeamWinnerForm;
(function(TeamWinnerForm2) {
  TeamWinnerForm2["W"] = "W";
  TeamWinnerForm2["D"] = "D";
  TeamWinnerForm2["L"] = "L";
})(TeamWinnerForm || (TeamWinnerForm = {}));
var getTeamWinnerForm = (teamId, match12, dataLabels) => {
  var _a, _b, _c, _d, _e;
  if ((match12 == null ? void 0 : match12.winner) === null) {
    return { value: (_a = dataLabels == null ? void 0 : dataLabels.D) != null ? _a : TeamWinnerForm.D, css: { background: "$drawBackgroundColor" } };
  }
  if (((_c = (_b = match12 == null ? void 0 : match12.winner) == null ? void 0 : _b.match) == null ? void 0 : _c.id) === teamId) {
    return { value: (_d = dataLabels == null ? void 0 : dataLabels.W) != null ? _d : TeamWinnerForm.W, css: { background: "$winBackgroundColor" } };
  }
  return { value: (_e = dataLabels == null ? void 0 : dataLabels.L) != null ? _e : TeamWinnerForm.L, css: { background: "$loseBackgroundColor" } };
};

// ../constants/statusLabels.ts
var IN_REGULAR_TIME = "In regular time";
var AFTER_PENALTIES = "After penalties";
var AGGREGATE = "Aggregate";

// ../constants/winnerReasons.ts
var AGG = "agg";
var AGG_BADGE = "AGG";
var PEN_BADGE = "PEN";

// src/constructAdditionalEventStatusInfo.ts
var constructAdditionalEventStatusInfo = (match12, dataLabels) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  if ((match12 == null ? void 0 : match12.winnerReason) === AGG) {
    return `( ${(_a = dataLabels == null ? void 0 : dataLabels.aggregate) != null ? _a : AGGREGATE} ${(_c = (_b = match12.score) == null ? void 0 : _b.aggregate) == null ? void 0 : _c.home}:${(_e = (_d = match12.score) == null ? void 0 : _d.aggregate) == null ? void 0 : _e.away} )`;
  }
  switch ((_f = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _f.code) {
    case FINISHED_AFTER_PENALTIES:
      return `( ${(_h = (_g = match12.score) == null ? void 0 : _g.penaltyShootout) == null ? void 0 : _h.home}:${(_j = (_i = match12.score) == null ? void 0 : _i.penaltyShootout) == null ? void 0 : _j.away} ${(_k = dataLabels == null ? void 0 : dataLabels.after_penalties) != null ? _k : AFTER_PENALTIES} )`;
    case FINISHED_AFTER_EXTRA_TIME:
      return `( ${(_m = (_l = match12.score) == null ? void 0 : _l.regularTime) == null ? void 0 : _m.home}:${(_o = (_n = match12.score) == null ? void 0 : _n.regularTime) == null ? void 0 : _o.away} ${(_p = dataLabels == null ? void 0 : dataLabels.in_regular_time) != null ? _p : IN_REGULAR_TIME} )`;
    default:
      return "";
  }
};

// src/constructEventStatusInfo.ts
var constructEventStatusInfo = (match12, dataShortStatusType) => {
  var _a, _b, _c;
  const shouldUseShortName = Boolean(dataShortStatusType) && (dataShortStatusType === SHORT_NAME || dataShortStatusType === SHORT_NAME_ALT);
  switch ((_a = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _a.code) {
    case NOT_STARTED.toLowerCase():
      return "";
    case POSTPONED.toLowerCase():
      return shouldUseShortName ? (_b = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _b.shortName : (_c = match12 == null ? void 0 : match12.matchStatus) == null ? void 0 : _c.name;
    default:
      return match12 == null ? void 0 : match12.status;
  }
};

// src/getOddsSettings.ts
var getOddsSettings = (bettingId, market, marketValueType, preEventOnly, scopeType) => {
  const oddsSettings = {};
  if (bettingId !== void 0 && bettingId !== null && bettingId !== "") {
    oddsSettings.providersIds = String(bettingId).split(",").map((id) => Number(id));
  }
  if (market) {
    oddsSettings.market = market;
  }
  if (marketValueType) {
    oddsSettings.marketValueType = marketValueType;
  }
  if (preEventOnly) {
    oddsSettings.preEventOddsOnly = preEventOnly;
  }
  if (scopeType) {
    oddsSettings.scopeType = scopeType;
  }
  return oddsSettings;
};

// src/colors.ts
var rgba2hex = (rgba) => {
  const rgb = rgba && rgba.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
  return rgb ? (Number(rgb[1]) | 1 << 8).toString(16).slice(1) + (Number(rgb[2]) | 1 << 8).toString(16).slice(1) + (Number(rgb[3]) | 1 << 8).toString(16).slice(1) : rgba;
};
var hex2rgba = (hex) => {
  let c2;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c2 = hex.substring(1).split("");
    if (c2.length === 3) {
      c2 = [c2[0], c2[0], c2[1], c2[1], c2[2], c2[2]];
    }
    c2 = "0x" + c2.join("");
    return "rgba(" + [Number(c2) >> 16 & 255, Number(c2) >> 8 & 255, Number(c2) & 255].join(",") + ",1)";
  }
};
var invertColor = (hex, bw) => {
  if (hex && hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  if (hex && hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  const r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b2 = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    return r * 0.299 + g * 0.587 + b2 * 0.203 > 186 ? "#000000" : "#FFFFFF";
  }
  const rHex = (255 - r).toString(16);
  const gHex = (255 - g).toString(16);
  const bHex = (255 - b2).toString(16);
  return "#" + rHex.padEnd(2, "0") + gHex.padEnd(2, "0") + bHex.padEnd(2, "0");
};
var getTeamColor = (colorFromAttribute, shirtColor, isHome = true) => {
  if (colorFromAttribute) {
    return colorFromAttribute;
  }
  if (shirtColor) {
    if (["white", "#ffffff", "#fff", "rgb(255,255,255)", "rgba(255,255,255,1)"].includes(shirtColor.toLowerCase().replace(/ /g, ""))) {
      return "$whiteTeamColorAlternative";
    }
    return shirtColor;
  }
  return isHome ? "$sportEntityOneColor" : "$sportEntityTwoColor";
};

// src/icons.ts
var ICONS_BASE64 = {
  goal: "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMSAxMS45OTk2QzIxIDE2Ljk3MDYgMTYuOTcwNiAyMSAxMS45OTk0IDIxQzcuMDMwOSAyMSAzIDE2Ljk3MDYgMyAxMS45OTk2QzMgNy4wMjk2NiA3LjAzMDY1IDMgMTEuOTk5NCAzQzE2Ljk3MDMgMy4wMDAyNSAyMSA3LjAyOTY2IDIxIDExLjk5OTZaTTQuMjAzNTUgMTMuNzgwOUw3LjUwMTY3IDE2LjE3NjRMNi44NjU0NyAxOC4xMzIzQzguMTE2MDggMTkuMTc5OCA5LjY1OTE1IDE5LjgxOTIgMTEuMjgyNyAxOS45NjU4TDE0LjU4MDggMTcuNTY4OUwxNi4yNDU1IDE4Ljc3NzZDMTcuNjI2MyAxNy45MTE2IDE4LjcxMjggMTYuNjQyNSAxOS4zNTI0IDE1LjE0M0wxOC4wOTQ2IDExLjI2NDlMMTkuNzU4OCAxMC4wNTYxQzE5LjM2MDggOC40NzQ0MiAxOC40ODk0IDcuMDQ5MjMgMTcuMjYwOCA1Ljk3NjQzSDEzLjE4NDRMMTIuNTQ3OSA0LjAyMDU0QzEwLjkyMTQgMy45MDg4NSA5LjI5NzgzIDQuMjk3NDEgNy44OTY5MSA1LjEzNDQ0TDYuNjM2OSA5LjAxMTU2SDQuNTc5NzJDMy45NzE1MSAxMC41MjU0IDMuODM4MDMgMTIuMTg5OCA0LjIwMzU1IDEzLjc4MDlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIuMDIyNiA4LjA3NzE1TDguMzcxODMgMTAuNzY1Nkw5Ljc2NzUgMTUuMTE2MUgxNC4yNzgzTDE1LjY3MzcgMTAuNzY1NkwxMi4wMjI2IDguMDc3MTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K",
  "own-goal": "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMi4yNTgxIDExLjk5OTVDMjIuMjU4MSAxNy42NjU0IDE3LjY2NTQgMjIuMjU4MSAxMS45OTkyIDIyLjI1ODFDNi4zMzYxMyAyMi4yNTgxIDEuNzQxNyAxNy42NjU0IDEuNzQxNyAxMS45OTk1QzEuNzQxNyA2LjMzNDcyIDYuMzM1ODQgMS43NDE3IDExLjk5OTIgMS43NDE3QzE3LjY2NTEgMS43NDE5OCAyMi4yNTgxIDYuMzM0NzIgMjIuMjU4MSAxMS45OTk1Wk0zLjExMzUxIDE0LjAyOThMNi44NzI3MSAxNi43NjAyTDYuMTQ3NTcgMTguOTg5NUM3LjU3MzAxIDIwLjE4MzUgOS4zMzE4IDIwLjkxMjMgMTEuMTgyMyAyMS4wNzk0TDE0Ljk0MTUgMTguMzQ3NEwxNi44Mzg5IDE5LjcyNTFDMTguNDEyOCAxOC43MzggMTkuNjUxMSAxNy4yOTE0IDIwLjM4MDIgMTUuNTgyM0wxOC45NDY2IDExLjE2MkwyMC44NDM0IDkuNzg0MjhDMjAuMzg5OCA3Ljk4MTQ1IDE5LjM5NjUgNi4zNTcwMSAxNy45OTYyIDUuMTM0MjRIMTMuMzQ5OEwxMi42MjQ0IDIuOTA0OTFDMTAuNzcwNSAyLjc3NzYxIDguOTE5OTggMy4yMjA0OSA3LjMyMzIxIDQuMTc0NTRMNS44ODcwNCA4LjU5MzY4SDMuNTQyMjdDMi44NDkwMiAxMC4zMTkyIDIuNjk2ODggMTIuMjE2MyAzLjExMzUxIDE0LjAyOThaIiBmaWxsPSIjRDgwMDI3Ii8+CjxwYXRoIGQ9Ik0xMi4wMjc1IDcuMjkyNDhMNy42NDY0OCAxMC41MTg3TDkuMzIxMyAxNS43MzkySDE0LjczNDNMMTYuNDA4OCAxMC41MTg3TDEyLjAyNzUgNy4yOTI0OFoiIGZpbGw9IiNEODAwMjciLz4KPC9zdmc+Cg==",
  dissalowed_own_goal: "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMSAxMS45OTk2QzIxIDE2Ljk3MDYgMTYuOTcwNiAyMSAxMS45OTk0IDIxQzcuMDMwOSAyMSAzIDE2Ljk3MDYgMyAxMS45OTk2QzMgNy4wMjk2NiA3LjAzMDY1IDMgMTEuOTk5NCAzQzE2Ljk3MDMgMy4wMDAyNSAyMSA3LjAyOTY2IDIxIDExLjk5OTZaTTQuMjAzNTUgMTMuNzgwOUw3LjUwMTY3IDE2LjE3NjRMNi44NjU0NyAxOC4xMzIzQzguMTE2MDggMTkuMTc5OCA5LjY1OTE1IDE5LjgxOTIgMTEuMjgyNyAxOS45NjU4TDE0LjU4MDggMTcuNTY4OUwxNi4yNDU1IDE4Ljc3NzZDMTcuNjI2MyAxNy45MTE2IDE4LjcxMjggMTYuNjQyNSAxOS4zNTI0IDE1LjE0M0wxOC4wOTQ2IDExLjI2NDlMMTkuNzU4OCAxMC4wNTYxQzE5LjM2MDggOC40NzQ0MiAxOC40ODk0IDcuMDQ5MjMgMTcuMjYwOCA1Ljk3NjQzSDEzLjE4NDRMMTIuNTQ3OSA0LjAyMDU0QzEwLjkyMTQgMy45MDg4NSA5LjI5NzgzIDQuMjk3NDEgNy44OTY5MSA1LjEzNDQ0TDYuNjM2OSA5LjAxMTU2SDQuNTc5NzJDMy45NzE1MSAxMC41MjU0IDMuODM4MDMgMTIuMTg5OCA0LjIwMzU1IDEzLjc4MDlaIiBmaWxsPSIjRDgwMDI3Ii8+CjxwYXRoIGQ9Ik0xMS42NTA4IDhMOCAxMC42ODg1TDkuMzk1NjggMTUuMDM4OUgxMy45MDY1TDE1LjMwMTkgMTAuNjg4NUwxMS42NTA4IDhaIiBmaWxsPSIjRDgwMDI3Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMzA2IDIxLjY5NEMxNC43MTQgMjIuMTAyIDE1LjM3NTYgMjIuMTAyIDE1Ljc4MzYgMjEuNjk0TDE4LjAwMDEgMTkuNDc3NUwyMC4yMTY1IDIxLjY5NEMyMC42MjQ2IDIyLjEwMiAyMS4yODYxIDIyLjEwMiAyMS42OTQxIDIxLjY5NEMyMi4xMDIxIDIxLjI4NiAyMi4xMDIxIDIwLjYyNDQgMjEuNjk0MSAyMC4yMTY0TDE5LjQ3NzYgMTcuOTk5OUwyMS42OTQgMTUuNzgzNkMyMi4xMDIgMTUuMzc1NiAyMi4xMDIgMTQuNzE0IDIxLjY5NCAxNC4zMDZDMjEuMjg1OSAxMy44OTggMjAuNjI0NCAxMy44OTggMjAuMjE2NCAxNC4zMDZMMTguMDAwMSAxNi41MjIzTDE1Ljc4MzggMTQuMzA2QzE1LjM3NTcgMTMuODk4IDE0LjcxNDIgMTMuODk4IDE0LjMwNjIgMTQuMzA2QzEzLjg5ODIgMTQuNzE0MSAxMy44OTgyIDE1LjM3NTYgMTQuMzA2MiAxNS43ODM2TDE2LjUyMjUgMTcuOTk5OUwxNC4zMDYgMjAuMjE2NEMxMy44OTggMjAuNjI0NCAxMy44OTggMjEuMjg1OSAxNC4zMDYgMjEuNjk0WiIgZmlsbD0iIzhDOEM4QyIvPgo8L3N2Zz4K",
  "participant-placeholder-dark": "PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM4MDRfODc0NzEpIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzOEM0MC4yMDkxIDAgNDIgMS43OTA4NiA0MiA0VjQySDBWNFoiIGZpbGw9IiMyNjI2MjYiLz4KPHBhdGggZD0iTTIwLjQ3NDYgMjQuMTU3M0MyNS4wNDEyIDI0LjE1NzMgMjguNzQzMSAyMC41MTI0IDI4Ljc0MzEgMTYuMDE2MkMyOC43NDMxIDExLjUxOTkgMjUuMDQxMiA3Ljg3NSAyMC40NzQ2IDcuODc1QzE1LjkwOCA3Ljg3NSAxMi4yMDYxIDExLjUxOTkgMTIuMjA2MSAxNi4wMTYyQzEyLjIwNjEgMjAuNTEyNCAxNS45MDggMjQuMTU3MyAyMC40NzQ2IDI0LjE1NzNaIiBmaWxsPSIjNTk1OTU5Ii8+CjxwYXRoIGQ9Ik03IDQxLjk5OTdIMzRDMzYuMjI4IDQxLjk5OTcgMzUuNyA0MC4yMjAzIDM1LjcgMzguMDI2NkMzNS43IDMxLjYwMzkgMzAuMzg5OCAyNi4zNzU1IDIzLjg2NjYgMjYuMzc1NUgxNy4wODM0QzEwLjU2MDIgMjYuMzc1NSA1LjI1MDAxIDMxLjYwMzkgNS4yNTAwMSAzOC4wMjY2QzUuMjUwMDEgNDAuMjIwMyA0Ljc3MTk2IDQxLjk5OTcgNyA0MS45OTk3WiIgZmlsbD0iIzU5NTk1OSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM4MDRfODc0NzEiPgo8cmVjdCB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==",
  "participant-placeholder": "PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzOEM0MC4yMDkxIDAgNDIgMS43OTA4NiA0MiA0VjQySDBWNFoiIGZpbGw9IiNCRkJGQkYiLz4KPHBhdGggZD0iTTIwLjQ3NDYgMjQuMTU3M0MyNS4wNDEyIDI0LjE1NzMgMjguNzQzMSAyMC41MTI0IDI4Ljc0MzEgMTYuMDE2MkMyOC43NDMxIDExLjUxOTkgMjUuMDQxMiA3Ljg3NSAyMC40NzQ2IDcuODc1QzE1LjkwOCA3Ljg3NSAxMi4yMDYxIDExLjUxOTkgMTIuMjA2MSAxNi4wMTYyQzEyLjIwNjEgMjAuNTEyNCAxNS45MDggMjQuMTU3MyAyMC40NzQ2IDI0LjE1NzNaIiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik05LjI4NTI0IDQxLjk5OTdIMzEuNjY0OEMzMy44OTI4IDQxLjk5OTcgMzUuNyA0MC4yMjAzIDM1LjcgMzguMDI2NkMzNS43IDMxLjYwMzkgMzAuMzg5OCAyNi4zNzU1IDIzLjg2NjYgMjYuMzc1NUgxNy4wODM0QzEwLjU2MDIgMjYuMzc1NSA1LjI1IDMxLjYwMzkgNS4yNSAzOC4wMjY2QzUuMjUgNDAuMjIwMyA3LjA1NzIgNDEuOTk5NyA5LjI4NTI0IDQxLjk5OTdaIiBmaWxsPSIjRjBGMEYwIi8+Cjwvc3ZnPgo=",
  "participant-placeholder-field": "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",
  red: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjE0IiByeD0iMiIgZmlsbD0iI0Q4MDAyNyIvPgo8L3N2Zz4K",
  substitution_with_background: "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",
  substitution: "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",
  "yellow-red": "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMi43NSIgeT0iMi4wNzcxNSIgd2lkdGg9IjkuMTUzODUiIGhlaWdodD0iMTIuOTIzMSIgcng9IjEuNjMyODUiIGZpbGw9IiNGRkQ4MDAiLz4KPHJlY3QgeD0iMy44MjcxNSIgeT0iMSIgd2lkdGg9IjkuMTUzODUiIGhlaWdodD0iMTIuOTIzMSIgcng9IjEuNjMyODUiIGZpbGw9IiNEODAwMjciLz4KPC9zdmc+Cg==",
  yellow: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjE0IiByeD0iMiIgZmlsbD0iI0ZGRDgwMCIvPgo8L3N2Zz4K",
  "racer-placeholder": "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzE4ODVfNDE2Mzc5IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgo8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTg4NV80MTYzNzkpIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNGNUY1RjUiLz4KPHBhdGggZD0iTTggOEM5LjEwNDU3IDggMTAgNy4xMDQ1NyAxMCA2QzEwIDQuODk1NDMgOS4xMDQ1NyA0IDggNEM2Ljg5NTQzIDQgNiA0Ljg5NTQzIDYgNkM2IDcuMTA0NTcgNi44OTU0MyA4IDggOFoiIGZpbGw9IiNBOUE5QTkiLz4KPHBhdGggZD0iTTUuMDYwMTYgMTJIMTAuOTM5OEMxMS41MjUyIDEyIDEyIDExLjY1ODMgMTIgMTEuMjM3MUMxMiAxMC4wMDM5IDEwLjYwNDkgOSA4Ljg5MTA2IDlINy4xMDg5NEM1LjM5NTEyIDkgNCAxMC4wMDM5IDQgMTEuMjM3MUM0IDExLjY1ODMgNC40NzQ4IDEyIDUuMDYwMTYgMTJaIiBmaWxsPSIjQTlBOUE5Ii8+CjwvZz4KPC9zdmc+Cg==",
  "blue-check": "PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAxNiAxNicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KICAgIDxtYXNrIGlkPSdtYXNrMF8xOTEyXzQ2NTg5NScgbWFza1VuaXRzPSd1c2VyU3BhY2VPblVzZScgeD0nMCcgeT0nMCcgd2lkdGg9JzE2JyBoZWlnaHQ9JzE2Jz4KICAgICAgICA8cmVjdCB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIGZpbGw9JyNEOUQ5RDknIC8+CiAgICA8L21hc2s+CiAgICA8ZyBtYXNrPSd1cmwoI21hc2swXzE5MTJfNDY1ODk1KSc+CiAgICAgICAgPHBhdGgKICAgICAgICAgICAgZD0nTTUuNzMzNDEgMTVMNC40NjY3NSAxMi44NjY3TDIuMDY2NzUgMTIuMzMzM0wyLjMwMDA4IDkuODY2NjdMMC42NjY3NDggOEwyLjMwMDA4IDYuMTMzMzNMMi4wNjY3NSAzLjY2NjY3TDQuNDY2NzUgMy4xMzMzM0w1LjczMzQxIDFMOC4wMDAwOCAxLjk2NjY3TDEwLjI2NjcgMUwxMS41MzM0IDMuMTMzMzNMMTMuOTMzNCAzLjY2NjY3TDEzLjcwMDEgNi4xMzMzM0wxNS4zMzM0IDhMMTMuNzAwMSA5Ljg2NjY3TDEzLjkzMzQgMTIuMzMzM0wxMS41MzM0IDEyLjg2NjdMMTAuMjY2NyAxNUw4LjAwMDA4IDE0LjAzMzNMNS43MzM0MSAxNVpNNi4zMDAwOCAxMy4zTDguMDAwMDggMTIuNTY2N0w5LjczMzQyIDEzLjNMMTAuNjY2NyAxMS43TDEyLjUwMDEgMTEuMjY2N0wxMi4zMzM0IDkuNEwxMy41NjY3IDhMMTIuMzMzNCA2LjU2NjY3TDEyLjUwMDEgNC43TDEwLjY2NjcgNC4zTDkuNzAwMDggMi43TDguMDAwMDggMy40MzMzM0w2LjI2Njc1IDIuN0w1LjMzMzQyIDQuM0wzLjUwMDA4IDQuN0wzLjY2Njc1IDYuNTY2NjdMMi40MzM0MSA4TDMuNjY2NzUgOS40TDMuNTAwMDggMTEuM0w1LjMzMzQyIDExLjdMNi4zMDAwOCAxMy4zWk03LjMwMDA4IDEwLjM2NjdMMTEuMDY2NyA2LjZMMTAuMTMzNCA1LjYzMzMzTDcuMzAwMDggOC40NjY2N0w1Ljg2Njc1IDcuMDY2NjdMNC45MzM0MSA4TDcuMzAwMDggMTAuMzY2N1onCiAgICAgICAgICAgIGZpbGw9JyMxMjYyRkEnCiAgICAgICAgLz4KICAgIDwvZz4KPC9zdmc+",
  football: "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",
  basketball: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxMzdfMzc3MTMyKSI+CjxwYXRoIGQ9Ik03Ljk5OTY3IDEuMzMzMjVDNC4zMTk2NyAxLjMzMzI1IDEuMzMzMDEgNC4zMTk5MiAxLjMzMzAxIDcuOTk5OTJDMS4zMzMwMSAxMS42Nzk5IDQuMzE5NjcgMTQuNjY2NiA3Ljk5OTY3IDE0LjY2NjZDMTEuNjc5NyAxNC42NjY2IDE0LjY2NjMgMTEuNjc5OSAxNC42NjYzIDcuOTk5OTJDMTQuNjY2MyA0LjMxOTkyIDExLjY3OTcgMS4zMzMyNSA3Ljk5OTY3IDEuMzMzMjVaTTMuNDg2MzQgNS4xNjY1OEM0LjA2NjM0IDUuNzQ2NTggNC40NjYzNCA2LjQ5MzI1IDQuNjA2MzQgNy4zMzMyNUgyLjcxMzAxQzIuODEzMDEgNi41NDY1OSAzLjA4NjM0IDUuODEzMjUgMy40ODYzNCA1LjE2NjU4Wk0yLjcxMzAxIDguNjY2NThINC42MDYzNEM0LjQ2NjM0IDkuNTA2NTkgNC4wNjYzNCAxMC4yNTMzIDMuNDg2MzQgMTAuODMzM0MzLjA4NjM0IDEwLjE4NjYgMi44MTMwMSA5LjQ1MzI1IDIuNzEzMDEgOC42NjY1OFpNNy4zMzMwMSAxMy4yODY2QzYuMTc5NjcgMTMuMTM5OSA1LjEzOTY3IDEyLjYxOTkgNC4zMzk2NyAxMS44NTk5QzUuMjA2MzQgMTEuMDMzMyA1Ljc5OTY3IDkuOTE5OTIgNS45NTMwMSA4LjY2NjU4SDcuMzMzMDFWMTMuMjg2NlpNNy4zMzMwMSA3LjMzMzI1SDUuOTUzMDFDNS43OTMwMSA2LjA3OTkyIDUuMjA2MzQgNC45NTk5MiA0LjMzMzAxIDQuMTMzMjVDNS4xMzk2NyAzLjM3MzI1IDYuMTc5NjcgMi44NTk5MiA3LjMzMzAxIDIuNzEzMjVWNy4zMzMyNVpNMTMuMjg2MyA3LjMzMzI1SDExLjM5M0MxMS41MzMgNi40OTMyNSAxMS45MzMgNS43NDY1OCAxMi41MTMgNS4xNjY1OEMxMi45MTMgNS44MTMyNSAxMy4xODYzIDYuNTQ2NTkgMTMuMjg2MyA3LjMzMzI1Wk04LjY2NjM0IDIuNzEzMjVDOS44MTk2NyAyLjg1OTkyIDEwLjg1OTcgMy4zNzMyNSAxMS42NjYzIDQuMTMzMjVDMTAuNzkzIDQuOTU5OTIgMTAuMjA2MyA2LjA3OTkyIDEwLjA0NjMgNy4zMzMyNUg4LjY2NjM0VjIuNzEzMjVaTTguNjY2MzQgMTMuMjg2NlY4LjY2NjU4SDEwLjA0NjNDMTAuMjA2MyA5LjkxOTkyIDEwLjc5MyAxMS4wMzMzIDExLjY1OTcgMTEuODU5OUMxMC44NTk3IDEyLjYxOTkgOS44MTk2NyAxMy4xMzk5IDguNjY2MzQgMTMuMjg2NlpNMTIuNTEzIDEwLjgzMzNDMTEuOTMzIDEwLjI1OTkgMTEuNTM5NyA5LjUwNjU5IDExLjM5MyA4LjY2NjU4SDEzLjI4NjNDMTMuMTg2MyA5LjQ1MzI1IDEyLjkxMyAxMC4xODY2IDEyLjUxMyAxMC44MzMzWiIgZmlsbD0iI0Q5RDlEOSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIxMzdfMzc3MTMyIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=",
  tennis: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxMzdfMzc3MTE2KSI+CjxwYXRoIGQ9Ik0xMy4wMTMyIDEuNjYwMDVDMTEuNDUzMiAwLjEwMDA1MyA4LjU5OTkgMC40MTMzODYgNi42NDY1NiAyLjM2NjcyQzUuNTc5OSAzLjQzMzM5IDQuOTY2NTYgNC45NDY3MiA0Ljk1MzIzIDYuMDA2NzJDNC45Mzk5IDcuMDYwMDUgNS4xMjY1NiA4LjYwMDA1IDQuMDUzMjMgOS42NzMzOUwxLjIyNjU2IDEyLjUwMDFMMi4xNzMyMyAxMy40NDY3TDQuOTk5OSAxMC42MjAxQzYuMDczMjMgOS41NDY3MiA3LjYxMzIzIDkuNzMzMzkgOC42NjY1NiA5LjcyMDA1QzkuNzE5OSA5LjcwNjcyIDExLjIzOTkgOS4wOTMzOSAxMi4zMDY2IDguMDI2NzJDMTQuMjUzMiA2LjA3MzM5IDE0LjU3MzIgMy4yMjAwNSAxMy4wMTMyIDEuNjYwMDVaTTYuODc5OSA3Ljc4NjcyQzUuODU5OSA2Ljc2NjcyIDYuMTc5OSA0LjcxMzM5IDcuNTg2NTYgMy4zMDY3MkM4Ljk5MzIzIDEuOTAwMDUgMTEuMDM5OSAxLjU4MDA1IDEyLjA2NjYgMi42MDAwNUMxMy4wODY2IDMuNjIwMDUgMTIuNzY2NiA1LjY3MzM5IDExLjM1OTkgNy4wODAwNUM5Ljk1MzIzIDguNDg2NzIgNy45MDY1NiA4LjgwNjcyIDYuODc5OSA3Ljc4NjcyWiIgZmlsbD0iI0Q5RDlEOSIvPgo8cGF0aCBkPSJNMTEuOTk5NyAxMS4zMzMzQzEyLjM1MyAxMS4zMzMzIDEyLjY5MyAxMS40NzMzIDEyLjkzOTcgMTEuNzI2N0MxMy40NTk3IDEyLjI0NjcgMTMuNDU5NyAxMy4wOTMzIDEyLjkzOTcgMTMuNjEzM0MxMi42OTMgMTMuODYgMTIuMzUzIDE0IDExLjk5OTcgMTRDMTEuNjQ2MyAxNCAxMS4zMDYzIDEzLjg2IDExLjA1OTcgMTMuNjA2N0MxMC41Mzk3IDEzLjA4NjcgMTAuNTM5NyAxMi4yNCAxMS4wNTk3IDExLjcyQzExLjMwNjMgMTEuNDczMyAxMS42NDYzIDExLjMzMzMgMTEuOTk5NyAxMS4zMzMzWk0xMS45OTk3IDEwQzExLjMxOTcgMTAgMTAuNjMzIDEwLjI2IDEwLjExMyAxMC43OEM5LjA3MzAxIDExLjgyIDkuMDczMDEgMTMuNTA2NyAxMC4xMTMgMTQuNTUzM0MxMC42MzMgMTUuMDczMyAxMS4zMTk3IDE1LjMzMzMgMTEuOTk5NyAxNS4zMzMzQzEyLjY3OTcgMTUuMzMzMyAxMy4zNjYzIDE1LjA3MzMgMTMuODg2MyAxNC41NTMzQzE0LjkyNjMgMTMuNTEzMyAxNC45MjYzIDExLjgyNjcgMTMuODg2MyAxMC43OEMxMy4zNjYzIDEwLjI2IDEyLjY3OTcgMTAgMTEuOTk5NyAxMFoiIGZpbGw9IiNEOUQ5RDkiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yMTM3XzM3NzExNiI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K",
  cycling: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxMzdfMzc3MTgyKSI+CjxwYXRoIGQ9Ik0xMC4zMzMzIDMuNjY2NjdDMTEuMDY2NyAzLjY2NjY3IDExLjY2NjcgMy4wNjY2NyAxMS42NjY3IDIuMzMzMzNDMTEuNjY2NyAxLjYgMTEuMDY2NyAxIDEwLjMzMzMgMUM5LjYgMSA5IDEuNiA5IDIuMzMzMzNDOSAzLjA2NjY3IDkuNiAzLjY2NjY3IDEwLjMzMzMgMy42NjY2N1pNMy4zMzMzMyA4QzEuNDY2NjcgOCAwIDkuNDY2NjcgMCAxMS4zMzMzQzAgMTMuMiAxLjQ2NjY3IDE0LjY2NjcgMy4zMzMzMyAxNC42NjY3QzUuMiAxNC42NjY3IDYuNjY2NjcgMTMuMiA2LjY2NjY3IDExLjMzMzNDNi42NjY2NyA5LjQ2NjY3IDUuMiA4IDMuMzMzMzMgOFpNMy4zMzMzMyAxMy42NjY3QzIuMDY2NjcgMTMuNjY2NyAxIDEyLjYgMSAxMS4zMzMzQzEgMTAuMDY2NyAyLjA2NjY3IDkgMy4zMzMzMyA5QzQuNiA5IDUuNjY2NjcgMTAuMDY2NyA1LjY2NjY3IDExLjMzMzNDNS42NjY2NyAxMi42IDQuNiAxMy42NjY3IDMuMzMzMzMgMTMuNjY2N1pNNy4yIDdMOC44IDUuNEw5LjMzMzMzIDUuOTMzMzNDMTAuMiA2LjggMTEuMzMzMyA3LjMzMzMzIDEyLjczMzMgNy4zMzMzM1Y2QzExLjczMzMgNiAxMC45MzMzIDUuNiAxMC4zMzMzIDVMOS4wNjY2NyAzLjczMzMzQzguNzMzMzMgMy40NjY2NyA4LjQgMy4zMzMzMyA4IDMuMzMzMzNDNy42IDMuMzMzMzMgNy4yNjY2NyAzLjQ2NjY3IDcuMDY2NjcgMy43MzMzM0w1LjIgNS42QzQuOTMzMzMgNS44NjY2NyA0LjggNi4yIDQuOCA2LjUzMzMzQzQuOCA2LjkzMzMzIDQuOTMzMzMgNy4yNjY2NyA1LjIgNy40NjY2N0w3LjMzMzMzIDkuMzMzMzNWMTIuNjY2N0g4LjY2NjY3VjguNTMzMzNMNy4yIDdaTTEyLjY2NjcgOEMxMC44IDggOS4zMzMzMyA5LjQ2NjY3IDkuMzMzMzMgMTEuMzMzM0M5LjMzMzMzIDEzLjIgMTAuOCAxNC42NjY3IDEyLjY2NjcgMTQuNjY2N0MxNC41MzMzIDE0LjY2NjcgMTYgMTMuMiAxNiAxMS4zMzMzQzE2IDkuNDY2NjcgMTQuNTMzMyA4IDEyLjY2NjcgOFpNMTIuNjY2NyAxMy42NjY3QzExLjQgMTMuNjY2NyAxMC4zMzMzIDEyLjYgMTAuMzMzMyAxMS4zMzMzQzEwLjMzMzMgMTAuMDY2NyAxMS40IDkgMTIuNjY2NyA5QzEzLjkzMzMgOSAxNSAxMC4wNjY3IDE1IDExLjMzMzNDMTUgMTIuNiAxMy45MzMzIDEzLjY2NjcgMTIuNjY2NyAxMy42NjY3WiIgZmlsbD0iI0Q5RDlEOSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIxMzdfMzc3MTgyIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=",
  handball: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxMzdfMzc3MTY0KSI+CjxwYXRoIGQ9Ik05LjUxMjUzIDQuMDAwMTdDOS4xNDU4NiA0LjYzMzUxIDkuMzY1ODYgNS40NTM1MSA5Ljk5OTIgNS44MjAxN0MxMC42MzI1IDYuMTg2ODQgMTEuNDUyNSA1Ljk2Njg0IDExLjgxOTIgNS4zMzM1MUMxMi4xODU5IDQuNzAwMTcgMTEuOTY1OSAzLjg4MDE3IDExLjMzMjUgMy41MTM1MUMxMC42OTkyIDMuMTQ2ODQgOS44NzkyIDMuMzY2ODQgOS41MTI1MyA0LjAwMDE3WiIgZmlsbD0iI0Q5RDlEOSIvPgo8cGF0aCBkPSJNMTAuNTU5NSA2Ljk0MDE0QzEwLjU1OTUgNi45NDAxNCA5LjQ3Mjg1IDYuMzEzNDcgOC44MjYxOCA1Ljk0MDE0QzcuMjM5NTIgNS4wMjAxNCA2LjY5Mjg1IDIuOTgwMTQgNy42MTI4NSAxLjM5MzQ3TDYuNDU5NTIgMC43MjY4MDdDNS4zOTk1MiAyLjU1MzQ3IDUuNzMyODUgNC44MDY4MSA3LjEwNjE4IDYuMjY2ODFMMy42NzI4NSAxMi4yMTM1TDQuODI2MTggMTIuODgwMUw1LjgyNjE4IDExLjE0NjhMNi45Nzk1MiAxMS44MTM1TDQuOTc5NTIgMTUuMjgwMUw2LjEzMjg1IDE1Ljk0NjhMMTAuMzI2MiA4LjY4NjgxQzExLjA4NjIgOS43MjAxNCAxMS4yMTI5IDExLjE0NjggMTAuNTMyOSAxMi4zMjY4TDExLjY4NjIgMTIuOTkzNUMxMi43NTI5IDExLjE2MDEgMTIuNTM5NSA4LjYwNjgxIDEwLjU1OTUgNi45NDAxNFoiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTguNDk5NzcgMi41MzM0M0M4Ljk3OTc3IDIuODA2NzYgOS41ODY0NCAyLjY0Njc2IDkuODY2NDQgMi4xNjY3NkMxMC4xMzk4IDEuNjg2NzYgOS45Nzk3NyAxLjA4MDEgOS40OTk3NyAwLjgwMDA5NUM5LjAxOTc3IDAuNTI2NzYyIDguNDEzMSAwLjY4Njc2MiA4LjEzMzEgMS4xNjY3NkM3Ljg1OTc3IDEuNjQ2NzYgOC4wMTk3NyAyLjI2MDEgOC40OTk3NyAyLjUzMzQzWiIgZmlsbD0iI0Q5RDlEOSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIxMzdfMzc3MTY0Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=",
  ice_hockey: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjAxNyAyLjcxOTk3SDE0Ljc4OTJDMTQuMDYzNCA1LjEzMTc3IDEyLjQ4ODMgMTEuNTc4NSAxMS4wOTY4IDEyLjM4MDFDOS4xNzA5OSAxMy40ODk2IDIuOTQyMjQgMTMuMjk2IDIuMTU4NjcgMTIuMzgwMUMxLjMzNDY3IDExLjQxNyAyLjIyNDU3IDkuNjg1NjEgMi45ODkzMyA5LjUyOTQ0QzMuODgwMjYgOS4zNDc1MiA4Ljc0NTM1IDEwLjQ2MTMgOS42Nzc3NyA5LjgxNzU4QzEwLjM1NDUgOS4zNTAzOCAxMi4xMDY2IDQuNjA2MTUgMTMuMDE3IDIuNzE5OTdaIiBmaWxsPSIjRDlEOUQ5Ii8+CjxwYXRoIGQ9Ik01LjgyOTIyIDcuMDEzOEM1LjgyOTIyIDcuNDMyNDggNC44MTA5MSA3Ljc3MTg4IDMuNTU0NzUgNy43NzE4OEMyLjI5ODU3IDcuNzcxODggMS4yODAyNiA3LjQzMjQ4IDEuMjgwMjYgNy4wMTM4VjYuMTk4MDVDMS4yODAyNiA1Ljc3OTM3IDIuMjk4NTkgNS40Mzk5NyAzLjU1NDc1IDUuNDM5OTdDNC44MTA5IDUuNDM5OTcgNS44MjkyMiA1Ljc3OTM3IDUuODI5MjIgNi4xOTgwNVY3LjAxMzhaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=",
  roller_hockey: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjAxNyAyLjcxOTk3SDE0Ljc4OTJDMTQuMDYzNCA1LjEzMTc3IDEyLjQ4ODMgMTEuNTc4NSAxMS4wOTY4IDEyLjM4MDFDOS4xNzA5OSAxMy40ODk2IDIuOTQyMjQgMTMuMjk2IDIuMTU4NjcgMTIuMzgwMUMxLjMzNDY3IDExLjQxNyAyLjIyNDU3IDkuNjg1NjEgMi45ODkzMyA5LjUyOTQ0QzMuODgwMjYgOS4zNDc1MiA4Ljc0NTM1IDEwLjQ2MTMgOS42Nzc3NyA5LjgxNzU4QzEwLjM1NDUgOS4zNTAzOCAxMi4xMDY2IDQuNjA2MTUgMTMuMDE3IDIuNzE5OTdaIiBmaWxsPSIjRDlEOUQ5Ii8+CjxwYXRoIGQ9Ik01LjgyOTIyIDcuMDEzOEM1LjgyOTIyIDcuNDMyNDggNC44MTA5MSA3Ljc3MTg4IDMuNTU0NzUgNy43NzE4OEMyLjI5ODU3IDcuNzcxODggMS4yODAyNiA3LjQzMjQ4IDEuMjgwMjYgNy4wMTM4VjYuMTk4MDVDMS4yODAyNiA1Ljc3OTM3IDIuMjk4NTkgNS40Mzk5NyAzLjU1NDc1IDUuNDM5OTdDNC44MTA5IDUuNDM5OTcgNS44MjkyMiA1Ljc3OTM3IDUuODI5MjIgNi4xOTgwNVY3LjAxMzhaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=",
  motorsports: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxMzdfMzc3MTAxKSI+CjxwYXRoIGQ9Ik0xNC42Mzk3IDcuNDgwMDhDMTQuMzc5NyA0LjY3MzQxIDExLjgzOTcgMi42NjY3NSA5LjAzOTY3IDIuNjY2NzVDOC45MTMwMSAyLjY2Njc1IDguNzg2MzQgMi42NzM0MSA4LjY1OTY3IDIuNjgwMDhDMS4zMzMwMSAzLjE2MDA4IDEuMzMzMDEgMTEuNDY2NyAxLjMzMzAxIDExLjQ2NjdWMTIuMDAwMUMxLjMzMzAxIDEyLjczMzQgMS45MzMwMSAxMy4zMzM0IDIuNjY2MzQgMTMuMzMzNEg5LjMzMzAxQzEyLjQ0NjMgMTMuMzMzNCAxNC45Mzk3IDEwLjY2MDEgMTQuNjM5NyA3LjQ4MDA4Wk0zLjUwNjM0IDcuNzA2NzVDMy44ODYzNCA2Ljg0Njc1IDQuMzU5NjcgNi4xNDAwOCA0LjkzMzAxIDUuNTgwMDhMNy4zNDYzNCA2LjYwMDA4QzcuNzQ2MzQgNi43NjY3NSA3Ljk5OTY3IDcuMTUzNDEgNy45OTk2NyA3LjU4Njc1QzcuOTk5NjcgOC4xODAwOCA3LjUxOTY3IDguNjYwMDggNi45MjYzNCA4LjY2MDA4SDMuMTQ2MzRDMy4yNDYzNCA4LjM1MzQxIDMuMzU5NjcgOC4wMzM0MiAzLjUwNjM0IDcuNzA2NzVaTTEyLjI5MyAxMC42OTM0QzExLjUzMyAxMS41MjY3IDEwLjQ1MyAxMi4wMDAxIDkuMzMzMDEgMTIuMDAwMUgyLjY2NjM0VjExLjQ2NjdDMi42NjYzNCAxMS40NTM0IDIuNjczMDEgMTAuODUzNCAyLjgyNjM0IDEwLjAwMDFINi45MjYzNEM4LjI1MzAxIDEwLjAwMDEgOS4zMzMwMSA4LjkyMDA4IDkuMzMzMDEgNy41OTM0MkM5LjMzMzAxIDYuNjI2NzUgOC43NTMwMSA1Ljc1MzQxIDcuODY2MzQgNS4zODAwOEw2LjE5OTY3IDQuNjczNDFDNi45MzMwMSA0LjI5MzQxIDcuNzc5NjcgNC4wNzM0MSA4Ljc0NjM0IDQuMDEzNDFDOC44NDYzNCA0LjAwMDA4IDguOTQ2MzQgNC4wMDAwOCA5LjAzOTY3IDQuMDAwMDhDMTEuMjQ2MyA0LjAwMDA4IDEzLjEyNjMgNS41ODAwOCAxMy4zMTMgNy42MDY3NUMxMy40MTk3IDguNzUzNDEgMTMuMDU5NyA5Ljg0Njc1IDEyLjI5MyAxMC42OTM0WiIgZmlsbD0iI0Q5RDlEOSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIxMzdfMzc3MTAxIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=",
  facebook_light: "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi44MDYzIDI3Ljg2NUMyMi41NzY3IDI2Ljk5MzggMjcgMjIuMDEzNSAyNyAxNkMyNyA5LjM3MjU4IDIxLjYyNzQgNCAxNSA0QzguMzcyNTggNCAzIDkuMzcyNTggMyAxNkMzIDIxLjkyMzEgNy4yOTEyNyAyNi44NDM4IDEyLjkzNDQgMjcuODIyOVYxOC40NDY1SDExVjE1LjE5MDZIMTIuOTM0NFYxMy4yMzU3QzEyLjkzNDQgMTAuNTc5NSAxNC4wMjY3IDkgMTcuMTI5OSA5SDE5LjcxMzVWMTIuMjU2M0gxOC4wOTg2QzE2Ljg5MDYgMTIuMjU2MyAxNi44MTA2IDEyLjcxMTQgMTYuODEwNiAxMy41NjA2TDE2LjgwNjMgMTUuMTkwMkgxOS43MzE4TDE5LjM4OTUgMTguNDQ2MkgxNi44MDYzVjI3Ljg2NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=",
  instagram_light: "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",
  twitter_light: "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjk2OCA1SDI2LjY0OEwxOC41NjggMTQuMzM1OEwyOC4wMDggMjdIMjAuNkwxNC44IDE5LjMwNDFMOC4xNiAyN0g0LjQ4TDEzLjA0IDE3LjAxNDhMNCA1SDExLjU5MkwxNi44MzIgMTIuMDMwM0wyMi45NjggNVpNMjEuNjggMjQuODA4MUgyMy43MkwxMC41MiA3LjExMDdIOC4zMjhMMjEuNjggMjQuODA4MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=",
  youtube_light: "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS4zNzYzIDguNTAxODFDMjYuNDA5NiA4Ljc3ODQgMjcuMjIxNiA5LjU5MDM5IDI3LjQ5ODIgMTAuNjIzNkMyNy45OTggMTIuNDk0NiAyOCAxNi40MDA0IDI4IDE2LjQwMDRDMjggMTYuNDAwNCAyOCAyMC4zMDYzIDI3LjQ5ODIgMjIuMTc3MkMyNy4yMjE2IDIzLjIxMDQgMjYuNDA5NiAyNC4wMjI0IDI1LjM3NjMgMjQuMjk5QzIzLjUwNTUgMjQuODAwOCAxNiAyNC44MDA4IDE2IDI0LjgwMDhDMTYgMjQuODAwOCA4LjQ5NDU3IDI0LjgwMDggNi42MjM2NCAyNC4yOTlDNS41OTAzOSAyNC4wMjI0IDQuNzc4NCAyMy4yMTA0IDQuNTAxODEgMjIuMTc3MkM0IDIwLjMwNjMgNCAxNi40MDA0IDQgMTYuNDAwNEM0IDE2LjQwMDQgNCAxMi40OTQ2IDQuNTAxODEgMTAuNjIzNkM0Ljc3ODQgOS41OTAzOSA1LjU5MDM5IDguNzc4NCA2LjYyMzY0IDguNTAxODFDOC40OTQ1NyA4IDE2IDggMTYgOEMxNiA4IDIzLjUwNTUgOCAyNS4zNzYzIDguNTAxODFaTTE5LjgzMjggMTYuNDAwN0wxMy41OTc3IDIwLjAwMDNWMTIuODAxMUwxOS44MzI4IDE2LjQwMDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K",
  web_light: "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",
  wikipedia_light: "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgOVY5LjUwMjYyQzQgOS42MjgyNyA0LjA2MjgzIDkuNjkxMSA0LjI1MTMxIDkuNjkxMUM1LjUwNzg1IDkuNzUzOTMgNS41MDc4NSAxMC4wMDUyIDYuMDEwNDcgMTEuMTM2MUwxMS42NjQ5IDIzLjQ1MDNDMTIuMTA0NyAyNC4zMjk4IDEyLjY3MDIgMjQuNDU1NSAxMy4yMzU2IDIzLjM4NzRMMTYuMDYyOCAxNy44NTg2TDE4LjcwMTYgMjMuMzg3NEMxOS4yMDQyIDI0LjMyOTggMTkuNzA2OCAyNC4zOTI3IDIwLjIwOTQgMjMuMzg3NEwyNS42MTI2IDExLjE5OUMyNi4xMTUyIDEwLjEzMDkgMjYuODA2MyA5LjY5MTEgMjcuODc0MyA5LjY5MTFDMjggOS42OTExIDI4IDkuNjI4MjcgMjggOS41MDI2MlY5SDIyLjk3MzhMMjIuOTExIDkuMDYyODNWOS41MDI2MkMyMi45MTEgOS42MjgyNyAyMy4wMzY2IDkuNjkxMSAyMy4xNjIzIDkuNjkxMUMyMy43OTA2IDkuNjkxMSAyNC45ODQzIDkuODE2NzUgMjQuNDgxNyAxMC44ODQ4TDIwLjA4MzggMjEuMzE0MUwxOS44OTUzIDIxLjI1MTNMMTcuMTkzNyAxNS43MjI1TDE5LjUxODMgMTEuMTk5QzIwLjAyMDkgMTAuMjU2NSAyMC4xNDY2IDkuNjkxMSAyMS4wODkgOS42OTExQzIxLjIxNDcgOS42OTExIDIxLjM0MDMgOS42MjgyNyAyMS4zNDAzIDkuNTAyNjJWOS4wNjI4M0wyMS4yNzc1IDlIMTcuMjU2NUwxNy4xOTM3IDkuMDYyODNWOS41MDI2MkMxNy4xOTM3IDkuNjkxMSAxNy40NDUgOS42OTExIDE3LjYzMzUgOS42OTExQzE4Ljc2NDQgOS43NTM5MyAxOC42Mzg3IDEwLjE5MzcgMTguMjYxOCAxMC44ODQ4TDE2LjU2NTQgMTQuNDAzMUwxNC45OTQ4IDExLjEzNjFDMTQuNDI5MyAxMC4xMzA5IDE0LjMwMzcgOS44MTY3NSAxNS4xMjA0IDkuNzUzOTNDMTUuMzA4OSA5LjY5MTEgMTUuNjIzIDkuNjkxMSAxNS42MjMgOS41MDI2MlY5LjA2MjgzTDE1LjU2MDIgOUgxMS4yMjUxTDExLjE2MjMgOS4wNjI4M1Y5LjU2NTQ1QzExLjE2MjMgOS42OTExIDExLjI4OCA5LjY5MTEgMTEuNDc2NCA5LjY5MTFDMTIuMjMwNCA5LjgxNjc1IDEyLjIzMDQgOS44Nzk1OCAxMi45MjE1IDExLjMyNDZMMTUuNDM0NiAxNi42MDIxTDEzLjEwOTkgMjEuMzE0MUwxMi45MjE1IDIxLjI1MTNMOC4xNDY2IDEwLjc1OTJDNy42NDM5OCA5LjY5MTEgOC4yNzIyNSA5Ljc1MzkzIDkuMjc3NDkgOS42OTExQzkuNDY1OTcgOS42OTExIDkuNDY1OTcgOS42MjgyNyA5LjQ2NTk3IDkuNTAyNjJWOS4wNjI4M0w5LjQwMzE0IDlINFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=",
  facebook_dark: "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi44MDYzIDI3Ljg2NUMyMi41NzY3IDI2Ljk5MzggMjcgMjIuMDEzNSAyNyAxNkMyNyA5LjM3MjU4IDIxLjYyNzQgNCAxNSA0QzguMzcyNTggNCAzIDkuMzcyNTggMyAxNkMzIDIxLjkyMzEgNy4yOTEyNyAyNi44NDM4IDEyLjkzNDQgMjcuODIyOVYxOC40NDY1SDExVjE1LjE5MDZIMTIuOTM0NFYxMy4yMzU3QzEyLjkzNDQgMTAuNTc5NSAxNC4wMjY3IDkgMTcuMTI5OSA5SDE5LjcxMzVWMTIuMjU2M0gxOC4wOTg2QzE2Ljg5MDYgMTIuMjU2MyAxNi44MTA2IDEyLjcxMTQgMTYuODEwNiAxMy41NjA2TDE2LjgwNjMgMTUuMTkwMkgxOS43MzE4TDE5LjM4OTUgMTguNDQ2MkgxNi44MDYzVjI3Ljg2NVoiIGZpbGw9IiNmZmZmZmYiLz4KPC9zdmc+",
  instagram_dark: "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",
  twitter_dark: "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTIyLjk2OCA1SDI2LjY0OEwxOC41NjggMTQuMzM1OEwyOC4wMDggMjdIMjAuNkwxNC44IDE5LjMwNDFMOC4xNiAyN0g0LjQ4TDEzLjA0IDE3LjAxNDhMNCA1SDExLjU5MkwxNi44MzIgMTIuMDMwM0wyMi45NjggNVpNMjEuNjggMjQuODA4MUgyMy43MkwxMC41MiA3LjExMDdIOC4zMjhMMjEuNjggMjQuODA4MVoiIGZpbGw9IiNmZmZmZmYiLz4KPC9zdmc+",
  wikipedia_dark: "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTQgOVY5LjUwMjYyQzQgOS42MjgyNyA0LjA2MjgzIDkuNjkxMSA0LjI1MTMxIDkuNjkxMUM1LjUwNzg1IDkuNzUzOTMgNS41MDc4NSAxMC4wMDUyIDYuMDEwNDcgMTEuMTM2MUwxMS42NjQ5IDIzLjQ1MDNDMTIuMTA0NyAyNC4zMjk4IDEyLjY3MDIgMjQuNDU1NSAxMy4yMzU2IDIzLjM4NzRMMTYuMDYyOCAxNy44NTg2TDE4LjcwMTYgMjMuMzg3NEMxOS4yMDQyIDI0LjMyOTggMTkuNzA2OCAyNC4zOTI3IDIwLjIwOTQgMjMuMzg3NEwyNS42MTI2IDExLjE5OUMyNi4xMTUyIDEwLjEzMDkgMjYuODA2MyA5LjY5MTEgMjcuODc0MyA5LjY5MTFDMjggOS42OTExIDI4IDkuNjI4MjcgMjggOS41MDI2MlY5SDIyLjk3MzhMMjIuOTExIDkuMDYyODNWOS41MDI2MkMyMi45MTEgOS42MjgyNyAyMy4wMzY2IDkuNjkxMSAyMy4xNjIzIDkuNjkxMUMyMy43OTA2IDkuNjkxMSAyNC45ODQzIDkuODE2NzUgMjQuNDgxNyAxMC44ODQ4TDIwLjA4MzggMjEuMzE0MUwxOS44OTUzIDIxLjI1MTNMMTcuMTkzNyAxNS43MjI1TDE5LjUxODMgMTEuMTk5QzIwLjAyMDkgMTAuMjU2NSAyMC4xNDY2IDkuNjkxMSAyMS4wODkgOS42OTExQzIxLjIxNDcgOS42OTExIDIxLjM0MDMgOS42MjgyNyAyMS4zNDAzIDkuNTAyNjJWOS4wNjI4M0wyMS4yNzc1IDlIMTcuMjU2NUwxNy4xOTM3IDkuMDYyODNWOS41MDI2MkMxNy4xOTM3IDkuNjkxMSAxNy40NDUgOS42OTExIDE3LjYzMzUgOS42OTExQzE4Ljc2NDQgOS43NTM5MyAxOC42Mzg3IDEwLjE5MzcgMTguMjYxOCAxMC44ODQ4TDE2LjU2NTQgMTQuNDAzMUwxNC45OTQ4IDExLjEzNjFDMTQuNDI5MyAxMC4xMzA5IDE0LjMwMzcgOS44MTY3NSAxNS4xMjA0IDkuNzUzOTNDMTUuMzA4OSA5LjY5MTEgMTUuNjIzIDkuNjkxMSAxNS42MjMgOS41MDI2MlY5LjA2MjgzTDE1LjU2MDIgOUgxMS4yMjUxTDExLjE2MjMgOS4wNjI4M1Y5LjU2NTQ1QzExLjE2MjMgOS42OTExIDExLjI4OCA5LjY5MTEgMTEuNDc2NCA5LjY5MTFDMTIuMjMwNCA5LjgxNjc1IDEyLjIzMDQgOS44Nzk1OCAxMi45MjE1IDExLjMyNDZMMTUuNDM0NiAxNi42MDIxTDEzLjEwOTkgMjEuMzE0MUwxMi45MjE1IDIxLjI1MTNMOC4xNDY2IDEwLjc1OTJDNy42NDM5OCA5LjY5MTEgOC4yNzIyNSA5Ljc1MzkzIDkuMjc3NDkgOS42OTExQzkuNDY1OTcgOS42OTExIDkuNDY1OTcgOS42MjgyNyA5LjQ2NTk3IDkuNTAyNjJWOS4wNjI4M0w5LjQwMzE0IDlINFoiIGZpbGw9IiNmZmZmZmYiLz4KPC9zdmc+",
  web_dark: "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",
  youtube_dark: "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS4zNzYzIDguNTAxODFDMjYuNDA5NiA4Ljc3ODQgMjcuMjIxNiA5LjU5MDM5IDI3LjQ5ODIgMTAuNjIzNkMyNy45OTggMTIuNDk0NiAyOCAxNi40MDA0IDI4IDE2LjQwMDRDMjggMTYuNDAwNCAyOCAyMC4zMDYzIDI3LjQ5ODIgMjIuMTc3MkMyNy4yMjE2IDIzLjIxMDQgMjYuNDA5NiAyNC4wMjI0IDI1LjM3NjMgMjQuMjk5QzIzLjUwNTUgMjQuODAwOCAxNiAyNC44MDA4IDE2IDI0LjgwMDhDMTYgMjQuODAwOCA4LjQ5NDU3IDI0LjgwMDggNi42MjM2NCAyNC4yOTlDNS41OTAzOSAyNC4wMjI0IDQuNzc4NCAyMy4yMTA0IDQuNTAxODEgMjIuMTc3MkM0IDIwLjMwNjMgNCAxNi40MDA0IDQgMTYuNDAwNEM0IDE2LjQwMDQgNCAxMi40OTQ2IDQuNTAxODEgMTAuNjIzNkM0Ljc3ODQgOS41OTAzOSA1LjU5MDM5IDguNzc4NCA2LjYyMzY0IDguNTAxODFDOC40OTQ1NyA4IDE2IDggMTYgOEMxNiA4IDIzLjUwNTUgOCAyNS4zNzYzIDguNTAxODFaTTE5LjgzMjggMTYuNDAwN0wxMy41OTc3IDIwLjAwMDNWMTIuODAxMUwxOS44MzI4IDE2LjQwMDdaIiBmaWxsPSIjZmZmZmZmIi8+Cjwvc3ZnPg==",
  competition_placeholder: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzEyMTdfNDIxMzk3IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzEyMTdfNDIxMzk3KSI+CjxwYXRoIGQ9Ik00LjY2NjY3IDE0VjEyLjY2NjdINy4zMzMzM1YxMC42QzYuNzg4ODkgMTAuNDc3OCA2LjMwMjc4IDEwLjI0NzIgNS44NzUgOS45MDgzM0M1LjQ0NzIyIDkuNTY5NDQgNS4xMzMzMyA5LjE0NDQ0IDQuOTMzMzMgOC42MzMzM0M0LjEgOC41MzMzMyAzLjQwMjc4IDguMTY5NDQgMi44NDE2NyA3LjU0MTY3QzIuMjgwNTYgNi45MTM4OSAyIDYuMTc3NzggMiA1LjMzMzMzVjQuNjY2NjdDMiA0LjMgMi4xMzA1NiAzLjk4NjExIDIuMzkxNjcgMy43MjVDMi42NTI3OCAzLjQ2Mzg5IDIuOTY2NjcgMy4zMzMzMyAzLjMzMzMzIDMuMzMzMzNINC42NjY2N1YySDExLjMzMzNWMy4zMzMzM0gxMi42NjY3QzEzLjAzMzMgMy4zMzMzMyAxMy4zNDcyIDMuNDYzODkgMTMuNjA4MyAzLjcyNUMxMy44Njk0IDMuOTg2MTEgMTQgNC4zIDE0IDQuNjY2NjdWNS4zMzMzM0MxNCA2LjE3Nzc4IDEzLjcxOTQgNi45MTM4OSAxMy4xNTgzIDcuNTQxNjdDMTIuNTk3MiA4LjE2OTQ0IDExLjkgOC41MzMzMyAxMS4wNjY3IDguNjMzMzNDMTAuODY2NyA5LjE0NDQ0IDEwLjU1MjggOS41Njk0NCAxMC4xMjUgOS45MDgzM0M5LjY5NzIyIDEwLjI0NzIgOS4yMTExMSAxMC40Nzc4IDguNjY2NjcgMTAuNlYxMi42NjY3SDExLjMzMzNWMTRINC42NjY2N1pNNC42NjY2NyA3LjJWNC42NjY2N0gzLjMzMzMzVjUuMzMzMzNDMy4zMzMzMyA1Ljc1NTU2IDMuNDU1NTYgNi4xMzYxMSAzLjcgNi40NzVDMy45NDQ0NCA2LjgxMzg5IDQuMjY2NjcgNy4wNTU1NiA0LjY2NjY3IDcuMlpNOCA5LjMzMzMzQzguNTU1NTYgOS4zMzMzMyA5LjAyNzc4IDkuMTM4ODkgOS40MTY2NyA4Ljc1QzkuODA1NTYgOC4zNjExMSAxMCA3Ljg4ODg5IDEwIDcuMzMzMzNWMy4zMzMzM0g2VjcuMzMzMzNDNiA3Ljg4ODg5IDYuMTk0NDQgOC4zNjExMSA2LjU4MzMzIDguNzVDNi45NzIyMiA5LjEzODg5IDcuNDQ0NDQgOS4zMzMzMyA4IDkuMzMzMzNaTTExLjMzMzMgNy4yQzExLjczMzMgNy4wNTU1NiAxMi4wNTU2IDYuODEzODkgMTIuMyA2LjQ3NUMxMi41NDQ0IDYuMTM2MTEgMTIuNjY2NyA1Ljc1NTU2IDEyLjY2NjcgNS4zMzMzM1Y0LjY2NjY3SDExLjMzMzNWNy4yWiIgZmlsbD0iI0Q5RDlEOSIvPgo8L2c+Cjwvc3ZnPgo=",
  multisport_dropdown_white: "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",
  multisport_dropdown_black: "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",
  age_restriction: "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",
  whistle: "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkdhbWUgc3RhcnRzIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEzIDEwVjEySDRWMTQuMjY1TDExLjgwMiAxNS4zOEwxMi4wNzUgMTYuNzc1QzEyLjI3MDkgMTcuNzQ2NiAxMi44MjA1IDE4LjYxMSAxMy42MTcyIDE5LjIwMDdDMTQuNDEzOSAxOS43OTAzIDE1LjQwMTEgMjAuMDYzNCAxNi4zODc1IDE5Ljk2NjlDMTcuMzc0IDE5Ljg3MDQgMTguMjg5NiAxOS40MTEzIDE4Ljk1NyAxOC42Nzg1QzE5LjYyNDMgMTcuOTQ1NiAxOS45OTYgMTYuOTkxMiAyMCAxNkMyMCAxNC45MzkxIDE5LjU3ODYgMTMuOTIxNyAxOC44Mjg0IDEzLjE3MTZDMTguMDc4MyAxMi40MjE0IDE3LjA2MDkgMTIgMTYgMTJIMTVWMTBIMTZDMTcuMTM3IDEwLjAwMDIgMTguMjUwNiAxMC4zMjM1IDE5LjIxMSAxMC45MzIxQzIwLjE3MTMgMTEuNTQwOCAyMC45MzkgMTIuNDA5OSAyMS40MjQ1IDEzLjQzOEMyMS45MSAxNC40NjYyIDIyLjA5MzQgMTUuNjExMSAyMS45NTMzIDE2LjczOTVDMjEuODEzMSAxNy44Njc4IDIxLjM1NTMgMTguOTMzMSAyMC42MzMgMTkuODExM0MxOS45MTA4IDIwLjY4OTUgMTguOTUzOCAyMS4zNDQzIDE3Ljg3MzcgMjEuNjk5NkMxNi43OTM3IDIyLjA1NDkgMTUuNjM0OCAyMi4wOTU5IDE0LjUzMjMgMjEuODE4QzEzLjQyOTggMjEuNTQgMTIuNDI4OSAyMC45NTQ1IDExLjY0NjMgMjAuMTI5N0MxMC44NjM3IDE5LjMwNDggMTAuMzMxNiAxOC4yNzQ2IDEwLjExMiAxNy4xNTlMMy43MTcgMTYuMjQ1QzMuMjQwNDIgMTYuMTc2OSAyLjgwNDQgMTUuOTM5MSAyLjQ4OSAxNS41NzU0QzIuMTczNiAxNS4yMTE3IDEuOTk5OTcgMTQuNzQ2NCAyIDE0LjI2NVYxMkMyIDExLjQ2OTYgMi4yMTA3MSAxMC45NjA5IDIuNTg1NzkgMTAuNTg1OEMyLjk2MDg2IDEwLjIxMDcgMy40Njk1NyAxMCA0IDEwSDEzWk0xOC4wNiA1LjU1QzE4LjI0NTIgNS4zNjc0IDE4LjQ5NDkgNS4yNjUwNCAxOC43NTUgNS4yNjUwNEMxOS4wMTUxIDUuMjY1MDQgMTkuMjY0OCA1LjM2NzQgMTkuNDUgNS41NUMxOS44NCA1LjkzIDE5Ljg0IDYuNTYgMTkuNDUgNi45NEMxOC44MiA3LjU3IDE4LjkyIDcuNDggMTguMyA4LjExQzE4LjIwODUgOC4yMDI2NCAxOC4wOTk1IDguMjc2MTkgMTcuOTc5MyA4LjMyNjM5QzE3Ljg1OTIgOC4zNzY1OSAxNy43MzAyIDguNDAyNDQgMTcuNiA4LjQwMjQ0QzE3LjQ2OTggOC40MDI0NCAxNy4zNDA4IDguMzc2NTkgMTcuMjIwNyA4LjMyNjM5QzE3LjEwMDUgOC4yNzYxOSAxNi45OTE1IDguMjAyNjQgMTYuOSA4LjExTDE2Ljg5IDguMDlDMTYuNzk3NCA3Ljk5OTQ4IDE2LjcyMzkgNy44OTEzNyAxNi42NzM2IDcuNzcyMDJDMTYuNjIzNCA3LjY1MjY3IDE2LjU5NzUgNy41MjQ0OSAxNi41OTc1IDcuMzk1QzE2LjU5NzUgNy4yNjU1MSAxNi42MjM0IDcuMTM3MzMgMTYuNjczNiA3LjAxNzk4QzE2LjcyMzkgNi44OTg2MyAxNi43OTc0IDYuNzkwNTIgMTYuODkgNi43TDE4LjA2IDUuNTVaTTguNTcgNS41NEM4LjY2MDUyIDUuNDQ3NDEgOC43Njg2NCA1LjM3Mzg1IDguODg3OTggNS4zMjM2M0M5LjAwNzMzIDUuMjczNCA5LjEzNTUxIDUuMjQ3NTMgOS4yNjUgNS4yNDc1M0M5LjM5NDQ5IDUuMjQ3NTMgOS41MjI2NyA1LjI3MzQgOS42NDIwMiA1LjMyMzYzQzkuNzYxMzcgNS4zNzM4NSA5Ljg2OTQ4IDUuNDQ3NDEgOS45NiA1LjU0TDExLjExIDYuNzFDMTEuMjkyNiA2Ljg5NTI0IDExLjM5NSA3LjE0NDg5IDExLjM5NSA3LjQwNUMxMS4zOTUgNy42NjUxMSAxMS4yOTI2IDcuOTE0NzYgMTEuMTEgOC4xQzExLjAxODUgOC4xOTI2NCAxMC45MDk1IDguMjY2MTkgMTAuNzg5MyA4LjMxNjM5QzEwLjY2OTIgOC4zNjY1OSAxMC41NDAyIDguMzkyNDQgMTAuNDEgOC4zOTI0NEMxMC4yNzk4IDguMzkyNDQgMTAuMTUwOCA4LjM2NjU5IDEwLjAzMDcgOC4zMTYzOUM5LjkxMDUyIDguMjY2MTkgOS44MDE1MiA4LjE5MjY0IDkuNzEgOC4xQzkuMDkgNy40NyA5LjE4IDcuNTYgOC41NSA2Ljk0QzguMTYgNi41NiA4LjE2IDUuOTQgOC41NSA1LjU1TDguNTcgNS41NFpNMTQuMDIgMkMxNC41NiAyIDE1IDIuNDQgMTUgMi45OFY2LjAyQzE1IDYuNTYgMTQuNTYgNyAxNC4wMSA3SDEzLjk4QzEzLjQ0IDcgMTMgNi41NiAxMyA2LjAxVjIuOThDMTMgMi40NCAxMy40NCAyIDEzLjk5IDJIMTQuMDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=",
  whistle_dark: "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",
  penalty_goal: "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",
  dissallowed_penalty: "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",
  penalty_miss: "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",
  penalty_shootout_missed: "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",
  penalty_shootout_scored: "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",
  calendar: "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8bWFzayBpZD0ibWFzazBfMTgyM18xMDkxNjUiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CiAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNEOUQ5RDkiLz4KICA8L21hc2s+CiAgPGcgbWFzaz0idXJsKCNtYXNrMF8xODIzXzEwOTE2NSkiPgogICAgPHBhdGggZD0iTTUgMjJDNC40NSAyMiAzLjk3OTE3IDIxLjgwNDIgMy41ODc1IDIxLjQxMjVDMy4xOTU4MyAyMS4wMjA4IDMgMjAuNTUgMyAyMFY2QzMgNS40NSAzLjE5NTgzIDQuOTc5MTcgMy41ODc1IDQuNTg3NUMzLjk3OTE3IDQuMTk1ODMgNC40NSA0IDUgNEg2VjJIOFY0SDE2VjJIMThWNEgxOUMxOS41NSA0IDIwLjAyMDggNC4xOTU4MyAyMC40MTI1IDQuNTg3NUMyMC44MDQyIDQuOTc5MTcgMjEgNS40NSAyMSA2VjIwQzIxIDIwLjU1IDIwLjgwNDIgMjEuMDIwOCAyMC40MTI1IDIxLjQxMjVDMjAuMDIwOCAyMS44MDQyIDE5LjU1IDIyIDE5IDIySDVaTTUgMjBIMTlWMTBINVYyMFpNNSA4SDE5VjZINVY4WiIgZmlsbD0iIzhDOEM4QyIvPgogIDwvZz4KPC9zdmc+",
  venue: "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjE0MzIgMjAuNUgyMS44NTY3QzIyLjA3MjggMjAuNSAyMi4yODY5IDIwLjQ1NzQgMjIuNDg2NiAyMC4zNzQ3QzIyLjY4NjMgMjAuMjkyIDIyLjg2NzggMjAuMTcwNyAyMy4wMjA3IDIwLjAxNzlDMjMuMTczNSAxOS44NjUgMjMuMjk0OCAxOS42ODM1IDIzLjM3NzUgMTkuNDgzOEMyMy40NjAyIDE5LjI4NDEgMjMuNTAyOCAxOS4wNyAyMy41MDI4IDE4Ljg1MzlWNS4xNDYxM0MyMy41MDI4IDQuOTI5OTYgMjMuNDYwMiA0LjcxNTkgMjMuMzc3NSA0LjUxNjE4QzIzLjI5NDggNC4zMTY0NyAyMy4xNzM1IDQuMTM1IDIzLjAyMDcgMy45ODIxNEMyMi44Njc4IDMuODI5MjggMjIuNjg2MyAzLjcwODAzIDIyLjQ4NjYgMy42MjUzQzIyLjI4NjkgMy41NDI1OCAyMi4wNzI4IDMuNSAyMS44NTY3IDMuNUgyLjE0MzJDMS43MDY2MiAzLjUgMS4yODc5MiAzLjY3MzQzIDAuOTc5MjExIDMuOTgyMTRDMC42NzA1MDIgNC4yOTA4NSAwLjQ5NzA3IDQuNzA5NTUgMC40OTcwNyA1LjE0NjEzVjE4Ljg1MzlDMC40OTcwNyAxOS4yOTA1IDAuNjcwNTAyIDE5LjcwOTEgMC45NzkyMTEgMjAuMDE3OUMxLjI4NzkyIDIwLjMyNjYgMS43MDY2MiAyMC41IDIuMTQzMiAyMC41Wk0yLjAxMDQ5IDUuMDEzNDJDMi4wNDU2OSA0Ljk3ODIzIDIuMDkzNDMgNC45NTg0NSAyLjE0MzIgNC45NTg0NUgyMS44NTY3QzIxLjkwNjQgNC45NTg0NSAyMS45NTQyIDQuOTc4MjMgMjEuOTg5NCA1LjAxMzQyQzIyLjAyNDYgNS4wNDg2MiAyMi4wNDQzIDUuMDk2MzYgMjIuMDQ0MyA1LjE0NjEzVjE4Ljg1MzlDMjIuMDQ0MyAxOC45MDM2IDIyLjAyNDYgMTguOTUxNCAyMS45ODk0IDE4Ljk4NjZDMjEuOTU0MiAxOS4wMjE4IDIxLjkwNjQgMTkuMDQxNSAyMS44NTY3IDE5LjA0MTVIMi4xNDMyQzIuMDkzNDMgMTkuMDQxNSAyLjA0NTY5IDE5LjAyMTggMi4wMTA0OSAxOC45ODY2QzEuOTc1MyAxOC45NTE0IDEuOTU1NTIgMTguOTAzNiAxLjk1NTUyIDE4Ljg1MzlWNS4xNDYxM0MxLjk1NTUyIDUuMDk2MzYgMS45NzUzIDUuMDQ4NjIgMi4wMTA0OSA1LjAxMzQyWiIgZmlsbD0iIzhDOEM4QyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjk5OTkgMTUuMDAwOUwxMi4wMDA4IDE1LjAwMDlDMTIuNzk2IDE0Ljk5OTQgMTMuNTU4MiAxNC42ODI5IDE0LjEyMDUgMTQuMTIwNkMxNC42ODI4IDEzLjU1ODMgMTQuOTk5MyAxMi43OTYxIDE1LjAwMDcgMTIuMDAwOVYxMkMxNS4wMDA3IDExLjQwNjUgMTQuODI0NyAxMC44MjYzIDE0LjQ5NSAxMC4zMzI4QzE0LjE2NTMgOS44MzkzMyAxMy42OTY2IDkuNDU0NyAxMy4xNDgzIDkuMjI3NTdDMTIuNTk5OSA5LjAwMDQ1IDExLjk5NjYgOC45NDEwMiAxMS40MTQ0IDkuMDU2ODFDMTAuODMyMyA5LjE3MjYgMTAuMjk3NiA5LjQ1ODQgOS44Nzc5NiA5Ljg3ODA4QzkuNDU4MjggMTAuMjk3OCA5LjE3MjQ3IDEwLjgzMjUgOS4wNTY2OSAxMS40MTQ2QzguOTQwOSAxMS45OTY3IDkuMDAwMzIgMTIuNjAwMSA5LjIyNzQ1IDEzLjE0ODRDOS40NTQ1OCAxMy42OTY3IDkuODM5MjEgMTQuMTY1NCAxMC4zMzI3IDE0LjQ5NTFDMTAuODI2MiAxNC44MjQ5IDExLjQwNjQgMTUuMDAwOSAxMS45OTk5IDE1LjAwMDlaTTE0LjUwMDcgMTIuMDAyMkwxNC41MDA3IDEyLjAwMThMMTQuNTAwNyAxMi4wMDE2QzE0LjUwMDcgMTIuMDAxOCAxNC41MDA3IDEyLjAwMiAxNC41MDA3IDEyLjAwMjJaTTE0LjA0MjMgMTJWMTIuMDAwMVpNMTMuMDg5OSAxMC45MTIzQzEyLjgwMDcgMTAuNjIzMSAxMi40MDg2IDEwLjQ2MDQgMTEuOTk5NiAxMC40NTk5QzExLjY5NDcgMTAuNDU5OSAxMS4zOTY1IDEwLjU1MDQgMTEuMTQzIDEwLjcxOThDMTAuODg5MyAxMC44ODkzIDEwLjY5MTYgMTEuMTMwMiAxMC41NzQ5IDExLjQxMkMxMC40NTgxIDExLjY5MzkgMTAuNDI3NiAxMi4wMDQgMTAuNDg3MSAxMi4zMDMyQzEwLjU0NjYgMTIuNjAyNCAxMC42OTM1IDEyLjg3NzIgMTAuOTA5MiAxMy4wOTI5QzExLjEyNDkgMTMuMzA4NyAxMS4zOTk4IDEzLjQ1NTYgMTEuNjk5IDEzLjUxNTFDMTEuOTk4MiAxMy41NzQ2IDEyLjMwODMgMTMuNTQ0IDEyLjU5MDEgMTMuNDI3M0MxMi44NzIgMTMuMzEwNiAxMy4xMTI5IDEzLjExMjkgMTMuMjgyMyAxMi44NTkyQzEzLjQ1MTggMTIuNjA1NiAxMy41NDIzIDEyLjMwNzUgMTMuNTQyMyAxMi4wMDI1QzEzLjU0MTcgMTEuNTkzNSAxMy4zNzkgMTEuMjAxNSAxMy4wODk5IDEwLjkxMjNaIiBmaWxsPSIjOEM4QzhDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNDg0MyAyMC4yODY0QzExLjYyMTEgMjAuNDIzMiAxMS44MDY2IDIwLjUgMTIgMjAuNUMxMi4xOTM0IDIwLjUgMTIuMzc4OSAyMC40MjMyIDEyLjUxNTYgMjAuMjg2NEMxMi42NTI0IDIwLjE0OTcgMTIuNzI5MiAxOS45NjQyIDEyLjcyOTIgMTkuNzcwOFY0LjIyOTIzQzEyLjcyOTIgNC4wMzU4MiAxMi42NTI0IDMuODUwMzQgMTIuNTE1NiAzLjcxMzU5QzEyLjM3ODkgMy41NzY4MyAxMi4xOTM0IDMuNSAxMiAzLjVDMTEuODA2NiAzLjUgMTEuNjIxMSAzLjU3NjgzIDExLjQ4NDMgMy43MTM1OUMxMS4zNDc2IDMuODUwMzQgMTEuMjcwOCA0LjAzNTgyIDExLjI3MDggNC4yMjkyM1YxOS43NzA4QzExLjI3MDggMTkuOTY0MiAxMS4zNDc2IDIwLjE0OTcgMTEuNDg0MyAyMC4yODY0WiIgZmlsbD0iIzhDOEM4QyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMzA1MDkgMTMuNzc4NUgxLjk1NTUyVjEwLjIzMDdIMy4zMDUwOVYxMy43Nzg1Wk0xLjIyNjMgMTUuMjM3SDQuMDM0MzJDNC4yMjc3MiAxNS4yMzcgNC40MTMyIDE1LjE2MDEgNC41NDk5NiAxNS4wMjM0QzQuNjg2NzIgMTQuODg2NiA0Ljc2MzU1IDE0LjcwMTEgNC43NjM1NSAxNC41MDc3VjkuNTAxNDRDNC43NjM1NSA5LjMwODA0IDQuNjg2NzIgOS4xMjI1NiA0LjU0OTk2IDguOTg1OEM0LjQxMzIgOC44NDkwNCA0LjIyNzcyIDguNzcyMjIgNC4wMzQzMiA4Ljc3MjIySDEuMjI2M0MxLjAzMjg5IDguNzcyMjIgMC44NDc0MTMgOC44NDkwNCAwLjcxMDY1NiA4Ljk4NThDMC41NzM4OTkgOS4xMjI1NiAwLjQ5NzA3IDkuMzA4MDQgMC40OTcwNyA5LjUwMTQ0VjE0LjUwNzdDMC40OTcwNyAxNC43MDExIDAuNTczODk5IDE0Ljg4NjYgMC43MTA2NTYgMTUuMDIzNEMwLjg0NzQxMyAxNS4xNjAxIDEuMDMyODkgMTUuMjM3IDEuMjI2MyAxNS4yMzdaIiBmaWxsPSIjOEM4QzhDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjIuMDQ0NCAxMy43Nzg1SDIwLjY5NDhWMTAuMjMwN0gyMi4wNDQ0VjEzLjc3ODVaTTE5Ljk2NTYgMTUuMjM3SDIyLjc3MzZDMjIuOTY3IDE1LjIzNyAyMy4xNTI1IDE1LjE2MDEgMjMuMjg5MiAxNS4wMjM0QzIzLjQyNiAxNC44ODY2IDIzLjUwMjggMTQuNzAxMSAyMy41MDI4IDE0LjUwNzdWOS41MDE0NEMyMy41MDI4IDkuMzA4MDQgMjMuNDI2IDkuMTIyNTYgMjMuMjg5MiA4Ljk4NThDMjMuMTUyNSA4Ljg0OTA0IDIyLjk2NyA4Ljc3MjIyIDIyLjc3MzYgOC43NzIyMkgxOS45NjU2QzE5Ljc3MjIgOC43NzIyMiAxOS41ODY3IDguODQ5MDQgMTkuNDQ5OSA4Ljk4NThDMTkuMzEzMiA5LjEyMjU2IDE5LjIzNjMgOS4zMDgwNCAxOS4yMzYzIDkuNTAxNDRWMTQuNTA3N0MxOS4yMzYzIDE0LjcwMTEgMTkuMzEzMiAxNC44ODY2IDE5LjQ0OTkgMTUuMDIzNEMxOS41ODY3IDE1LjE2MDEgMTkuNzcyMiAxNS4yMzcgMTkuOTY1NiAxNS4yMzdaIiBmaWxsPSIjOEM4QzhDIi8+Cjwvc3ZnPgo=",
  referee_whistle: "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",
  attendance: "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",
  competition: "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImVtb2ppX2V2ZW50cyI+CjxtYXNrIGlkPSJtYXNrMF8xODIzXzEwOTIxMSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KPHJlY3QgaWQ9IkJvdW5kaW5nIGJveCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8xODIzXzEwOTIxMSkiPgo8cGF0aCBpZD0iZW1vamlfZXZlbnRzXzIiIGQ9Ik03IDIxVjE5SDExVjE1LjlDMTAuMTgzMyAxNS43MTY3IDkuNDU0MTcgMTUuMzcwOCA4LjgxMjUgMTQuODYyNUM4LjE3MDgzIDE0LjM1NDIgNy43IDEzLjcxNjcgNy40IDEyLjk1QzYuMTUgMTIuOCA1LjEwNDE3IDEyLjI1NDIgNC4yNjI1IDExLjMxMjVDMy40MjA4MyAxMC4zNzA4IDMgOS4yNjY2NyAzIDhWN0MzIDYuNDUgMy4xOTU4MyA1Ljk3OTE3IDMuNTg3NSA1LjU4NzVDMy45NzkxNyA1LjE5NTgzIDQuNDUgNSA1IDVIN1YzSDE3VjVIMTlDMTkuNTUgNSAyMC4wMjA4IDUuMTk1ODMgMjAuNDEyNSA1LjU4NzVDMjAuODA0MiA1Ljk3OTE3IDIxIDYuNDUgMjEgN1Y4QzIxIDkuMjY2NjcgMjAuNTc5MiAxMC4zNzA4IDE5LjczNzUgMTEuMzEyNUMxOC44OTU4IDEyLjI1NDIgMTcuODUgMTIuOCAxNi42IDEyLjk1QzE2LjMgMTMuNzE2NyAxNS44MjkyIDE0LjM1NDIgMTUuMTg3NSAxNC44NjI1QzE0LjU0NTggMTUuMzcwOCAxMy44MTY3IDE1LjcxNjcgMTMgMTUuOVYxOUgxN1YyMUg3Wk03IDEwLjhWN0g1VjhDNSA4LjYzMzMzIDUuMTgzMzMgOS4yMDQxNyA1LjU1IDkuNzEyNUM1LjkxNjY3IDEwLjIyMDggNi40IDEwLjU4MzMgNyAxMC44Wk0xMiAxNEMxMi44MzMzIDE0IDEzLjU0MTcgMTMuNzA4MyAxNC4xMjUgMTMuMTI1QzE0LjcwODMgMTIuNTQxNyAxNSAxMS44MzMzIDE1IDExVjVIOVYxMUM5IDExLjgzMzMgOS4yOTE2NyAxMi41NDE3IDkuODc1IDEzLjEyNUMxMC40NTgzIDEzLjcwODMgMTEuMTY2NyAxNCAxMiAxNFpNMTcgMTAuOEMxNy42IDEwLjU4MzMgMTguMDgzMyAxMC4yMjA4IDE4LjQ1IDkuNzEyNUMxOC44MTY3IDkuMjA0MTcgMTkgOC42MzMzMyAxOSA4VjdIMTdWMTAuOFoiIGZpbGw9IiM4QzhDOEMiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=",
  age_restriction_black: "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",
  age_restriction_white: "PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTMiIGZpbGw9IiNEOUQ5RDkiLz4KPHBhdGggZD0iTTE4LjA0MSAxMy45MTAySDE1Ljc3MzRWMTMuMDMxMkgxOC4wNDFWMTAuNzUySDE4LjkxOTlWMTMuMDMxMkgyMS4xODc1VjEzLjkxMDJIMTguOTE5OVYxNi4xNjZIMTguMDQxVjEzLjkxMDJaIiBmaWxsPSIjOEM4QzhDIi8+CjxwYXRoIGQ9Ik0xMi44NzcgOUMxMy4yMDUxIDkgMTMuNTEzNyA5LjA0Mjk3IDEzLjgwMjcgOS4xMjg5MUMxNC4wOTU3IDkuMjE0ODQgMTQuMzUxNiA5LjM0Mzc1IDE0LjU3MDMgOS41MTU2MkMxNC43OTMgOS42ODc1IDE0Ljk2ODggOS45MDIzNCAxNS4wOTc3IDEwLjE2MDJDMTUuMjI2NiAxMC40MTggMTUuMjkxIDEwLjcxODggMTUuMjkxIDExLjA2MjVDMTUuMjkxIDExLjMyNDIgMTUuMjUyIDExLjU2MDUgMTUuMTczOCAxMS43NzE1QzE1LjA5NTcgMTEuOTgyNCAxNC45ODgzIDEyLjE3MzggMTQuODUxNiAxMi4zNDU3QzE0LjcxNDggMTIuNTEzNyAxNC41NTI3IDEyLjY2NiAxNC4zNjUyIDEyLjgwMjdDMTQuMTc3NyAxMi45MzU1IDEzLjk3NDYgMTMuMDU2NiAxMy43NTU5IDEzLjE2NkMxMy45ODI0IDEzLjI4NzEgMTQuMjAzMSAxMy40MjE5IDE0LjQxOCAxMy41NzAzQzE0LjYzNjcgMTMuNzE4OCAxNC44MzAxIDEzLjg4NjcgMTQuOTk4IDE0LjA3NDJDMTUuMTY5OSAxNC4yNTc4IDE1LjMwNjYgMTQuNDY0OCAxNS40MDgyIDE0LjY5NTNDMTUuNTEzNyAxNC45MjU4IDE1LjU2NjQgMTUuMTgzNiAxNS41NjY0IDE1LjQ2ODhDMTUuNTY2NCAxNS44MjgxIDE1LjUgMTYuMTU0MyAxNS4zNjcyIDE2LjQ0NzNDMTUuMjM4MyAxNi43MzYzIDE1LjA1NDcgMTYuOTgyNCAxNC44MTY0IDE3LjE4NTVDMTQuNTgyIDE3LjM4ODcgMTQuMjk4OCAxNy41NDQ5IDEzLjk2NjggMTcuNjU0M0MxMy42Mzg3IDE3Ljc2MzcgMTMuMjc1NCAxNy44MTg0IDEyLjg3NyAxNy44MTg0QzEyLjQ0NzMgMTcuODE4NCAxMi4wNjQ1IDE3Ljc2NTYgMTEuNzI4NSAxNy42NjAyQzExLjM5NjUgMTcuNTU0NyAxMS4xMTUyIDE3LjQwNDMgMTAuODg0OCAxNy4yMDlDMTAuNjU4MiAxNy4wMDk4IDEwLjQ4NDQgMTYuNzY3NiAxMC4zNjMzIDE2LjQ4MjRDMTAuMjQ2MSAxNi4xOTczIDEwLjE4NzUgMTUuODc1IDEwLjE4NzUgMTUuNTE1NkMxMC4xODc1IDE1LjIyMjcgMTAuMjMwNSAxNC45NTkgMTAuMzE2NCAxNC43MjQ2QzEwLjQwNjIgMTQuNDkwMiAxMC41MjU0IDE0LjI3OTMgMTAuNjczOCAxNC4wOTE4QzEwLjgyMjMgMTMuOTA0MyAxMC45OTggMTMuNzM4MyAxMS4yMDEyIDEzLjU5MzhDMTEuNDA0MyAxMy40NDkyIDExLjYxOTEgMTMuMzIyMyAxMS44NDU3IDEzLjIxMjlDMTEuNjU0MyAxMy4wOTE4IDExLjQ3NDYgMTIuOTYwOSAxMS4zMDY2IDEyLjgyMDNDMTEuMTM4NyAxMi42NzU4IDEwLjk5MjIgMTIuNTE1NiAxMC44NjcyIDEyLjMzOThDMTAuNzQ2MSAxMi4xNjQxIDEwLjY0ODQgMTEuOTcwNyAxMC41NzQyIDExLjc1OThDMTAuNTAzOSAxMS41NDQ5IDEwLjQ2ODggMTEuMzA4NiAxMC40Njg4IDExLjA1MDhDMTAuNDY4OCAxMC43MTA5IDEwLjUzMzIgMTAuNDE0MSAxMC42NjIxIDEwLjE2MDJDMTAuNzk0OSA5LjkwMjM0IDEwLjk3MjcgOS42ODc1IDExLjE5NTMgOS41MTU2MkMxMS40MTggOS4zNDM3NSAxMS42NzM4IDkuMjE0ODQgMTEuOTYyOSA5LjEyODkxQzEyLjI1NTkgOS4wNDI5NyAxMi41NjA1IDkgMTIuODc3IDlaTTExLjIzNjMgMTUuNTI3M0MxMS4yMzYzIDE1LjczNDQgMTEuMjY3NiAxNS45MjU4IDExLjMzMDEgMTYuMTAxNkMxMS4zOTI2IDE2LjI3MzQgMTEuNDkwMiAxNi40MjE5IDExLjYyMyAxNi41NDY5QzExLjc1NTkgMTYuNjY4IDExLjkyMzggMTYuNzYzNyAxMi4xMjcgMTYuODM0QzEyLjMzMDEgMTYuOTAwNCAxMi41NzIzIDE2LjkzMzYgMTIuODUzNSAxNi45MzM2QzEzLjEyNyAxNi45MzM2IDEzLjM2NzIgMTYuOTAwNCAxMy41NzQyIDE2LjgzNEMxMy43ODUyIDE2Ljc2MzcgMTMuOTYwOSAxNi42NjYgMTQuMTAxNiAxNi41NDFDMTQuMjQyMiAxNi40MTIxIDE0LjM0NzcgMTYuMjU3OCAxNC40MTggMTYuMDc4MUMxNC40ODgzIDE1Ljg5ODQgMTQuNTIzNCAxNS42OTkyIDE0LjUyMzQgMTUuNDgwNUMxNC41MjM0IDE1LjI3NzMgMTQuNDg0NCAxNS4wOTM4IDE0LjQwNjIgMTQuOTI5N0MxNC4zMzIgMTQuNzY1NiAxNC4yMjI3IDE0LjYxMzMgMTQuMDc4MSAxNC40NzI3QzEzLjkzNzUgMTQuMzMyIDEzLjc2NzYgMTQuMTk5MiAxMy41Njg0IDE0LjA3NDJDMTMuMzY5MSAxMy45NDkyIDEzLjE0NjUgMTMuODI2MiAxMi45MDA0IDEzLjcwNTFMMTIuNzI0NiAxMy42MjNDMTIuMjMyNCAxMy44NTc0IDExLjg2MTMgMTQuMTI3IDExLjYxMTMgMTQuNDMxNkMxMS4zNjEzIDE0LjczMjQgMTEuMjM2MyAxNS4wOTc3IDExLjIzNjMgMTUuNTI3M1pNMTIuODY1MiA5Ljg5MDYyQzEyLjQ1MTIgOS44OTA2MiAxMi4xMjExIDkuOTk0MTQgMTEuODc1IDEwLjIwMTJDMTEuNjMyOCAxMC40MDgyIDExLjUxMTcgMTAuNzA5IDExLjUxMTcgMTEuMTAzNUMxMS41MTE3IDExLjMyNjIgMTEuNTQ0OSAxMS41MTc2IDExLjYxMTMgMTEuNjc3N0MxMS42ODE2IDExLjgzNzkgMTEuNzc3MyAxMS45ODA1IDExLjg5ODQgMTIuMTA1NUMxMi4wMTk1IDEyLjIzMDUgMTIuMTY0MSAxMi4zNDM4IDEyLjMzMiAxMi40NDUzQzEyLjUwMzkgMTIuNTQzIDEyLjY4OTUgMTIuNjM4NyAxMi44ODg3IDEyLjczMjRDMTMuMDc2MiAxMi42NDY1IDEzLjI1MiAxMi41NTI3IDEzLjQxNiAxMi40NTEyQzEzLjU4NCAxMi4zNDk2IDEzLjcyODUgMTIuMjM0NCAxMy44NDk2IDEyLjEwNTVDMTMuOTc0NiAxMS45NzY2IDE0LjA3MjMgMTEuODMwMSAxNC4xNDI2IDExLjY2NkMxNC4yMTI5IDExLjUwMiAxNC4yNDggMTEuMzE0NSAxNC4yNDggMTEuMTAzNUMxNC4yNDggMTAuNzA5IDE0LjEyNSAxMC40MDgyIDEzLjg3ODkgMTAuMjAxMkMxMy42MzI4IDkuOTk0MTQgMTMuMjk0OSA5Ljg5MDYyIDEyLjg2NTIgOS44OTA2MloiIGZpbGw9IiM4QzhDOEMiLz4KPHBhdGggZD0iTTguMTIzMDUgMTcuNzAxMkg3LjA5MThWMTIuMzUxNkM3LjA5MTggMTIuMTgzNiA3LjA5MTggMTIuMDAzOSA3LjA5MTggMTEuODEyNUM3LjA5NTcgMTEuNjIxMSA3LjA5OTYxIDExLjQzMTYgNy4xMDM1MiAxMS4yNDQxQzcuMTExMzMgMTEuMDUyNyA3LjExNzE5IDEwLjg3MTEgNy4xMjEwOSAxMC42OTkyQzcuMTI4OTEgMTAuNTIzNCA3LjEzNDc3IDEwLjM2OTEgNy4xMzg2NyAxMC4yMzYzQzcuMDcyMjcgMTAuMzA2NiA3LjAxMzY3IDEwLjM2NzIgNi45NjI4OSAxMC40MThDNi45MTIxMSAxMC40Njg4IDYuODU5MzggMTAuNTE3NiA2LjgwNDY5IDEwLjU2NDVDNi43NTM5MSAxMC42MTEzIDYuNjk5MjIgMTAuNjYyMSA2LjY0MDYyIDEwLjcxNjhDNi41ODIwMyAxMC43Njc2IDYuNTExNzIgMTAuODI4MSA2LjQyOTY5IDEwLjg5ODRMNS41NjI1IDExLjYwNzRMNSAxMC44ODY3TDcuMjQ0MTQgOS4xMzQ3N0g4LjEyMzA1VjE3LjcwMTJaIiBmaWxsPSIjOEM4QzhDIi8+Cjwvc3ZnPgo="
};
var getIconAsBgImage = (iconName) => {
  if (!ICONS_BASE64[iconName]) {
    return;
  }
  return "data:image/svg+xml;base64," + ICONS_BASE64[iconName];
};
var getIconBasedOnEventType = (eventType, theme) => {
  switch (eventType) {
    case EventTypeCode.YELLOW_CARD:
      return getIconAsBgImage("yellow");
    case EventTypeCode.RED_CARD:
      return getIconAsBgImage("red");
    case EventTypeCode.YELLOW_CARD_RED:
      return getIconAsBgImage("yellow-red");
    case EventTypeCode.KICKOFF:
      return theme === THEME_VARIANTS.DARK ? getIconAsBgImage("whistle") : getIconAsBgImage("whistle_dark");
    case EventTypeCode.OWN_GOAL:
      return getIconAsBgImage("own-goal");
    default:
      return getIconAsBgImage(eventType.toLocaleLowerCase());
  }
};

// src/general.ts
import { Buffer as Buffer2 } from "buffer";
var removeEmptyValuesFromArray = (arr) => {
  if (arr && arr.length > 0) {
    return arr.filter((item) => item !== void 0 && item !== null && item !== "");
  }
  return arr;
};
var areWidgetsRendered = (widgetIds) => {
  return widgetIds.every((widgetId) => isVisible(widgetId));
  function isVisible(dataId) {
    const el = document.querySelector(`[data-id="${dataId}"]`);
    const elShadowRoot = el == null ? void 0 : el.shadowRoot;
    const elShadowRootChildrens = (elShadowRoot == null ? void 0 : elShadowRoot.childNodes) ? [...elShadowRoot.childNodes] : [];
    const elShadowRootIsDivChildren = elShadowRootChildrens.some((child) => (child == null ? void 0 : child.nodeName) === "DIV");
    return elShadowRootIsDivChildren;
  }
};
var isInStorybook = () => {
  return window.location.pathname.includes("/iframe.html");
};

// src/abbreviateName.ts
var shortenName = (name) => name.slice(0, 1) + ".";
function abbreviateName_default(name) {
  const nameParts = name.split(" ");
  return `${nameParts.map((part, i2) => i2 === nameParts.length - 1 ? part : shortenName(part)).join(" ")}`;
}

// src/labels.ts
var DEFAULT_HEADER_LABELS = {
  [HeaderLabels.OVERTIME]: "OT",
  [HeaderLabels.POINTS]: "PTS",
  [HeaderLabels.SCORE]: "S"
};
var getScoreHeader = (dataLabels, labelKey) => {
  var _a, _b;
  let headerLabel = (_b = (_a = dataLabels == null ? void 0 : dataLabels[labelKey]) != null ? _a : DEFAULT_HEADER_LABELS[labelKey]) != null ? _b : labelKey;
  headerLabel = headerLabel.toString().split(" ")[0];
  return headerLabel;
};

// src/breakText.tsx
import React from "react";
function breakText(text) {
  const words = text.split(" ");
  return words.map((word, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, word, index !== words.length - 1 && /* @__PURE__ */ React.createElement("br", null)));
}
var breakText_default = breakText;

// src/getDefaultShortLabel.ts
var getDefaultShortValue = (value) => {
  switch (value) {
    case "age":
      return "AGE";
    case "matches_played":
      return "P";
    case "minutes":
      return "M";
    case "yellow_cards":
      return "YC";
    case "red_cards":
      return "RC";
    case "goals":
      return "G";
    case "assists":
      return "A";
    case "conceded":
      return "GC";
    case "cleansheets":
      return "CS";
    case "started":
      return "S";
    case "minutes_substitute":
      return "MS";
    case "goals_substitute":
      return "GS";
    case "substitute_in":
      return "SI";
    case "substitute_out":
      return "SO";
    default:
      return "";
  }
};
var getDefaultShortLabel_default = getDefaultShortValue;

// src/getMatchMinutes.ts
var getMatchMinutes = ({ regularTime, injuryTime }) => {
  if (injuryTime) {
    return `${regularTime}+${injuryTime}'`;
  }
  return `${regularTime}'`;
};

// src/classnames.ts
var hasOwn = {}.hasOwnProperty;
function classNames(...args) {
  let classes = "";
  for (let i2 = 0; i2 < args.length; i2++) {
    const arg = args[i2];
    if (arg) {
      classes = appendClass(classes, parseValue(arg));
    }
  }
  return classes;
}
function parseValue(arg) {
  if (typeof arg === "string") {
    return arg;
  }
  if (typeof arg !== "object") {
    return "";
  }
  if (Array.isArray(arg)) {
    return classNames(...arg);
  }
  if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
    return arg.toString();
  }
  let classes = "";
  for (const key in arg) {
    if (hasOwn.call(arg, key) && arg[key]) {
      classes = appendClass(classes, key);
    }
  }
  return classes;
}
function appendClass(value, newClass) {
  if (!newClass) {
    return value;
  }
  return value ? value + " " + newClass : newClass;
}

// ../constants/assetsPlaceholder.ts
var assetsPlaceholder = {
  empty: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
  participantPlayer: "data:image/png;base64,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",
  team: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzkyMV83MTIzMSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF85MjFfNzEyMzEpIj4KPHBhdGggZD0iTTEyIDIyQzkuNjgzMzMgMjEuNDE2NyA3Ljc3MDgzIDIwLjA4NzUgNi4yNjI1IDE4LjAxMjVDNC43NTQxNyAxNS45Mzc1IDQgMTMuNjMzMyA0IDExLjFWNUwxMiAyTDIwIDVWMTEuMUMyMCAxMy42MzMzIDE5LjI0NTggMTUuOTM3NSAxNy43Mzc1IDE4LjAxMjVDMTYuMjI5MiAyMC4wODc1IDE0LjMxNjcgMjEuNDE2NyAxMiAyMlpNMTIgMTkuOUMxMy43MzMzIDE5LjM1IDE1LjE2NjcgMTguMjUgMTYuMyAxNi42QzE3LjQzMzMgMTQuOTUgMTggMTMuMTE2NyAxOCAxMS4xVjYuMzc1TDEyIDQuMTI1TDYgNi4zNzVWMTEuMUM2IDEzLjExNjcgNi41NjY2NyAxNC45NSA3LjcgMTYuNkM4LjgzMzMzIDE4LjI1IDEwLjI2NjcgMTkuMzUgMTIgMTkuOVoiIGZpbGw9IiM4QzhDOEMiLz4KPC9nPgo8L3N2Zz4K",
  tournament: "data:image/png;base64,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",
  country: "data:image/png;base64,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",
  competition: "data:image/png;base64,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",
  tennisServer: "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9IiNmZmY2NDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogICAgPHBhdGggZD0iTTI5LjcyNSAxNmMwLjUxNSAwIDEuMDIyIDAuMDI5IDEuNTIzIDAuMDg0LTAuMDQ0IDguMzg0LTYuODU1IDE1LjE2Ni0xNS4yNDggMTUuMTY2aDAuMDg0Yy0wLjA1NS0wLjUwMi0wLjA4NC0xLjAwOS0wLjA4NC0xLjUyNSAwLTcuNTc5IDYuMTQ2LTEzLjcyNSAxMy43MjUtMTMuNzI1ek0xNy40NTUgMC44MTljNy4yNjEgMC42ODYgMTMuMDM5IDYuNDY2IDEzLjcyNyAxMy43MjUtMC40OC0wLjA0Ni0wLjk2NS0wLjA2OS0xLjQ1Ni0wLjA2OS04LjQyMyAwLTE1LjI1IDYuODI3LTE1LjI1IDE1LjI1IDAgMC40OTEgMC4wMjMgMC45NzYgMC4wNjkgMS40NTYtNy4yNTktMC42ODYtMTMuMDM3LTYuNDY2LTEzLjcyNS0xMy43MjUgMC40OCAwLjA0NiAwLjk2NSAwLjA2OSAxLjQ1NiAwLjA2OSA4LjQyMyAwIDE1LjI1LTYuODI3IDE1LjI1LTE1LjI1IDAtMC40MjctMC4wMTgtMC44NTMtMC4wNTItMS4yNzJ6TTE1LjkxNiAwLjc1YzAuMDU1IDAuNTAzIDAuMDg0IDEuMDEwIDAuMDg0IDEuNTI1IDAgNy41NzktNi4xNDYgMTMuNzI1LTEzLjcyNSAxMy43MjUtMC41MTUgMC0xLjAyMi0wLjAyOS0xLjUyNC0wLjA4NCAwLjA0Ni04LjM4NCA2Ljg1NS0xNS4xNjYgMTUuMjQ4LTE1LjE2NnoiPjwvcGF0aD4NCjwvc3ZnPg==",
  tennisParticipant: "data:image/png;base64,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"
};

// ../constants/sportRegions.ts
var NATIONAL = "national";

// src/images.ts
var setNationalParticipantBorder = (isNational) => {
  if (!isNational) {
    return {};
  }
  return {
    br: "$round",
    borderRadius: "$radii$round",
    border: "1px solid $countryLogoBorderColor"
  };
};
var isNationalParticipant = (team) => {
  return (team == null ? void 0 : team.type) === NATIONAL || (team == null ? void 0 : team.type) === NATIONAL.toLocaleUpperCase();
};
var isPlaceholderImage = (participantImage) => {
  return participantImage ? participantImage.startsWith("data:image/") : false;
};
var checkIsPlaceholderOrSetBorder = (participantImage) => {
  if (isPlaceholderImage(participantImage)) {
    return {};
  }
  return setNationalParticipantBorder(true);
};
var setParticipantBorder = (team, participantImage) => {
  if (isPlaceholderImage(participantImage) || !isNationalParticipant(team)) {
    return {};
  }
  return setNationalParticipantBorder(true);
};

// src/getOddsParams.ts
var getOddsParams = ({
  dataConfigOddClient,
  dataOddsDisplay,
  dataOddsMarketValueType,
  dataOddsMarket,
  dataOddsPreEventOnly
}) => {
  return dataOddsDisplay ? {
    oddClient: dataConfigOddClient != null ? dataConfigOddClient : "sportal",
    oddFormat: dataOddsMarketValueType,
    marketTypes: dataOddsMarket,
    oddType: dataOddsPreEventOnly ? OddsTypes.PRE_EVENT : OddsTypes.ALL
  } : {};
};

// src/getTabValue.ts
var TAB_OPTIONS;
(function(TAB_OPTIONS2) {
  TAB_OPTIONS2["ALL"] = "ALL";
  TAB_OPTIONS2["POPULAR"] = "POPULAR";
  TAB_OPTIONS2["UPCOMING"] = "UPCOMING";
  TAB_OPTIONS2["LIVE"] = "LIVE";
  TAB_OPTIONS2["FINISHED"] = "FINISHED";
  TAB_OPTIONS2["ODDS"] = "ODDS";
})(TAB_OPTIONS || (TAB_OPTIONS = {}));
var getTabValue = (tabName) => {
  switch (tabName) {
    case TAB_OPTIONS.ALL:
      return "";
    case TAB_OPTIONS.POPULAR:
      return "";
    case TAB_OPTIONS.UPCOMING:
      return NOT_STARTED;
    case TAB_OPTIONS.LIVE:
      return LIVE;
    case TAB_OPTIONS.FINISHED:
      return FINISHED;
    case TAB_OPTIONS.ODDS:
      return "";
  }
};

// src/getLanguageParam.ts
var getLanguageParam = (sdkLanguageParam) => sdkLanguageParam ? sdkLanguageParam : "en";

// src/getWinnerReason.ts
var getWinnerReason = (id, winner) => {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!winner) {
    return "";
  }
  if (id === ((_a = winner == null ? void 0 : winner.match) == null ? void 0 : _a.id) && ((_c = (_b = winner == null ? void 0 : winner.match) == null ? void 0 : _b.reason) == null ? void 0 : _c.name)) {
    return (_d = winner == null ? void 0 : winner.match) == null ? void 0 : _d.reason.name;
  }
  if (id === ((_e = winner == null ? void 0 : winner.aggregate) == null ? void 0 : _e.id) && ((_f = winner == null ? void 0 : winner.aggregate.reason) == null ? void 0 : _f.name)) {
    return (_g = winner == null ? void 0 : winner.aggregate.reason) == null ? void 0 : _g.name;
  }
  return "";
};
var getMultiSportWinnerReason = (results) => {
  const hasAggregates = results.find((result) => result.type.code === "aggregate");
  const hasPenalties = results.find((result) => result.type.code === "penalty_shootout");
  if (hasAggregates && hasAggregates.winner === WinnerType.YES)
    return AGG_BADGE;
  if (hasPenalties && hasPenalties.winner === WinnerType.YES)
    return PEN_BADGE;
  return "";
};

// src/getStatusDate.ts
var getStatusDate = (start_time, status, sdkOptions) => {
  if (status === LIVE) {
    return getDate(start_time, sdkOptions)[1];
  }
  return start_time ? getDate(start_time, sdkOptions)[1] : "";
};

// src/getNameByStatus.ts
var getNameByStatus = ({ name, three_letter_code, short_name, status }) => {
  switch (status) {
    case THREE_LETTER_CODE:
      return three_letter_code ? three_letter_code : name;
    case SHORT_NAME:
      return short_name ? short_name : name;
    default:
      return name;
  }
};

// src/statuses.ts
var isFinishedOrInterrupted = (statusType) => {
  return statusType === FINISHED || statusType === INTERRUPTED || statusType === POSTPONED || statusType === CANCELLED || statusType === ABANDONED || statusType === UNKNOWN;
};
var isInterceptedMatch = (statusType) => {
  return statusType === INTERRUPTED || statusType === POSTPONED || statusType === CANCELLED || statusType === ABANDONED || statusType === UNKNOWN;
};
var isDelayed = (statusType) => {
  return statusType === POSTPONED || statusType === CANCELLED || statusType === UNKNOWN;
};
var getLivescoreStatusForDisplay = (status) => {
  if (status.type === NOT_STARTED)
    return "";
  return (status == null ? void 0 : status.short_name) || (status == null ? void 0 : status.name) || (status == null ? void 0 : status.three_letter_code);
};

// src/sortByType.ts
var sortLabelsByType = (data, element, isLive) => {
  if (!data) {
    return [];
  }
  const sortedData = [...data];
  const index = data.indexOf(element);
  if (index > -1) {
    sortedData.splice(index, 1);
    sortedData.unshift(element);
  }
  return isLive ? sortedData : data;
};

// src/getCompetitionLogo.ts
var getCompetitionLogo = (competition) => {
  var _a, _b;
  if (competition == null ? void 0 : competition.display_asset.url) {
    return competition == null ? void 0 : competition.display_asset.url;
  }
  if ((_a = competition.country) == null ? void 0 : _a.display_asset.url) {
    return (_b = competition.country) == null ? void 0 : _b.display_asset.url;
  }
  return assetsPlaceholder.tournament;
};

// ../types/multisport.ts
var ResultTypes;
(function(ResultTypes2) {
  ResultTypes2["QUARTER1"] = "quarter1";
  ResultTypes2["QUARTER2"] = "quarter2";
  ResultTypes2["QUARTER3"] = "quarter3";
  ResultTypes2["QUARTER4"] = "quarter4";
  ResultTypes2["PERIOD1"] = "period1";
  ResultTypes2["PERIOD2"] = "period2";
  ResultTypes2["PERIOD3"] = "period3";
  ResultTypes2["PERIOD4"] = "period4";
  ResultTypes2["EXTRA_TIME"] = "extratime";
  ResultTypes2["FINAL_RESULT"] = "display";
  ResultTypes2["TOTAL_RESULT"] = "total";
  ResultTypes2["PENALTY_SHOOTOUT"] = "penaltyshootout";
})(ResultTypes || (ResultTypes = {}));

// src/getEventStatus.ts
var getEventStatus = ({ type, status, participants, minute, statusType }) => {
  var _a, _b, _c, _d;
  const isShortType = Boolean(statusType === SHORT_NAME || SHORT_NAME_ALT);
  const hasPenalties = Boolean(((_b = (_a = participants[0].results) == null ? void 0 : _a.find(({ type: type2 }) => type2.code === ResultTypes.PENALTY_SHOOTOUT)) == null ? void 0 : _b.value) && ((_d = (_c = participants[1].results) == null ? void 0 : _c.find(({ type: type2 }) => type2.code === ResultTypes.PENALTY_SHOOTOUT)) == null ? void 0 : _d.value));
  switch (type) {
    case NOT_STARTED:
      return "";
    case LIVE:
      if (hasPenalties) {
        return "PEN'";
      }
      return `${minute}'`;
    default:
      return isShortType ? status.short_name ? status.short_name : status.name : status.name;
  }
};

// src/getResultLabel.ts
var getResultLabel = (code, dataLabels) => {
  switch (code) {
    case ResultTypes.QUARTER1:
      return "1";
    case ResultTypes.QUARTER2:
      return "2";
    case ResultTypes.QUARTER3:
      return "3";
    case ResultTypes.QUARTER4:
      return "4";
    case ResultTypes.PERIOD1:
      return "P1";
    case ResultTypes.PERIOD2:
      return "P2";
    case ResultTypes.PERIOD3:
      return "P3";
    case ResultTypes.EXTRA_TIME:
      return getLabelValue_default(dataLabels == null ? void 0 : dataLabels.overtime_short, "OT");
    case ResultTypes.FINAL_RESULT:
      return getLabelValue_default(dataLabels == null ? void 0 : dataLabels.score_short, "S");
    default:
      return "";
  }
};

// ../constants/windowTarget.ts
var TARGET_SELF = "_self";
var TARGET_BLANK = "_blank";

// ../constants/playoff.ts
var resultTypeForDisplaying = "TOTALSCORE";

// src/knockout.tsx
var isWinner = (participant) => {
  var _a;
  return ((_a = participant == null ? void 0 : participant.winner) == null ? void 0 : _a.value) === "YES";
};
var isWinnerInEvent = (participantResults, currentParticipant) => {
  const currentValue = Number(currentParticipant.value);
  if (isNaN(currentValue))
    return false;
  const maxValue = Math.max(...participantResults.map((p) => Number(p.value)).filter((v) => !isNaN(v)));
  if (currentValue !== maxValue)
    return false;
  return true;
};
var extractParticipantDisplayScore = (participantId, groupResults) => {
  var _a, _b;
  const totalScoreObject = (_a = groupResults.filter((result) => result.result_type.type === resultTypeForDisplaying)) == null ? void 0 : _a[0];
  if (!totalScoreObject)
    return "";
  return ((_b = totalScoreObject.participants.find((participant) => participant.id === participantId)) == null ? void 0 : _b.value) || "-";
};
var mapFirstEventAsLink = (group) => {
  var _a, _b;
  if (((_a = group == null ? void 0 : group.events) == null ? void 0 : _a.length) > 1)
    return null;
  const firstEvent = (_b = group == null ? void 0 : group.events) == null ? void 0 : _b[0];
  return {
    url: (firstEvent == null ? void 0 : firstEvent.url) || "#",
    target: (firstEvent == null ? void 0 : firstEvent.url) ? (firstEvent == null ? void 0 : firstEvent.url_target) || TARGET_BLANK : TARGET_SELF
  };
};
var isDoubles = (type) => {
  switch (type) {
    case "MALE_DOUBLES":
    case "FEMALE_DOUBLES":
    case "MIXED_DOUBLES":
      return true;
    default:
      return false;
  }
};

// src/participant.tsx
var getParticipantName = (team, dataTeamNameType) => {
  if (dataTeamNameType === THREE_LETTER_CODE && team.three_letter_code) {
    return team.three_letter_code;
  }
  if (dataTeamNameType === SHORT_NAME && team.short_name) {
    return team.short_name;
  }
  if (team.name) {
    return team.name;
  }
  return NOT_AVAILABLE;
};

// src/mapToOptions.ts
function mapToOptions(items) {
  if (!items)
    return [];
  return items.map((item) => ({
    label: item.name,
    value: item.id,
    type: item.type
  }));
}

// ../types/standings.ts
var ALL_TABLE_TYPES;
(function(ALL_TABLE_TYPES2) {
  ALL_TABLE_TYPES2["PLAYED"] = "PLAYED";
  ALL_TABLE_TYPES2["WINS"] = "WINS";
  ALL_TABLE_TYPES2["WINS_OVER_TIME"] = "WINS_OVER_TIME";
  ALL_TABLE_TYPES2["LOSSES"] = "LOSSES";
  ALL_TABLE_TYPES2["LOSSES_OVER_TIME"] = "LOSSES_OVER_TIME";
  ALL_TABLE_TYPES2["WINS_PENALTY"] = "WINS_PENALTY";
  ALL_TABLE_TYPES2["LOSSES_PENALTY"] = "LOSSES_PENALTY";
  ALL_TABLE_TYPES2["GOAL_DIFFERENCES"] = "GOAL_DIFFERENCES";
  ALL_TABLE_TYPES2["POINTS"] = "POINTS";
  ALL_TABLE_TYPES2["TOTAL_POINTS"] = "TOTAL_POINTS";
  ALL_TABLE_TYPES2["PERCENTAGE"] = "PERCENTAGE";
  ALL_TABLE_TYPES2["GOALS_FOR"] = "GOALS_FOR";
  ALL_TABLE_TYPES2["GOALS_AGAINST"] = "GOALS_AGAINST";
  ALL_TABLE_TYPES2["FORM"] = "FORM";
})(ALL_TABLE_TYPES || (ALL_TABLE_TYPES = {}));

// ../constants/standings.ts
var BASKETBALL_TABLE_TYPES = ["PLAYED", "WINS", "LOSSES", "TOTAL_POINTS", "PERCENTAGE"];
var ICE_HOCKEY_TABLE_TYPES = [
  "PLAYED",
  "WINS",
  "WINS_OVER_TIME",
  "LOSSES",
  "LOSSES_OVER_TIME",
  "WINS_PENALTY",
  "LOSSES_PENALTY",
  "GOAL_DIFFERENCES",
  "POINTS"
];

// src/transformTableCells.ts
var translateTableLabel = (type, dataLabels, fullName) => {
  switch (type) {
    case ALL_TABLE_TYPES.PLAYED:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.matches_played : dataLabels == null ? void 0 : dataLabels.matches_played_short, fullName ? "Matches Played" : "MP");
    case ALL_TABLE_TYPES.WINS:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.matches_won : dataLabels == null ? void 0 : dataLabels.matches_won_short, fullName ? "Wins" : "W");
    case ALL_TABLE_TYPES.WINS_OVER_TIME:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.matches_won_overtime : dataLabels == null ? void 0 : dataLabels.matches_won_overtime_short, fullName ? "Wins Overtime" : "WO");
    case ALL_TABLE_TYPES.LOSSES:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.match_losses : dataLabels == null ? void 0 : dataLabels.match_losses_short, fullName ? "Losses" : "L");
    case ALL_TABLE_TYPES.LOSSES_OVER_TIME:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.matches_losses_overtime : dataLabels == null ? void 0 : dataLabels.matches_losses_overtime_short, fullName ? "Losses Overtime" : "LO");
    case ALL_TABLE_TYPES.WINS_PENALTY:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.win_after_penalty : dataLabels == null ? void 0 : dataLabels.win_after_penalty_short, fullName ? "Wins After Penalty" : "WAP");
    case ALL_TABLE_TYPES.LOSSES_PENALTY:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.loss_after_penalty : dataLabels == null ? void 0 : dataLabels.loss_after_penalty_short, fullName ? "Losses After Penalty" : "LAP");
    case ALL_TABLE_TYPES.TOTAL_POINTS:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.points_difference : dataLabels == null ? void 0 : dataLabels.points_difference_short, fullName ? "Points Difference" : "PD");
    case ALL_TABLE_TYPES.GOAL_DIFFERENCES:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.goals_difference : dataLabels == null ? void 0 : dataLabels.goals_difference_short, fullName ? "Goals Difference" : "GD");
    case ALL_TABLE_TYPES.POINTS:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.points : dataLabels == null ? void 0 : dataLabels.points_short, fullName ? "Points" : "PTS");
    case ALL_TABLE_TYPES.PERCENTAGE:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.percentages : dataLabels == null ? void 0 : dataLabels.percentages_short, fullName ? "Percentage" : "PCT");
    case ALL_TABLE_TYPES.FORM:
      return getLabelValue_default(fullName ? dataLabels == null ? void 0 : dataLabels.team_form : dataLabels == null ? void 0 : dataLabels.team_form_short, fullName ? "FORM" : "FORM");
  }
};
var constructTableCells = (columns, sport, dataLabels) => {
  var _a;
  const getGameDifferences = (columns2) => {
    var _a2, _b, _c, _d;
    const goalsFor = (_b = (_a2 = columns2.find(({ type }) => type.code === ALL_TABLE_TYPES.GOALS_FOR)) == null ? void 0 : _a2.value) != null ? _b : "";
    const goalsAgainst = (_d = (_c = columns2.find(({ type }) => type.code === ALL_TABLE_TYPES.GOALS_AGAINST)) == null ? void 0 : _c.value) != null ? _d : "";
    const difference = Number(goalsFor) - Number(goalsAgainst);
    return `${goalsFor}:${goalsAgainst} (${difference > 0 ? "+" : ""}${difference})`;
  };
  const labels = columns.map(({ type }) => {
    var _a2;
    return { type: type.code, value: (_a2 = translateTableLabel(type.code, dataLabels)) != null ? _a2 : "" };
  });
  const values = columns.map(({ type, value }) => ({ type: type.code, value }));
  if (sport === SportTypes.ICE_HOCKEY) {
    const labelsWithGoalsDifference = [
      ...labels,
      { type: ALL_TABLE_TYPES.GOAL_DIFFERENCES, value: (_a = translateTableLabel(ALL_TABLE_TYPES.GOAL_DIFFERENCES, dataLabels)) != null ? _a : "" }
    ];
    const valuesWithGoalsDifference = [...values, { type: ALL_TABLE_TYPES.GOAL_DIFFERENCES, value: getGameDifferences(columns) }];
    return {
      labels: labelsWithGoalsDifference.filter(({ type }) => ICE_HOCKEY_TABLE_TYPES.includes(type)).sort((a3, b2) => ICE_HOCKEY_TABLE_TYPES.indexOf(a3.type) - ICE_HOCKEY_TABLE_TYPES.indexOf(b2.type)),
      values: valuesWithGoalsDifference.filter(({ type }) => ICE_HOCKEY_TABLE_TYPES.includes(type)).sort((a3, b2) => ICE_HOCKEY_TABLE_TYPES.indexOf(a3.type) - ICE_HOCKEY_TABLE_TYPES.indexOf(b2.type))
    };
  }
  return {
    labels: labels.filter(({ type }) => BASKETBALL_TABLE_TYPES.includes(type)).sort((a3, b2) => BASKETBALL_TABLE_TYPES.indexOf(a3.type) - BASKETBALL_TABLE_TYPES.indexOf(b2.type)),
    values: values.filter(({ type }) => BASKETBALL_TABLE_TYPES.includes(type)).sort((a3, b2) => BASKETBALL_TABLE_TYPES.indexOf(a3.type) - BASKETBALL_TABLE_TYPES.indexOf(b2.type))
  };
};
var trimGoalDifferenceValue = (type, value, isMobile) => {
  var _a;
  if (type === ALL_TABLE_TYPES.GOAL_DIFFERENCES && isMobile) {
    const parts = value.trim().split(" ");
    const lastPart = (_a = parts[parts.length - 1]) == null ? void 0 : _a.replace(/[()]/g, "");
    return lastPart ? lastPart : value;
  }
  return value;
};

// src/formatGameValues.ts
var formatGameStatus = (status, minutes) => {
  if ((status == null ? void 0 : status.type) === NOT_STARTED) {
    return "";
  }
  if ((status == null ? void 0 : status.type) === LIVE) {
    if (!minutes) {
      return status.short_name;
    }
    return (minutes == null ? void 0 : minutes.injury_time) ? `${minutes.regular_time}+${minutes.injury_time}` : `${minutes == null ? void 0 : minutes.regular_time}'`;
  }
  return status == null ? void 0 : status.short_name;
};
var formatGameScore = (homeScore, awayScore, status) => {
  var _a, _b;
  let score = "";
  let homeScoreResult = "";
  let awayScoreResult = "";
  switch (status == null ? void 0 : status.type) {
    case FINISHED:
    case INTERRUPTED:
    case LIVE:
      score = `${homeScore} - ${awayScore}`;
      homeScoreResult = (_a = homeScore == null ? void 0 : homeScore.toString()) != null ? _a : "-";
      awayScoreResult = (_b = awayScore == null ? void 0 : awayScore.toString()) != null ? _b : "-";
      break;
    case POSTPONED:
    case NOT_STARTED:
    case CANCELLED:
    case UNKNOWN:
      score = "-";
      homeScoreResult = "-";
      awayScoreResult = "-";
      break;
    default:
      score = "-";
      homeScoreResult = "-";
      awayScoreResult = "-";
  }
  return { score, homeScoreResult, awayScoreResult };
};

// ../constants/actitivityStatus.ts
var ACTIVE = "ACTIVE";

// src/transformSeasons.ts
var transformSeasonNames = (seasons, dataLabels, withCombinedSeasons) => {
  if (!seasons || !Array.isArray(seasons))
    return [];
  const initialOutput = withCombinedSeasons ? [{ id: "", name: getLabelValue_default(dataLabels == null ? void 0 : dataLabels.current_season, "Current Season") }] : [];
  return seasons.reduce((output, season) => {
    var _a, _b;
    const competitionName = ((_a = season.competition) == null ? void 0 : _a.name) || ((_b = season.tournament) == null ? void 0 : _b.name) || "";
    if (season.status === ACTIVE && withCombinedSeasons && output.length > 0) {
      return [
        __spreadProps(__spreadValues({}, output[0]), {
          id: `${output[0].id.length > 0 ? output[0].id + "," : ""}${season.id}`
        }),
        ...output.slice(1)
      ];
    } else {
      return [...output, { id: season.id, name: season.name + " " + competitionName }];
    }
  }, initialOutput);
};
var transformToSeasonOptions = (seasons) => {
  if (!seasons || !Array.isArray(seasons))
    return [];
  return seasons.map(({ name, id }) => ({
    label: name,
    value: id
  }));
};
export {
  FansUnitedTokenProvider,
  LinkCreationService,
  abbreviateName_default as abbreviateName,
  areWidgetsRendered,
  breakText_default as breakText,
  buildWidgetProps,
  camelToSnakeCase,
  checkIsPlaceholderOrSetBorder,
  classNames,
  constructAdditionalEventStatusInfo,
  constructEventStatusInfo,
  constructTableCells,
  convertTZ,
  defaultHandleBettingMarketValueClick,
  defaultHandleBettingMarketValueClickNew,
  defaultHandleCompetitionClick,
  defaultHandleEventClick,
  defaultHandleOddProviderClick,
  defaultHandleParticipantClick,
  defaultHandlePlayerClick,
  defaultHandleTeamClick,
  defaultHandleTournamentClick,
  defaultHandleUserInteractionClick,
  extractOnlyDateSDKOptions,
  extractParticipantDisplayScore,
  formatGameScore,
  formatGameStatus,
  formatGameTime,
  formatRuleType_default as formatRuleType,
  getCompetitionLogo,
  getDate,
  getDateFnsLocale,
  getDefaultShortLabel_default as getDefaultShortValue,
  getEventStatus,
  getGameResult,
  getGameStatus,
  getIconAsBgImage,
  getIconBasedOnEventType,
  getLabelValue_default as getLabelValue,
  getLanguageParam,
  getLivescoreStatusForDisplay,
  getMatchDate,
  getMatchDateExtended,
  getMatchMinutes,
  getMatchStatus,
  getMultiSportWinnerReason,
  getNameByStatus,
  getOddsParams,
  getOddsSettings,
  getParticipantName,
  getPropValue_default as getPropValue,
  getResultLabel,
  getScoreByCoverageType,
  getScoreHeader,
  getStatusDate,
  getTabValue,
  getTeamColor,
  getTeamName,
  getTeamWinnerForm,
  getTiebreakScore,
  getUniqueListBy_default as getUniqueListBy,
  getWidgetAttributes_default as getWidgetAttributes,
  getWinnerReason,
  hex2rgba,
  invertColor,
  isDelayed,
  isDoubles,
  isFinishedOrInterrupted,
  isInStorybook,
  isInterceptedMatch,
  isKnouckoutGameDoubles,
  isMobileDevice,
  isMobileUserAgent,
  isNationalParticipant,
  isOfTypeMarket,
  isOfTypeMarketValueType,
  isSmartphone,
  isStringLowerCase,
  isWinner,
  isWinnerInEvent,
  mapFirstEventAsLink,
  mapToOptions,
  removeEmptyValuesFromArray,
  removeUndefinedPropertiesFromObject,
  rgba2hex,
  scrollToHorizontally_default as scrollToHorizontally,
  setNationalParticipantBorder,
  setParticipantBorder,
  snakeToCamelCase,
  sortLabelsByType,
  toCamelCase,
  toSentenceCase,
  toSnakeCase,
  transformSeasonNames,
  transformToSeasonOptions,
  translateTableLabel,
  trimGoalDifferenceValue,
  validateRequiredWidgetAttributes_default as validateRequiredWidgetAttributes
};
